const messages = {
  en: {
    translations: {
      signup: {
        title: "Sign Up",
        toasts: {
          success: "User successfully created! Please log in!",
          disabled: "User registration is currently disabled. Please try again later.",
          fail: "Error creating user. Please check the provided data.",
          codeSent: "Verification code sent to your email!",
          codeResent: "New code sent!"
        },
        form: {
          name: "Name",
          email: "Email",
          password: "Password",
          company: "Organization Name",
          phone: "WhatsApp (Area Code + Number)",
        },
        buttons: {
          submit: "Register",
          login: "Already have an account? Log in!",
        },
        plan: {
          title: "Choose your plan",
          subtitle: "Select the ideal plan for your company",
          badge: "Ideal for your company",
          period: "month",
          meta: "Up to {{users}} users · Up to {{connections}} connections"
        },
        formStep: {
          title: "Create your account",
          subtitle: "Fill in your company details"
        },
        verify: {
          title: "Email verification",
          subtitle: "Enter the 6-digit code sent to",
          confirm: "Verify and Create Account",
          sending: "Sending...",
          resend: "Resend code",
          resendIn: "Resend in"
        },
        actions: {
          continue: "Continue",
          back: "Back",
          hasAccount: "Already have an account?",
          enter: "Sign in"
        },
        document: {
          label: "CPF / CNPJ / Document (optional)",
          cpfValid: "CPF valid!",
          cnpjValid: "CNPJ valid! Company name filled automatically.",
          invalid: "Invalid document.",
          error: "Error validating document."
        },
        validation: {
          required: "Required field",
          nameMin: "Name must be at least 2 characters",
          nameMax: "Name must be at most 50 characters",
          companyMin: "Company must be at least 2 characters",
          companyMax: "Company must be at most 50 characters",
          passwordMin: "Password must be at least 5 characters",
          passwordMax: "Password must be at most 50 characters",
          invalidEmail: "Invalid email",
          codeLength: "Enter the full 6-digit code."
        },
        features: {
          whatsapp: "WhatsApp",
          facebook: "Facebook",
          instagram: "Instagram",
          campaigns: "Campaigns",
          schedules: "Schedules",
          internalChat: "Internal Chat",
          externalApi: "External API",
          integrations: "Integrations",
          openAi: "OpenAI",
          kanban: "Kanban"
        }
      },
      login: {
        title: "Login",
        welcome: "Welcome back",
        loginInstruction: "Enter your credentials to access your account",
        forgotPassword: "Forgot your password?",
        form: {
          email: "Email",
          password: "Password",
          button: "Access",
        },
        buttons: {
          submit: "Enter",
          register: "Don't have an account? Register!",
        },
        footer: "All rights reserved.",
      },
        quickMessages: "Quick Replies",
        phonecopied: "Phone copied to clipboard!",
        noPhone: "No phone available to copy",
        copyError: "Error copying phone",
    embeddedSignup: {
      title: "WhatsApp Embedded Signup",
      subtitle: "Register your number directly from the CRM",
      steps: { configure: "Configure", processing: "Processing", result: "Result" },
      description: "Click the button below to start registering your WhatsApp Business number directly through Meta.",
      connectionName: "Connection name",
      connectionNamePlaceholder: "E.g.: Main WhatsApp",
      infoTitle: "What happens:",
      infoItems: { popup: "A Meta popup will open", login: "You will log in with your Facebook Business account", select: "You will select or create a WhatsApp Business account", register: "The number will be automatically registered in the CRM" },
      buttons: { loadingSdk: "Loading SDK...", processing: "Processing...", start: "Start Registration via Meta", close: "Close", cancel: "Cancel" },
      success: { title: "Connection created successfully!", name: "Name", number: "Number", numberPending: "Will be displayed soon", wabaId: "WABA ID", status: "Status" },
      errors: { title: "Registration error", noAppId: "Meta App ID not configured!", noConfigId: "Meta Configuration ID not configured!", noName: "Please enter a connection name!", sdkNotLoaded: "Meta SDK did not load correctly. Reload the page and try again.", sdkInitFailed: "Failed to initialize Meta SDK.", sdkLoadFailed: "Failed to load Meta SDK. Disable blockers and allow popups.", sdkNotAvailable: "Facebook SDK not available in browser.", appIdNotConfigured: "Meta App ID not configured! Go to Settings > Meta Integrations.", configIdNotConfigured: "Meta Configuration ID not configured! Go to Settings > Meta Integrations.", timeout: "Timed out. The Meta popup may have been blocked by the browser. Allow popups and try again.", noAuthCode: "Authorization code not received. Check app permissions.", cancelled: "Process cancelled by user.", signupError: "Error during signup process.", processingError: "Error processing registration. Try again.", popupError: "Error opening Meta popup. Check if popups are allowed.", loginCancelled: "Login cancelled or not authorized.", metaStatus: "Meta returned status:" },
      processing: { title: "Processing registration...", description: "We are exchanging credentials with Meta and setting up your connection." },
      menuItem: "WhatsApp Embedded Signup",
    },
      },
      forgotPassword: {
        title: "Recover access",
        subtitleLine1: "Enter the email linked to your account.",
        subtitleLine2: "We will send you a verification code.",
        email: "Email",
        placeholder: "your.email@example.com",
        sending: "Sending...",
        send: "Send Code",
        back: "Back to login",
        toasts: {
          requiredEmail: "Enter your email",
          success: "If the email is registered, a code will be sent.",
          error: "Error sending code. Check whether SMTP is configured in settings."
        }
      },
      validateCode: {
        title: "Check your email",
        subtitle: "We sent a 6-digit code to",
        label: "Verification Code",
        submitting: "Validating...",
        submit: "Verify Code",
        resendPrompt: "Didn't receive it? Resend code",
        back: "Back",
        toasts: {
          incomplete: "Enter the full 6-digit code",
          success: "Code validated successfully!",
          error: "Invalid or expired code. Try again.",
          resent: "New code sent!",
          resentError: "Error resending code."
        }
      },
      resetPassword: {
        title: "Create a new password",
        subtitleLine1: "Choose a secure password to",
        subtitleLine2: "protect your account.",
        newPassword: "New Password",
        confirmPassword: "Confirm Password",
        passwordPlaceholder: "Enter your new password",
        confirmPlaceholder: "Repeat your new password",
        minHint: "Minimum 6 characters",
        submitting: "Saving...",
        submit: "Reset Password",
        successTitle: "Password reset successfully!",
        successSubtitle: "Redirecting to login...",
        toasts: {
          minLength: "Password must be at least 6 characters",
          mismatch: "Passwords do not match",
          success: "Password reset successfully!",
          error: "Error resetting password. Invalid or expired token."
        }
      },
      companies: {
        title: "Register Company",
        form: {
          name: "Company Name",
          plan: "Plan",
          token: "Token",
          submit: "Register",
          success: "Company successfully created!",
        },
        confirmationModal: {
          deleteTitle: "Delete Company",
          deleteMessage: "Are you sure you want to delete this company? All related data will be lost. This action cannot be undone.",
        },
      },

      auth: {
        toasts: {
          success: "Login successful!",
        },
        dueDate: {
          expiration: "Your subscription expires in",
          days: "days!",
          day: "day!",
          expirationToday: "Your subscription expires today!",
          warning: "Your subscription expires in {{days}} {{unit}}",
          expired: "Your subscription expired on {{date}}. Contact Support for more information!",
        },
        token: "Token",
      },
      dashboard: {
        subtitle: "Overview of service indicators",
        fetchError: "Error loading dashboard data",
        hideFilters: "Hide Filters",
        filters: "Filters",
        filter: "FILTER ",
        npsTitle: "Satisfaction Survey (NPS)",
        calls: "Attendances",
        analytics: {
          title: "Analytics",
          ticketVolume: "Ticket Volume",
          lastDays: "Last {{days}} days",
          noData: "No data",
          ticketStatus: "Ticket Status",
          distributionByStatus: "Distribution by status",
          noTickets: "No tickets",
          conversationMetrics: "Conversation Metrics",
          activeContacts: "Active Contacts",
          ticketsPerContact: "Tickets/Contact",
          days: "days",
          ratingRate: "Rating Rate",
          hourlyActivity: "Hourly Activity",
          less: "Less",
          more: "More",
          topContacts: "Top Contacts",
        },
        tabs: {
          indicators: "Indicators",
          assessments: "NPS",
          attendants: "Agents",
        },
        charts: {
          perDay: {
            title: "Attendances today: ",
          },
        },
        cards: {
          inAttendance: "In Attendance",
          waiting: "Waiting",
          activeAttendants: "Active Agents",
          finalized: "Finalized",
          newContacts: "New Contacts",
          totalReceivedMessages: "Received Messages",
          totalSentMessages: "Sent Messages",
          averageServiceTime: "Average Service Time",
          averageWaitingTime: "Average Waiting Time",
          status: "Status (Current)",
          activeTickets: "Active Tickets",
          passiveTickets: "Passive Tickets",
          groups: "Groups",
        },
        users: {
          name: "Name",
          numberAppointments: "Number of Attendances",
          statusNow: "Current Status",
          totalCallsUser: "Total Attendances per User",
          totalAttendances: "Total Attendances",
        },
        date: {
          initialDate: "Start Date",
          finalDate: "End Date",
        },
        licence: {
          available: "Available until",
        },
        assessments: {
          totalCalls: "Total Attendances",
          callsWaitRating: "Attendances Waiting for Rating",
          callsWithoutRating: "Attendances Without Rating",
          ratedCalls: "Rated Attendances",
          evaluationIndex: "Evaluation Index",
          score: "Score",
          prosecutors: "Promoters",
          neutral: "Neutral",
          detractors: "Detractors",
        },
      },
      reports: {
        title: "Attendance Reports",
        subtitle: "View and export attendance data",
        startDate: "Start Date",
        endDate: "End Date",
        searchPlaceholder: "Search...",
        saleValue: "Sale Value",
        noSaleReason: "No Sale Reason",
        closedWithSale: "Closed with Sale",
        yes: "Yes",
        no: "No",
        ticketLogs: "Ticket Logs",
        accessTicket: "Access Ticket",
        operator: "Operator",
        period: "Period",
        until: "Until",
        date: "Date",
        reportTitle: "Reports",
        calls: "Attendances",
        search: "Surveys",
        durationCalls: "Attendance Duration",
        grupoSessions: "Group Attendances",
        groupTicketsReports: {
          timezone: "America/Sao_Paulo",
          msgToast: "Generating compressed report, please wait.",
          errorToast: "Error generating report",
          back: "Back",
          groupServiceReport: "Group Attendance Report",
          loading: "Loading...",
          contact: "Contact",
          dateOpen: "Opening Date",
          dateLastUpdated: "Last Update Date",
          agent: "Agent",
          agentClosed: "Agent who closed",
          waitingAssistance: "Waiting for Service",
          process: "In Service",
        },
        researchReports: {
          response: "Response",
          active: "(Active)",
          inactive: "(Inactive)",
          quantity: "Quantity",
          percentage: "Percentage",
          title: "Research Reports",
          activeSearch: "Active Survey",
          inactiveSearch: "Inactive Survey",
        },
        ticketDurationDetail: {
          msgToast: "Generating compressed report, please wait.",
          title: "Attendance Duration Report",
          startService: "Start of Attendance",
          lastUpdated: "Last Updated",
          lastAgent: "Last Agent",
          durationFinished: "Duration After Closing",
        },
        ticketDuration: {
          title: "Attendance Duration Report",
          contact: "Contact",
          open: "Open",
          pending: "Pending",
          finished: "Finished",
          durationFinished: "Duration of Finished Attendances",
          durationAfterFinished: "Duration After Closing",
          actions: "Actions",
        },
        ticketReports: {
          msgToast: "Generating compressed report, please wait.",
          title: "Attendance Report",
        },
        exportExcel: {
          title: "Attendance Reports",
          startDate: "Start date",
          endDate: "End date",
          notInformed: "Not informed",
          columns: {
            id: "ID",
            connection: "Connection",
            contact: "Contact",
            user: "User",
            queue: "Queue",
            status: "Status",
            lastMessage: "Last Message",
            openDate: "Open Date",
            openTime: "Open Time",
            closeDate: "Close Date",
            closeTime: "Close Time",
            supportTime: "Support Time",
            nps: "NPS",
          },
        },
        pdf: {
          title: "List of Completed Attendances",
          exportTitle: "List of Completed Group Attendances",
        },
        table: {
          id: "Ticket",
          user: "User",
          dateOpen: "Opening Date",
          dateClose: "Closing Date",
          NPS: "NPS",
          status: "Status",
          whatsapp: "Connection",
          queue: "Queue",
          actions: "Actions",
          lastMessage: "Last Message",
          contact: "Customer",
          supportTime: "Attendance Time",
        },
        buttons: {
          filter: "Apply Filter",
          onlyRated: "Only Rated",
        },
      },
      todo: {
        newTask: "New Task",
        add: "Add",
        task: "Tasks",
      },
      contactImportWpModal: {
        title: "Export Contacts to Excel",
        buttons: {
          downloadModel: "Download Excel template for import",
          closed: "Close",
          import: "Select Excel file to import Contacts",
        },
      },
      connections: {
        title: "Connections",
        waitConnection: "Please wait... Your connections will be restarted!",
        newConnection: "New Connection",
        restartConnections: "Restart Connections",
        callSupport: "Call Support",
        connectYourServiceChannelsToReceiveMessagesAndStartConversationsWithYourCustomers:
          " Connect your service channels to receive messages and start conversations with your customers.",
        client: "Client",
        connectedConnections: "Connected connections",
        disconnectedConnections: "Disconnected connections",
        totalConnections: "Total connections",
        total: "Total",
        connections: " Connections:",
        integrity: "Integrity",
        stable: "Stable",
        unstable: "Unstable",
        statusConnected: "Connected",
        statusDisconnected: "Disconnected",
        statusOpening: "Connecting",
        statusQrcode: "QR Code",
        statusPairing: "Pairing",
        active: "Active",
        inactive: "Inactive",
        updatedAt: "Updated",
        toasts: {
          deleted: "Connection successfully deleted!",
          closedimported:
            "Closing imported tickets, please wait a few moments.",
        },
        confirmationModal: {
          closedImportedTitle: "Close imported tickets",
          closedImportedMessage:
            "If you confirm, all imported tickets will be closed.",
          deleteTitle: "Delete",
          deleteMessage: "Are you sure? This action cannot be undone.",
          disconnectTitle: "Disconnect",
          disconnectMessage:
            "Are you sure? You will need to scan the QR Code again.",
        },
        buttons: {
          add: "Add Connection",
          disconnect: "Disconnect",
          tryAgain: "Try Again",
          qrcode: "QR CODE",
          newQr: "New QR CODE",
          closedImported: "Close all imported tickets",
          preparing: "Preparing messages for import",
          importing: "Importing WhatsApp Messages",
          processed: "Processed",
          in: "of",
          connecting: "Connecting",
        },
        typography: {
          processed: "Processed",
          in: "of",
          date: "Message Date",
        },
        toolTips: {
          disconnected: {
            title: "Failed to start WhatsApp session",
            content:
              "Make sure your phone is connected to the internet and try again, or request a new QR Code.",
          },
          qrcode: {
            title: "Waiting for QR Code scan",
            content:
              "Click the 'QR CODE' button and scan the QR Code with your phone to start the session.",
          },
          connected: {
            title: "Connection established!",
          },
          timeout: {
            title: "Connection with the phone was lost",
            content:
              "Make sure your phone is connected to the internet and WhatsApp is open, or click 'Disconnect' to get a new QR Code.",
          },
        },
        table: {
          name: "Name",
          status: "Status",
          lastUpdate: "Last Update",
          default: "Default",
          actions: "Actions",
          session: "Session",
          number: "WhatsApp Number",
          color: "Color",
          receiveComments: "Receive Comments",
        },
        receiveComments: {
          label: "Receive Comments",
          enabled: "Comment receiving enabled",
          disabled: "Comment receiving disabled",
          tooltip: {
            enabled: "Comments are being received. Click to disable.",
            disabled: "Comments are not being received. Click to enable.",
          },
        transfer: {
          title: "Ticket Transfer",
          description: "Select the source and target connections. All active tickets will be moved.",
          source: "Source",
          target: "Target",
          cancel: "Cancel",
          transfer: "Transfer",
          transferTickets: "Transfer Tickets",
          transferring: "Transferring Tickets",
          of: "of",
          waitMessage: "Please wait while tickets are being transferred...",
          selectConnections: "Select source and target connections",
          differentConnections: "Source and target connections must be different",
          success: "Tickets transferred successfully! {{count}} tickets transferred.",
        },
        preDelete: {
          title: "Before deleting",
          message: "Have you transferred the tickets from this connection to another? If not, we recommend transferring before deleting.",
          notYet: "Not yet",
          yesTransferred: "Yes, already transferred",
        },
        importMessages: {
          title: "Import Messages",
          button: "Import Messages",
          connection: "Connection",
          selectConnection: "Select a Z-API connection",
          startDate: "Start Date",
          endDate: "End Date",
          messageType: "Message Type",
          all: "All",
          individual: "Individual",
          group: "Group",
          ticketStatus: "Ticket Status",
          open: "Open",
          closed: "Closed",
          import: "Import",
          cancel: "Cancel",
          importing: "Importing messages...",
          importingDescription: "Please wait while messages are imported. This may take a few minutes.",
          success: "Import complete! {{messages}} messages, {{tickets}} tickets, {{contacts}} contacts imported.",
          noZApiConnections: "No Z-API connections found.",
          noConnections: "No connected WhatsApp connections found.",
          errorMissingFields: "Please fill in all required fields.",
        },
        nativeImport: {
          importing: "Importing WhatsApp messages...",
          finishing: "Finishing import...",
          processed: "Processed",
          messages: "messages",
          currentDate: "Current date",
          errors: "errors",
          cancelled: "Import cancelled",
          cancel: "Cancel",
        },
        importProgress: {
          done: "Import complete!",
          cancelled: "Import cancelled",
          importing: "Importing messages...",
          starting: "Connecting...",
          scanning: "Scanning chats...",
          processingChat: "Processing chat {{current}} of {{total}}",
          allProcessed: "All chats have been processed",
          cancelledAt: "Stopped at {{current}} of {{total}} chats",
          initializing: "Starting...",
          progress: "Progress",
          chats: "chats",
          messagesLabel: "Messages",
          tickets: "Tickets",
          contacts: "Contacts",
          errorsLabel: "Errors",
          cancelImport: "Cancel Import",
          close: "Close",
        },
        officialLabel: "Official",
        badges: {
          pairingCode: "Connected via Pairing Code",
          qrCode: "Connected via QR Code",
        },
      },
      },
      showTicketOpenModal: {
        title: {
          header: "Existing Attendance",
        },
        form: {
          message: "This contact is already being attended to:",
          user: "Agent",
          queue: "Queue",
          messageWait:
            "This contact is already waiting for service. Check the Waiting tab!",
        },
      },
      showTicketLogModal: {
        title: {
          header: "Logs",
        },
        options: {
          create: "Ticket created.",
          chatBot: "ChatBot started.",
          queue: " - Queue assigned.",
          open: " started the service.",
          access: "accessed the ticket.",
          transfered: "transferred the ticket.",
          receivedTransfer: "received the transferred ticket.",
          pending: "returned to the queue.",
          closed: "closed the ticket.",
          reopen: "reopened the ticket.",
          redirect: "- redirected",
          clientClosed: "Client closed the ticket.",
        },
      },
      whatsappModal: {
        title: {
          add: "Add Connection",
          edit: "Edit Connection",
        },
        tabs: {
          general: "General",
          messages: "Messages",
          assessments: "NPS",
          integrations: "Integrations",
          schedules: "Business Hours",
        },
        form: {
          importOldMessagesEnable: "Import messages from device",
          importOldMessages: "Start date of import",
          importRecentMessages: "End date of import",
          importOldMessagesGroups: "Import group messages",
          closedTicketsPostImported: "Close tickets after import",
          name: "Name",
          queueRedirection: "Queue Redirection",
          queueRedirectionDesc:
            "Select a queue for contacts without an assigned queue",
          default: "Default",
          group: "Allow groups",
          timeSendQueue: "Time in minutes to redirect to queue",
          importAlert:
            "WARNING: Saving will terminate your connection. You will need to scan the QR Code again to import messages.",
          groupAsTicket: "Treat groups as ticket",
          timeCreateNewTicket: "Create a new ticket after X minutes",
          maxUseBotQueues: "Send bot X times",
          maxUseInactiveTime: "Send inactivity flow X times",
          timeUseBotQueues: "Send bot in X minutes",
          timeToReturnQueue: "Time to return to queue in minutes",
          timeAwaitActiveFlow: "Time to wait for active flow",
          expiresTicket: "Close open chats after X minutes",
          expiresTicketNPS: "Close chats awaiting evaluation after X minutes",
          maxUseBotQueuesNPS: "Max times evaluation is sent",
          closeLastMessageOptions1: "From agent/client",
          closeLastMessageOptions2: "From agent only",
          outOfHoursMessage: "Out-of-hours message",
          greetingMessage: "Greeting message",
          complationMessage: "Completion message",
          lgpdLinkPrivacy: "Privacy policy link",
          lgpdMessage: "LGPD greeting message",
          lgpdDeletedMessages: "Obfuscate messages deleted by contact",
          lgpdSendMessage: "Always request contact confirmation",
          ratingMessage: "Evaluation message - Scale must be from 0 to 10",
          token: "Token for external integration",
          sendIdQueue: "Queue",
          inactiveMessage: "Inactivity warning message",
          timeInactiveMessage: "Time in minutes to send inactivity warning",
          flowInactiveTime: "Time in minutes to send inactivity flow",
          whenExpiresTicket: "Close chats when the last message is",
          expiresInactiveMessage: "Inactivity closure message",
          prompt: "Prompt",
          collectiveVacationEnd: "End date",
          collectiveVacationStart: "Start date",
          collectiveVacationMessage: "Collective vacation message",
          queueIdImportMessages: "Queue for message import",
          isOficial: "Official",
          phone_number_id: "Phone Number ID",
          waba_id: "WABA ID",
          send_token: "Sending token",
          business_id: "Business ID",
          phone_number: "Phone number",
          triggerIntegrationOnClose: "Trigger Integration on Ticket Close",
          enableIntegration: "Habilited Integration",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        menuItem: {
          enabled: "Enabled",
          disabled: "Disabled",
          minutes: "minutes",
        },
        success: "Connection saved successfully.",
        errorSendQueue:
          "You set a redirection time but no queue was selected. Both fields are required.",
        errorExpiresNPS: "A timeout must be set for NPS evaluation.",
        errorRatingMessage: "An evaluation message must be provided for NPS.",
      },
      qrCode: {
        message: "Scan the QR Code to start the session",
      },
      qrcodeModal: {
        title: "Connect to WhatsApp",
        subtitle: "Scan the QR Code with your phone to start the session",
        connected: "Connected successfully!",
        generating: "Generating new QR Code...",
        step1: "Open <strong>WhatsApp</strong> on your phone",
        step2Options: "Tap <strong>More options ⋮</strong> or <strong>Settings ⚙</strong> and select <strong>Linked Devices</strong>",
        step3: "Tap <strong>Link a Device</strong> and point the camera at this QR Code",
        refreshCountdown: "QR Code refreshes in {{seconds}}s",
        refreshing: "Refreshing QR Code...",
      },
      contacts: {
        title: "Contacts",
        toasts: {
          deleted: "Contact successfully deleted!",
        },
        searchPlaceholder: "Search...",
        conversationFlows: " Conversation Flows",
        addFlow: "Add Flow",
        editFlow: "Edit Flow ",
        confirmationModal: {
          deleteTitle: "Delete",
          importTitlte: "Import Contacts",
          exportContact: "Export Contacts",
          deleteMessage:
            "Are you sure you want to delete this contact? All related attendances will be lost.",
          blockContact: "Are you sure you want to block this contact?",
          unblockContact: "Are you sure you want to unblock this contact?",
          importMessage: "Do you want to import all contacts from the phone?",
          importChat: "Import Chats",
          wantImport: "Do you want to import all chats from the phone?",
        },
        buttons: {
          import: "Import Contacts",
          add: "Add Contact",
          export: "Export Contact",
        },
        loading: "Loading...",
        loadMore: "Load More",
        table: {
          name: "Name",
          whatsapp: "Connection",
          email: "Email",
          actions: "Actions",
          lastMessage: "Last Message",
          wallet: "Wallet",
        },
        menu: {
          importYourPhone: "Import from default device",
          importToExcel: "Import/Export from Excel",
          importexport: "IMPORT / EXPORT ",
        },
      },
      forwardMessage: {
        text: "Forwarded",
      },
      forwardMessageModal: {
        title: "Forward Message",
        buttons: {
          ok: "Forward",
        },
      },
      promptModal: {
        form: {
          name: "Name",
          prompt: "Prompt",
          voice: "Voice",
          max_tokens: "Maximum Tokens in Response",
          temperature: "Temperature",
          apikey: "API Key",
          max_messages: "Maximum Messages in History",
          voiceKey: "Voice API Key",
          voiceRegion: "Voice Region",
        },
        success: "Agent saved successfully!",
        title: {
          add: "Create Agent",
          edit: "Edit Agent",
        },
        subtitle: "Configure the AI agent parameters",
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        tabs: {
          basic: "Basic",
          behavior: "Behavior",
          advanced: "Advanced",
          knowledge: "📚 Knowledge",
          test: "🧪 Test",
        },
        basic: {
          agentName: "Agent Name *",
          agentNamePlaceholder: "E.g.: Sales Assistant",
          function: "Function",
          voiceTone: "Voice Tone",
          aiModel: "AI Model",
          apiKey: "API Key *",
          responseLanguages: "🌐 Response Languages",
          responseLanguagesHelp: "Select the languages in which the AI can respond. Use \"Auto\" to respond in the customer's language automatically.",
          personality: "Personality",
          personalityPlaceholder: "Describe the agent's personality, knowledge, and skills",
          personalityHelp: "Describe the agent's personality, knowledge, and skills",
          activeAgent: "Active Agent",
        },
        behavior: {
          greetingMessage: "Greeting Message (optional)",
          greetingPlaceholder: "Hello! How can I help you?",
          greetingHelp: "Message sent automatically when the agent starts a conversation",
          responseRules: "Response Rules",
          responseRulesPlaceholder: "List specific rules the agent must follow",
          responseRulesHelp: "List specific rules the agent must follow",
          allowTransfer: "Allow transfer to agent",
          transferKeywords: "Transfer keywords",
          transferKeywordsPlaceholder: "agent, exit, talk to human, human",
          transferKeywordsHelp: "Separate by comma. When detected, the AI transfers to an agent",
          transferKeywordsDefault: "agent, exit, talk to human, human",
          transferMessage: "Transfer message",
          transferMessagePlaceholder: "Sorry, I don't have information on this topic. I'll transfer you to an agent.",
          transferMessageDefault: "Sorry, I don't have information on this topic. I'll transfer you to an agent.",
        },
        advanced: {
          responseDelay: "Response Delay",
          responseDelayHelp: "Wait time before sending the response (simulates typing)",
          charLimit: "Character Limit",
          charLimitHelp: "Maximum size of the agent's response",
          humanize: "✨ Humanize conversation",
          humanizeHelp: "Alternates between first name, full name, and no name to appear natural",
          audioFeatures: "🔊 Audio Features",
          transcribeAudio: "Transcribe received audio",
          transcribeAudioHelp: "Converts audio messages to text for the agent to understand",
          responseMode: "Response Mode",
          agentVoice: "Agent Voice",
          sendAsPTT: "Send as recorded audio (PTT)",
          sendAsPTTHelp: "Audio appears as if recorded on the spot, like a WhatsApp voice note",
          temperatureHelp: "0 = precise, 2 = creative",
          maxTokens: "Max Tokens",
          maxMessages: "Max Messages",
        },
        knowledge: {
          title: "Knowledge Base",
          subtitle: "Add texts, URLs, PDFs, audio, and videos for the agent to use as reference",
          upload: "Upload",
          add: "Add",
          saveFirst: "Save the agent first to add items to the knowledge base",
          newItem: "New Item",
          nameLabel: "Name",
          textType: "📋 Text",
          urlType: "🔗 URL",
          urlLabel: "Website URL",
          textLabel: "Text content",
          urlPlaceholder: "https://example.com/page",
          textPlaceholder: "Paste the reference text here...",
          cancelBtn: "Cancel",
          saveBtn: "Save",
          empty: "No items in the knowledge base",
          emptyHelp: "Add texts, URLs, or upload files",
          noContent: "No content",
          fillNameContent: "Fill in the name and content",
          addedSuccess: "Item added to knowledge base!",
          uploadSuccess: "File uploaded successfully!",
          removeConfirm: "Are you sure you want to remove this item?",
          removeSuccess: "Item removed!",
        },
        test: {
          model: "Model",
          usingApiKey: "Using API Key and prompt from the \"Basic\" tab",
          clear: "Clear",
          emptyChat: "💬 Send a message to test your AI Agent",
          placeholder: "Type your test message...",
          fillApiKey: "Fill in the API Key before testing",
          fillPrompt: "Fill in the personality/prompt before testing",
          fillApiKeyVoice: "Fill in the API Key in the Basic tab to hear the voice preview",
          voiceError: "Error generating voice preview. Check the API Key.",
        },
        functions: {
          geral: "General",
          geralDesc: "Multi-purpose assistant",
          vendas: "Sales",
          vendasDesc: "Focused on conversion",
          suporte: "Support",
          suporteDesc: "Technical support",
          agendamento: "Scheduling",
          agendamentoDesc: "Appointment booking",
          financeiro: "Financial",
          financeiroDesc: "Billing and payments",
        },
        voiceTones: {
          amigavel: "😊 Friendly",
          profissional: "💼 Professional",
          formal: "🎩 Formal",
          casual: "😎 Casual",
          empatico: "🤗 Empathetic",
          tecnico: "🔧 Technical",
        },
        responseModes: {
          text: "Text Only",
          textDesc: "Responds with text only",
          audio: "Audio Only",
          audioDesc: "Responds with audio only",
          both: "Text and Audio",
          bothDesc: "Responds with both",
        },
        agentVoices: {
          alloyDesc: "Neutral and balanced",
          ashDesc: "Male, smooth",
          balladDesc: "Female, expressive",
          coralDesc: "Female, clear",
          echoDesc: "Male, deep",
          fableDesc: "Male, British",
          onyxDesc: "Male, bass",
          novaDesc: "Female, energetic",
          sageDesc: "Male, calm",
          shimmerDesc: "Female, delicate",
        },
        aiModels: {
          gpt4oMiniDesc: "Recommended - Balance between speed and quality",
          gpt4oDesc: "Smarter and more detailed",
          gpt41MiniDesc: "Fast and efficient",
          gpt41Desc: "High performance",
          gpt41NanoDesc: "Ultra fast and economical",
          o4MiniDesc: "Advanced reasoning model",
        },
        sectorRequired: "Select a transfer sector",
      },
      prompts: {
        title: "AI Agent",
        table: {
          name: "Name",
          queue: "Sector/Queue",
          max_tokens: "Max Tokens in Response",
          tokens_used: "Tokens Used",
          actions: "Actions",
        },
        metrics: {
          title: "Token Usage Metrics",
          totalTokens: "Total Tokens",
          inputTokens: "Input Tokens",
          outputTokens: "Output Tokens",
          estimatedCost: "Estimated Cost (USD)",
          costTooltip: "Estimate based on average GPT-4o-mini pricing. Actual cost may vary.",
          perAgent: "Usage per Agent",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "Are you sure? This action cannot be undone!",
        },
        buttons: {
          add: "Add Agent",
        },
        noPermission: "This company does not have permission to access this page! We are redirecting you.",
      },
      contactModal: {
        title: {
          add: "Add Contact",
          edit: "Edit Contact",
        },
        form: {
          mainInfo: "Contact Data",
          extraInfo: "Additional Information",
          name: "Name",
          number: "WhatsApp Number",
          email: "Email",
          extraName: "Field Name",
          extraValue: "Value",
          chatBotContact: "Disable Chatbot",
          termsLGDP: "LGPD Terms accepted on:",
          whatsapp: "Origin Connection:",
        },
        buttons: {
          addExtraInfo: "Add Information",
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Contact saved successfully.",
        walletLinked: "Contact linked to your wallet successfully!",
        walletError: "User has no associated queues",
        saveFirst: "Contact must be saved first",
      },
      wallets: {
        title: "Contact Wallets",
        searchPlaceholder: "Search contacts...",
        filterByUser: "Filter by User",
        allUsers: "All users",
        contact: "Contact",
        user: "User",
        queue: "Queue",
        phone: "Phone",
        email: "Email",
        actions: "Actions",
        editWallet: "Edit Wallet",
        selectUser: "Select User",
        selectQueue: "Select Queue",
        selectUserAndQueue: "Select a user and queue",
        cancel: "Cancel",
        save: "Save",
        confirmDeleteTitle: "Confirm Deletion",
        confirmDeleteMessage:
          "Are you sure you want to remove this contact from the wallet?",
        deleteSuccess: "Contact removed from wallet successfully!",
        updateSuccess: "Wallet updated successfully!",
        totalContacts: "Total Contacts",
        activeUsers: "Active Users",
        activeQueues: "Active Queues",
        withEmail: "With Email",
        emptyTitle: "No contacts in wallet",
        emptySubtitle: "Linked contacts will appear here.",
        chartByUser: "Distribution by User",
        chartByQueue: "Contacts by Queue",
      },
      queueModal: {
        title: {
          queueData: "Queue Data",
          text: "Business Hours",
          add: "Add Queue",
          edit: "Edit Queue",
          confirmationDelete:
            "Are you sure? All integration options will be deleted.",
        },
        form: {
          name: "Name",
          color: "Color",
          orderQueue: "Queue Order (Bot)",
          rotate: "Rotation",
          timeRotate: "Rotation Time",
          typeRandomMode: "Rotation Type",
          greetingMessage: "Greeting Message",
          complationMessage: "Completion Message",
          outOfHoursMessage: "Out-of-Hours Message",
          token: "Token",
          integrationId: "Integration",
          fileListId: "File List",
          closeTicket: "Close Ticket",
          queueType: "Menu Type",
          message: "Return Message",
          queue: "Transfer Queue",
          integration: "Integration",
          file: "File List",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        bot: {
          title: "Options",
          toolTipTitle: "Add options to build a chatbot",
          toolTip:
            "If there is only one option, it will be automatically chosen, and the bot will respond with the message and proceed",
          selectOption: "Select an Option",
          text: "Text",
          attendent: "Agent",
          queue: "Queue",
          integration: "Integration",
          file: "File",
          aiAgent: "AI Agent",
          toolTipMessageTitle:
            "Message is required to proceed to the next level",
          toolTipMessageContent:
            "Message is required to proceed to the next level",
          selectUser: "Select a User",
          selectQueue: "Select a Queue",
          selectIntegration: "Select an Integration",
           selectAiAgent: "Select an AI Agent",
           selectModel: "AI Model",
           addOptions: "Add Options",
        },
        serviceHours: {
          dayWeek: "Day of the Week",
          startTimeA: "Start Time - Shift A",
          endTimeA: "End Time - Shift A",
          startTimeB: "Start Time - Shift B",
          endTimeB: "End Time - Shift B",
          monday: "Monday",
          tuesday: "Tuesday",
          wednesday: "Wednesday",
          thursday: "Thursday",
          friday: "Friday",
          saturday: "Saturday",
          sunday: "Sunday",
        },
      },
      queueIntegrationModal: {
        title: {
          add: "Add Project",
          edit: "Edit Project",
        },
        form: {
          id: "ID",
          type: "Type",
          name: "Name",
          projectName: "Project Name",
          language: "Language",
          jsonContent: "JSON Content",
          urlN8N: "URL",
          typebotSlug: "Typebot - Slug",
          typebotExpires: "Expiration time in minutes",
          typebotKeywordFinish: "Keyword to finish the ticket",
          typebotKeywordRestart: "Keyword to restart the flow",
          typebotRestartMessage: "Message when restarting the conversation",
          typebotUnknownMessage: "Invalid option message",
          typebotDelayMessage: "Delay (ms) between messages",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
          test: "Test Bot",
        },
        messages: {
          testSuccess: "Integration tested successfully!",
          addSuccess: "Integration added successfully.",
          editSuccess: "Integration edited successfully.",
        },
      },
      userModal: {
        warning: "To import messages, you must scan the QR Code again!",
        title: {
          add: "Add User",
          edit: "Edit User",
          updateImage: "Update Image",
          removeImage: "Delete Image",
        },
        form: {
          name: "Name",
          email: "Email",
          password: "Password",
          farewellMessage: "Farewell Message",
          profile: "Profile",
          startWork: "Work Start Time",
          endWork: "Work End Time",
          whatsapp: "Default Connection",
          allTicketEnable: "Enabled",
          allTicketDisable: "Disabled",
          allTicket: "View Tickets Without Queue",
          allowGroup: "Allow Groups",
          defaultMenuOpen: "Open",
          defaultMenuClosed: "Closed",
          defaultMenu: "Default Menu",
          defaultTheme: "Default Theme",
          defaultThemeDark: "Dark",
          defaultThemeLight: "Light",
          allHistoric: "View Conversations from Other Queues",
          allHistoricEnabled: "Enabled",
          allHistoricDisabled: "Disabled",
          allUserChat: "View Other Users' Conversations",
          userClosePendingTicket: "Allow Closing Pending Tickets",
          showDashboard: "View Dashboard",
          allowRealTime: "View Real-Time Panel",
          allowConnections: "Allow Actions on Connections",
          showContacts: "View Contacts",
          showCampaign: "View Campaigns",
          allowSeeMessagesInPendingTickets: "Allow viewing pending tickets",
          showReturnQueueButton: "Show return to queue button",
          showTransferTicketButton: "Show transfer ticket button",
          showFlow: "View Automations",
          showSchedules: "View Schedules",
          showKanban: "View Kanban",
          showInternalChat: "View Internal Chat",
          showOpenAi: "View AI Agent",
          showIntegrations: "View Integrations",
          finalizacaoComValorVenda: "Closing with Sale Value",
          birthDate: "Date of Birth",
          birthDateHelper: "Date of birth for birthday notifications",
          connections: "Connections",
          language: "Language",
          timezone: "Time zone (campaigns)",
        },
        tabs: {
          general: "General",
          permissions: "Permissions",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
          addImage: "Add Image",
          editImage: "Edit Image",
        },
        success: "User saved successfully.",
      },
      companyModal: {
        title: {
          add: "Add Company",
          edit: "Edit Company",
        },
        form: {
          name: "Name",
          email: "Email",
          passwordDefault: "Password",
          numberAttendants: "Users",
          numberConections: "Connections",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Company saved successfully.",
      },
      scheduleModal: {
        title: {
          add: "New Schedule",
          edit: "Edit Schedule",
          message: "Message",
        },
        form: {
          body: "Message",
          contact: "Contact",
          sendAt: "Scheduled Date",
          sentAt: "Sent Date",
          assinar: "Send Signature",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
          addSchedule: "Add Schedule",
        },
        success: "Schedule saved successfully.",
      },
      tagModal: {
        title: {
          add: "New Tag",
          edit: "Edit Tag",
          addKanban: "New Lane",
          editKanban: "Edit Lane",
          backToKanban: "BACK TO KANBAN",
        },
        form: {
          name: "Name",
          color: "Color",
          timeLane: "Time in minutes to redirect to lane",
          nextLaneId: "Lane",
          greetingMessageLane: "Lane Greeting Message",
          mediaFiles: "Media",
          rollbackLaneId: "Return to Lane after resuming attendance",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Tag saved successfully.",
        successKanban: "Lane saved successfully.",
      },
      fileModal: {
        title: {
          add: "Add File List",
          edit: "Edit File List",
        },
        buttons: {
          okAdd: "Save",
          okEdit: "Edit",
          cancel: "Cancel",
          fileOptions: "Add File",
        },
        form: {
          name: "File List Name",
          message: "List Details",
          fileOptions: "File List",
          extraName: "Message to send with file",
          extraValue: "Option Value",
        },
        success: "File list saved successfully!",
      },
      chat: {
        noTicketMessage: "Select a ticket to start chatting.",
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop: "⬇️ DRAG AND DROP FILES BELOW ⬇️",
          titleFileList: "File List",
        },
      },
      chatInternal: {
        new: "New group",
        modal: {
          conversation: "Conversation",
          title: "Title",
          filterUsers: "Filter by Users",
          cancel: "Close",
          save: "Save",
        },
        modalDelete: {
          title: "Delete Conversation",
          message: "This action cannot be undone, confirm?",
        },
      },
      ticketsManager: {
        header: {
          title: "Conversations",
        },
        questionCloseTicket: "DO YOU WANT TO CLOSE ALL TICKETS?",
        yes: "YES",
        not: "NO",
        buttons: {
          newTicket: "New",
          resolveAll: "Resolve All",
          close: "Close",
          new: "New",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Queues",
      },
      tickets: {
        messageHidden: "Hidden message",
        inbox: {
          closedAllTickets: "Close all tickets?",
          closedAll: "Close All",
          newTicket: "New Ticket",
          yes: "YES",
          no: "NO",
          open: "Open",
          resolverd: "Resolved",
        },
        toasts: {
          deleted: "The attendance you were handling has been deleted.",
        },
        notification: {
          message: "Message from",
        },
        tabs: {
          open: { title: "Open" },
          closed: { title: "Resolved" },
          search: { title: "Search" },
        },
        search: {
          placeholder: "Search attendance and messages",
          filterConections: "Filter by Connection",
          filterConectionsOptions: {
            open: "Open",
            closed: "Closed",
            pending: "Pending",
          },
          filterUsers: "Filter by Users",
          filterContacts: "Filter by Contacts",
          ticketsPerPage: "Tickets per page",
        },
        buttons: {
          showAll: "All",
          returnQueue: "Return to Queue",
          scredule: "Schedule",
          deleteTicket: "Delete Ticket",
        },
        closedTicket: {
          closedMessage: "Close Ticket With Farewell Message",
          closedNotMessage: "Close Ticket Without Farewell Message",
        },
      },
      transferTicketModal: {
        title: "Transfer Ticket",
        fieldLabel: "Type to search for users",
        fieldQueueLabel: "Transfer to Queue",
        fieldQueuePlaceholder: "Select a queue",
        fieldWhatsapp: "Select a WhatsApp",
        noOptions: "No users found with that name",
        msgTransfer: "Notes - internal message, will not be sent to the client",
        buttons: {
          ok: "Transfer",
          cancel: "Cancel",
        },
      },
      chatInternal: {
        new: "New group",
        modal: {
          conversation: "Conversation",
          title: "Title",
          filterUsers: "Filter by Users",
          cancel: "Close",
          save: "Save",
        },
        modalDelete: {
          title: "Delete Conversation",
          message: "This action cannot be undone, confirm?",
        },
      },
      ticketsList: {
        called: "Call",
        today: "Today",
        elapsedPrefix: "{{distance}} ago",
        missedCall: "Missed voice/video call at",
        pendingHeader: "Waiting",
        assignedHeader: "In Attendance",
        groupingHeader: "Groups",
        noTicketsTitle: "Nothing here!",
        noTicketsMessage:
          "No attendances found with this status or search term",
        noQueue: "No Queue",
        buttons: {
          accept: "Accept",
          cancel: "Cancel",
          start: "Start",
          closed: "Close",
          reopen: "Reopen",
          transfer: "Transfer",
          ignore: "Ignore",
          exportAsPDF: "Export to PDF",
          kanbanActions: "Kanban Options",
        },
        acceptModal: {
          title: "Accept Chat",
          queue: "Select Sector",
        },
      },
      newTicketModal: {
        title: "Create Ticket",
        fieldLabel: "Type to search for a contact",
        add: "Add",
        buttons: {
          ok: "Save",
          cancel: "Cancel",
        },
      },
      SendContactModal: {
        title: "Send Contact",
        fieldLabel: "Type to search for contact",
        add: "Add",
        buttons: {
          ok: "Send",
          cancel: "Cancel",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Connections",
          chatsTempoReal: "Real-Time Panel",
          tickets: "Attendances",
          quickMessages: "Quick Replies",
          contacts: "Contacts",
          wallets: "Wallets",
          queues: "Queues & Chatbot",
          tags: "Tags",
          administration: "Administration",
          companies: "Companies",
          users: "Users",
          birthdaySettings: "Birthday Settings",
          settings: "Settings",
          files: "File Lists",
          helps: "Help Center",
          messagesAPI: "API",
          schedules: "Schedules",
          campaigns: "Campaigns",
          annoucements: "Announcements",
          chats: "Internal Chat",
          financeiro: "Financial",
          myPlan: "My Plan",
          adminFinanceiro: "Financial Management",
          queueIntegration: "Integrations",
          version: "Version",
          kanban: "Kanban",
          prompts: "AI Agent",
          allConnections: "Manage Connections",
          reports: "Reports",
          management: "Management",
          callHistorical: "Call History",
           automations: "Automations",
          groupManager: "Group Manager",
          n8nPanel: "n8n Panel",
          tasks: "Tasks",
          followUp: "Follow UP (Templates)",
          salesPipeline: "Sales Pipeline",
          salesPipelineDesc: "View opportunities",
          taskList: "Task List",
          taskListDesc: "Schedule and manage",
          preferences: "Preferences",
          preferencesDesc: "System settings",
          switchAccount: "Switch Account",
          switchAccountDesc: "Manage saved accounts",
        },
        planExpiresToday: "⚠️ Your plan expires today! Renew now to keep your access.",
        planExpiresTomorrow: "⚠️ Your plan expires tomorrow! Renew to keep your access.",
        planExpiresIn: "⏳ Your plan expires in {{count}} days. Renew to continue using the system.",
        renewNow: "Renew now",
        appBar: {
          user: {
            profile: "Profile",
            logout: "Logout",
            switchAccount: "Switch Account",
            message: "Hello",
            messageEnd: "welcome to",
            active: "Active until",
            goodMorning: "Hi,",
            myName: "my name is",
            continuity: "and I will continue your service.",
            virtualAssistant: "Virtual Assistant",
            token: "Invalid token, please contact the platform administrator.",
          },
          message: {
            location: "Location",
            contact: "Contact",
          },
          notRegister: "No records found",
          refresh: "Refresh",
        },
      },
      languages: {
        undefined: "Language",
        "pt-BR": "Portuguese",
        es: "Spanish",
        en: "English",
        tr: "Turkish",
        ar: "Arabic",
      },
      messagesAPI: {
        title: "API",
        toSend: "TO SEND",
        textMessage: {
          number: "Number",
          body: "Message",
          token: "Registered Token",
          userId: "User/Agent ID",
          queueId: "Queue ID",
        },
        mediaMessage: {
          number: "Number",
          body: "File Name",
          media: "File",
          token: "Registered Token",
        },
        API: {
          title: "Message Sending Documentation",
          methods: {
            title: "Sending Methods",
            messagesText: "Text Messages",
            messagesMidia: "Media Messages",
          },
          instructions: {
            title: "Instructions",
            comments: "Important Notes",
            comments1:
              "Before sending messages, it is necessary to register the token linked to the connection that will send the messages. <br />To register, access the 'Connections' menu, click the edit button on the connection, and insert the token in the appropriate field.",
            comments2:
              "The sending number must not have a mask or special characters and must be composed of:",
            codeCountry: "Country Code",
            code: "Area Code (DDD)",
            number: "Phone Number",
          },
          text: {
            title: "1. Text Messages",
            instructions:
              "Below is the list of required information to send text messages:",
          },
          media: {
            title: "2. Media Messages",
            instructions:
              "Below is the list of required information to send media messages:",
          },
        },
      },
      notifications: {
        noTickets: "No notifications.",
        messageHidden: "Hidden message",
        newMessage: "New message from",
      },
      triggerFlowModal: {
        title: "Trigger Flow",
        description:
          "Select a flow to run on this ticket. The ticket will be changed to 'chatbot' status during execution.",
        selectFlow: "Choose a flow",
        selectedFlow: "Selected flow",
        flowId: "Flow ID",
        noFlows: "No active flows found",
        cancel: "Cancel",
        trigger: "Trigger Flow",
        triggering: "Triggering...",
        success: "Flow triggered successfully!",
        error: "Error triggering flow",
      },
      quickMessages: {
        title: "Quick Replies",
        searchPlaceholder: "Search...",
        noAttachment: "No attachment",
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "This action is irreversible! Do you want to proceed?",
        },
        buttons: {
          add: "Add",
          attach: "Attach File",
          cancel: "Cancel",
          edit: "Edit",
        },
        toasts: {
          success: "Shortcut added successfully!",
          deleted: "Shortcut removed successfully!",
        },
        dialog: {
          title: "Quick Message",
          shortcode: "Shortcut",
          message: "Response",
          save: "Save",
          cancel: "Cancel",
          general: "General",
          geral: "Allow Editing",
          add: "Add",
          edit: "Edit",
          visao: "Allow Viewing",
        },
        table: {
          shortcode: "Shortcut",
          message: "Message",
          media: "Media",
          actions: "Actions",
          mediaName: "File Name",
          status: "Status",
        },
      },
      contactLists: {
        title: "Contact Lists",
        table: {
          name: "Name",
          contacts: "Contacts",
          actions: "Actions",
        },
        buttons: {
          add: "New List",
        },
        dialog: {
          name: "Name",
          company: "Company",
          okEdit: "Edit",
          okAdd: "Add",
          add: "Add",
          edit: "Edit",
          cancel: "Cancel",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "This action cannot be undone.",
        },
        toasts: {
          deleted: "Record deleted successfully.",
        },
      },
      contactListItems: {
        title: "Contacts",
        searchPlaceholder: "Search",
        buttons: {
          add: "New",
          lists: "Lists",
          import: "Import",
        },
        dialog: {
          name: "Name",
          number: "Number",
          whatsapp: "WhatsApp",
          email: "Email",
          okEdit: "Edit",
          okAdd: "Add",
          add: "Add",
          edit: "Edit",
          cancel: "Cancel",
        },
        table: {
          name: "Name",
          number: "Number",
          whatsapp: "WhatsApp",
          email: "Email",
          actions: "Actions",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "This action cannot be undone.",
          importMessage:
            "Do you want to import the contacts from this spreadsheet?",
          importTitlte: "Import",
        },
        toasts: {
          deleted: "Record deleted successfully.",
        },
      },
      kanban: {
        title: "Kanban",
        searchPlaceholder: "Search",
        sortBy: "Sort by",
        startDate: "Start date",
        endDate: "End date",
        search: "Search",
        addColumns: "Add columns",
        allTickets: "All tickets",
        myTickets: "My tickets",
        slaOverdue: "SLA Overdue",
        filterSla: "Filter SLA",
        sortOptions: {
          ticketNumber: "Ticket Number",
          lastMessage: "Last Message",
          valueDesc: "Value (highest to lowest)",
        },
        toasts: {
          tagUpdated: "Ticket Tag updated successfully!",
          tagRemoved: "Ticket Tag removed!",
          adminOnly: "Only admins can reorder Kanban lanes",
          laneOrderUpdated: "Lane order updated successfully",
          laneOrderError: "Error saving lane order",
        },
        subMenus: {
          list: "Board",
          tags: "Lanes",
        },
      },
      campaigns: {
        title: "Campaigns",
        searchPlaceholder: "Search",
        subMenus: {
          list: "Listing",
          listContacts: "Contact List",
          settings: "Settings",
        },
        settings: {
          randomInterval: "Random Sending Interval",
          noBreak: "No Interval",
          intervalGapAfter: "Longer interval after",
          undefined: "Undefined",
          messages: "messages",
          laggerTriggerRange: "Larger Sending Interval",
          addVar: "Add Variable",
          save: "Save",
          close: "Close",
          add: "Add",
          shortcut: "Shortcut",
          content: "Content",
        },
        buttons: {
          add: "New Campaign",
          contactLists: "Contact Lists",
        },
        table: {
          name: "Name",
          whatsapp: "Connection",
          contactList: "Contact List",
          option: "None",
          disabled: "Disabled",
          enabled: "Enabled",
          status: "Status",
          scheduledAt: "Scheduled",
          completedAt: "Completed",
          confirmation: "Confirmation",
          actions: "Actions",
          recurrence: "Recurrence",
          nextExecution: "Next Execution",
        },
        dialog: {
          new: "New Campaign",
          update: "Edit Campaign",
          readonly: "View Only",
          help: "Use variables like {name}, {number}, {email}, or define custom variables.",
          form: {
            name: "Name",
            message1: "Message 1",
            message2: "Message 2",
            message3: "Message 3",
            message4: "Message 4",
            message5: "Message 5",
            confirmationMessage1: "Confirmation Message 1",
            confirmationMessage2: "Confirmation Message 2",
            confirmationMessage3: "Confirmation Message 3",
            confirmationMessage4: "Confirmation Message 4",
            confirmationMessage5: "Confirmation Message 5",
            messagePlaceholder: "Message content",
            whatsapp: "Connection",
            status: "Status",
            scheduledAt: "Schedule",
            confirmation: "Confirmation",
            contactList: "Contact List",
            tagList: "Tags",
            statusTicket: "Ticket Status",
            openTicketStatus: "Open",
            pendingTicketStatus: "Pending",
            closedTicketStatus: "Closed",
            enabledOpenTicket: "Enabled",
            disabledOpenTicket: "Disabled",
            openTicket: "Open Ticket",
          },
          buttons: {
            add: "Add",
            edit: "Update",
            okadd: "Ok",
            cancel: "Cancel Sending",
            restart: "Restart Sending",
            close: "Close",
            attach: "Attach File",
          },
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "This action cannot be undone.",
        },
        statuses: {
          inactive: "Inactive",
          scheduled: "Scheduled",
          inProgress: "In Progress",
          cancelled: "Cancelled",
          finished: "Finished",
        },
        recurrence: {
          minutely: "Per Minute",
          hourly: "Per Hour",
          daily: "Daily",
          weekly: "Weekly",
          biweekly: "Biweekly",
          monthly: "Monthly",
          yearly: "Yearly",
        },
        stopRecurrence: {
          title: "Stop Recurrence",
          message: "Are you sure you want to stop the recurrence of this campaign? The current campaign will continue running, but there will be no future executions.",
        },
        filters: {
          status: "Status",
          all: "All",
          allFem: "All",
          recurrence: "Recurrence",
          recurring: "Recurring",
          single: "Single",
        },
        tooltips: {
          recurring: "Recurring Campaign",
          stop: "Stop Campaign",
          restart: "Restart Campaign",
          stopRecurrence: "Stop Recurrence",
          duplicate: "Duplicate Campaign",
          export: "Export CSV",
          preview: "Preview message",
        },
        summary: {
          total: "Total",
          scheduled: "Scheduled",
          inProgress: "In Progress",
          finished: "Finished",
          cancelled: "Cancelled",
        },
        bulk: {
          selected: "selected",
          cancelAll: "Cancel",
          restartAll: "Restart",
          deleteAll: "Delete",
          confirmTitle: "Bulk Action",
          confirmMessage: "Are you sure you want to perform this action on {{count}} campaign(s)?",
        },
        noMessage: "No message",
        listRemoved: "No list linked",
        connectionDeleted: "Connection deleted",
        connectionPrefix: "Connection",
        noConnection: "No connection",
        notCompleted: "Not completed",
        totalLabel: "campaigns",
        pagination: {
          rowsPerPage: "Rows per page:",
          of: "of",
          moreThan: "more than",
        },
        toasts: {
          success: "Operation completed successfully.",
          cancel: "Campaign canceled.",
          restart: "Campaign restarted.",
          deleted: "Record deleted successfully.",
          duplicated: "Campaign duplicated successfully!",
          bulkSuccess: "Bulk action completed successfully!",
          noPermission: "This company does not have permission to access this page! We are redirecting you.",
          recurrenceStopped: "Recurrence stopped successfully!",
        },
      },
      campaignReport: {
        title: "Campaign Report",
        inactive: "Inactive",
        scheduled: "Scheduled",
        process: "In Progress",
        cancelled: "Canceled",
        finished: "Completed",
        campaign: "Campaign",
        validContacts: "Valid Contacts",
        confirmationsRequested: "Confirmations Requested",
        confirmations: "Confirmations",
        deliver: "Delivered",
        connection: "Connection",
        contactLists: "Contact List",
        schedule: "Schedule",
        conclusion: "Conclusion",
        backButton: "Back",
        awaitingTemplateResponseCard: "Awaiting template response",
        templateRespondedCard: "Replied (follow-up sent)",
        followUpStatus: {
          waiting: "Awaiting response",
          waitingTooltip: "Template sent. Waiting for the customer to reply to unlock messages 2-5 (Meta's 24h window).",
          sent: "Follow-ups sent",
          sentTooltip: "Customer replied to the template. Follow-up messages (2-5) have already been sent.",
          expired: "Window expired",
          expiredTooltip: "Meta's 24h window expired without a customer reply. Messages 2-5 can no longer be sent.",
        },
      },
      announcements: {
        title: "Announcements",
        searchPlaceholder: "Search",
        active: "Active",
        inactive: "Inactive",
        buttons: {
          add: "New Announcement",
          contactLists: "Announcement Lists",
        },
        table: {
          priority: "Priority",
          title: "Title",
          text: "Text",
          mediaName: "File",
          status: "Status",
          actions: "Actions",
        },
        dialog: {
          edit: "Edit Announcement",
          add: "New Announcement",
          update: "Edit Announcement",
          readonly: "View Only",
          form: {
            priority: "Priority",
            title: "Title",
            text: "Text",
            mediaPath: "File",
            status: "Status",
            high: "High",
            medium: "Medium",
            low: "Low",
            active: "Active",
            inactive: "Inactive",
          },
          buttons: {
            add: "Add",
            edit: "Update",
            okadd: "Ok",
            cancel: "Cancel",
            close: "Close",
            attach: "Attach File",
          },
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "This action cannot be undone.",
        },
        toasts: {
          success: "Operation completed successfully.",
          deleted: "Record deleted successfully.",
        },
      },
      campaignsConfig: {
        title: "Campaign Settings",
      },
      queues: {
        title: "Queues & Chatbot",
        table: {
          name: "Name",
          color: "Color",
          greeting: "Greeting Message",
          orderQueue: "Queue Order (Bot)",
          actions: "Actions",
          ID: "ID",
        },
        buttons: {
          add: "Add Queue",
        },
        toasts: {
          success: "Queue saved successfully.",
          deleted: "Queue deleted successfully.",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "Are you sure? This action cannot be undone! Attendances from this queue will still exist but will no longer be assigned to a queue.",
        },
      },
      queue: {
        queueData: "Queue Data",
      },
      queueSelect: {
        inputLabel: "Queues",
        inputLabelRO: "Read-Only Queues",
        withoutQueue: "No Queue",
      },
      queueIntegration: {
        title: "Integrations",
        table: {
          id: "ID",
          type: "Type",
          name: "Name",
          projectName: "Project Name",
          language: "Language",
          lastUpdate: "Last Update",
          actions: "Actions",
        },
        buttons: {
          add: "Add Project",
        },
        searchPlaceholder: "Search...",
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "Are you sure? This action cannot be undone and will be removed from linked queues and connections.",
        },
      },
      users: {
        title: "Users",
        table: {
          status: "Status",
          name: "Name",
          email: "Email",
          profile: "Profile",
          startWork: "Work Start Time",
          endWork: "Work End Time",
          actions: "Actions",
          ID: "ID",
        },
        buttons: {
          add: "Add User",
        },
        toasts: {
          deleted: "User deleted successfully.",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "All user data will be lost. Open tickets for this user will be moved to the queue.",
        },
      },
      compaies: {
        title: "Companies",
        table: {
          ID: "ID",
          status: "Active",
          name: "Name",
          email: "Email",
          password: "Password",
          phone: "Phone",
          plan: "Plan",
          active: "Active",
          numberAttendants: "Agents",
          numberConections: "Connections",
          value: "Value",
          namePlan: "Plan Name",
          numberQueues: "Queues",
          useCampaigns: "Campaigns",
          useExternalApi: "REST API",
          useFacebook: "Facebook",
          useInstagram: "Instagram",
          useWhatsapp: "WhatsApp",
          useInternalChat: "Internal Chat",
          useSchedules: "Scheduling",
          createdAt: "Created At",
          dueDate: "Expiration Date",
          lastLogin: "Last Login",
          folderSize: "Folder size ",
          totalFiles: " Total Files",
          lastUpdate: "Last update",
          actions: "Actions",
          money: "",
          yes: "Yes",
          no: "No",
          document: "CNPJ/CPF",
          recurrence: "Recurrence",
          monthly: "Monthly",
          bimonthly: "Bimonthly",
          quarterly: "Quarterly",
          semester: "Semiannual",
          yearly: "Annual",
          clear: "Clear",
          delete: "Delete",
          user: "User",
          save: "Save",
        },
        buttons: {
          add: "Add Company",
        },
        toasts: {
          deleted: "Company deleted successfully.",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "All company data will be lost. Open tickets for users in this company will be moved to the queue.",
        },
      },
      plans: {
        form: {
          name: "Name",
          users: "Users",
          connections: "Connections",
          queues: "Queues",
          amount: "Price",
          campaigns: "Campaigns",
          schedules: "Schedules",
          internalChat: "Internal Chat",
          externalApi: "External API",
          kanban: "Kanban",
          openAi: "AI Agent",
          integrations: "Integrations",
          flows: "Flows",
          contacts: "Contacts",
          dashboard: "Dashboard",
          realTime: "Real Time",
          enabled: "Enabled",
          disabled: "Disabled",
          clear: "Cancel",
          delete: "Delete",
          save: "Save",
          yes: "Yes",
          no: "No",
          money: "",
          public: "Public",
          trial: "Trial",
          trialDays: "Trial Days",
        },
        confirmationModal: {
          deleteTitle: "Delete Record",
          deleteMessage: "Are you sure you want to delete this record?",
        },
        toasts: {
          success: "Operation completed successfully!",
          errorList: "Could not load the list of records",
          errorSave: "Could not complete the operation. Check if a plan with the same name already exists or if the fields were filled correctly",
          errorDelete: "Could not complete the operation",
        },
      },
      helps: {
        title: "Help Center",
        settings: {
          codeVideo: "Video Code",
          description: "Description",
          clear: "Clear",
          delete: "Delete",
          save: "Save",
        },
        confirmationModal: {
          deleteTitle: "Delete Record",
          deleteMessage: "Are you sure you want to delete this record?",
        },
        toasts: {
          success: "Operation completed successfully!",
          error: "Could not complete the operation",
        },
      },
      schedules: {
        title: "Schedules",
        date: "Date",
        time: "Time",
        event: "Event",
        allDay: "All Day",
        week: "Week",
        work_week: "Work Week",
        day: "Day",
        month: "Month",
        previous: "Previous",
        next: "Next",
        yesterday: "Yesterday",
        tomorrow: "Tomorrow",
        today: "Today",
        agenda: "Agenda",
        noEventsInRange: "No events in this range.",
        more: "more",
        confirmationModal: {
          deleteTitle: "Are you sure you want to delete this Schedule?",
          deleteMessage: "This action cannot be undone.",
        },
        table: {
          contact: "Contact",
          body: "Message",
          sendAt: "Scheduled Date",
          sentAt: "Sent Date",
          status: "Status",
          actions: "Actions",
        },
        buttons: {
          add: "New Schedule",
        },
        toasts: {
          deleted: "Schedule deleted successfully.",
        },
      },
      tags: {
        title: "Tags",
        addColumns: "+ ADD COLUMNS",
        search: "SEARCH",
        seeTicket: "SEE TICKET",
        confirmationModal: {
          deleteTitle: "Are you sure you want to delete this Tag?",
          deleteMessage: "This action cannot be undone.",
        },
        table: {
          id: "ID",
          name: "Name",
          kanban: "Kanban",
          color: "Color",
          tickets: "Tag Records",
          contacts: "Contacts",
          actions: "Actions",
        },
        buttons: {
          add: "New Tag",
        },
        toasts: {
          deleted: "Tag deleted successfully.",
        },
      },
      tagsKanban: {
        title: "Lanes",
        laneDefault: "Open",
        backToKanban: "BACK TO KANBAN",
        confirmationModal: {
          deleteTitle: "Are you sure you want to delete this Lane?",
          deleteMessage: "This action cannot be undone.",
        },
        table: {
          name: "Name",
          color: "Color",
          tickets: "Tickets",
          actions: "Actions",
        },
        buttons: {
          add: "New Lane",
        },
        toasts: {
          deleted: "Lane deleted successfully.",
        },
      },
      files: {
        title: "File Lists",
        table: {
          name: "Name",
          contacts: "Contacts",
          actions: "Action",
        },
        toasts: {
          deleted: "File list deleted successfully!",
          deletedAll: "All file lists were deleted successfully!",
        },
        buttons: {
          add: "Add",
          deleteAll: "Delete All",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteAllTitle: "Delete All",
          deleteMessage: "Are you sure you want to delete this list?",
          deleteAllMessage: "Are you sure you want to delete all lists?",
        },
      },
      settings: {
        success: "Settings saved successfully.",
        title: "Settings",
        tabs: {
          options: "Options",
          plans: "Plans",
          helps: "Help",
          companies: "Companies",
        },
        settings: {
          userCreation: {
            name: "User Creation",
            options: {
              enabled: "Enabled",
              disabled: "Disabled",
            },
          },
          tabs: {
            options: "Options",
            schedules: "Schedules",
            plans: "Plans",
            help: "Help",
          },
          options: {
            disabled: "Disabled",
            enabled: "Enabled",
            updating: "Updating...",
            creationCompanyUser: "Company/User Creation",
            evaluations: "Evaluations",
            officeScheduling: "Office Scheduling",
            queueManagement: "Queue Management",
            companyManagement: "Company Management",
            connectionManagement: "Connection Management",
            sendGreetingAccepted: "Send Greeting on Accepting Ticket",
            sendMsgTransfTicket:
              "Send Transfer Message between Departments/Agents",
            checkMsgIsGroup: "Ignore Group Messages",
            chatBotType: "Bot Type",
            userRandom: "Random Agent Selection",
            buttons: "Buttons",
            acceptCallWhatsapp: "Notify that WhatsApp call is not accepted?",
            sendSignMessage: "Allow agent to choose to send Signature",
            sendGreetingMessageOneQueues:
              "Send Greeting when only one queue exists",
            sendQueuePosition: "Send Queue Position Message",
            sendFarewellWaitingTicket: "Send Farewell Message while Waiting",
            acceptAudioMessageContact:
              "Accept Audio Messages from All Contacts?",
            enableLGPD: "Enable LGPD Processing",
            requiredTag: "Required Tag to Close Ticket",
            closeTicketOnTransfer:
              "Close Ticket when Transferring to Another Queue",
            DirectTicketsToWallets: "Automatically Move Client to Wallet",
            showNotificationPending: "Show Notification for Pending Tickets",
          },
          customMessages: {
            sendQueuePositionMessage: "Queue Position Message",
            AcceptCallWhatsappMessage: "Message to Inform Call Not Accepted",
            greetingAcceptedMessage: "Greeting Message When Accepting Ticket",
            transferMessage:
              "Transfer Message - ${queue.name} = destination queue",
          },
          LGPD: {
            title: "LGPD",
            welcome: "Welcome Message (LGPD)",
            linkLGPD: "Privacy Policy Link",
            obfuscateMessageDelete: "Obfuscate Deleted Message",
            alwaysConsent: "Always Request Consent",
            obfuscatePhoneUser: "Obfuscate User Phone Number",
            enabled: "Enabled",
            disabled: "Disabled",
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: "Assigned to:",
          dialogRatingTitle:
            "Would you like to leave a service rating for the client?",
          dialogClosingTitle: "Closing the service with the client!",
          dialogRatingCancel: "Resolve WITH Farewell Message",
          dialogRatingSuccess: "Resolve and Send Rating",
          dialogRatingWithoutFarewellMsg: "Resolve WITHOUT Farewell Message",
          ratingTitle: "Choose a rating menu",
          notMessage: "No message selected",
          amount: "Prospecting Value",
          buttons: {
            return: "Return",
            resolve: "Resolve",
            reopen: "Reopen",
            accept: "Accept",
            rating: "Send Rating",
            enableIntegration: "Enable Integration",
            disableIntegration: "Disable Integration",
            logTicket: "Ticket Logs",
            requiredTag: "You must assign a tag before closing the ticket.",
            greetingAcceptedMessage:
              "You must configure a greeting message when accepting the ticket.",
          },
        },
      },
      messagesInput: {
        placeholderPrivateMessage:
          "Type a message or press / for quick replies",
        placeholderOpen: "Type a message or press / for quick replies",
        placeholderClosed: "Reopen or accept this ticket to send a message.",
        signMessage: "Sign",
        privateMessage: "Private Message",
        tooltips: {
          bold: "Bold",
          italic: "Italic",
          strikethrough: "Strikethrough",
          code: "Code",
          numberedList: "Numbered List",
          bulletList: "Bullet List",
          quote: "Quote",
          clearFormat: "Clear Formatting",
          ghostMention: "Ghost Mention (notifies all without showing @)",
          triggerFlow: "Trigger Flow",
          aiSuggest: "AI: Suggest Reply",
          enableSignature: "Enable/Disable Signature",
          enableComments: "Enable/Disable Comments",
        },
        menuItems: {
          ghostMention: "Ghost Mention",
          signature: "Signature",
          triggerFlow: "Trigger Flow",
          comments: "Comments",
        },
        errors: {
          ticketIdNotFound: "Error: Ticket ID not found",
        },
      },
      messagesInputExtra: {
        internalMessage: "Internal message",
        placeholderPending: "Type a message for pending tickets",
        placeholderPendingAccept: "Accept or reopen this ticket to send a message.",
        placeholderWindowExpired: "Outside the 24h window. Use a template to send the message.",
        ticketPendingTitle: "Pending ticket.",
        ticketPendingMessage: "Accept or reopen this ticket to reply.",
        flowProcessingTitle: "Flow Running:",
        flowProcessingMessage: "Message field temporarily disabled.",
        windowExpiredTitle: "24h Window Expired:",
        windowExpiredMessage: "We recommend sending a template, but you can also type normally.",
      },
      contactDrawer: {
        header: "Contact Details",
        buttons: {
          edit: "Edit Contact",
          block: "Block",
          unblock: "Unblock",
        },
        extraInfo: "Additional Information",
      },
      messageVariablesPicker: {
        label: "Available Variables",
        vars: {
          contactFirstName: "First Name",
          contactName: "Name",
          user: "Agent",
          greeting: "Greeting",
          protocolNumber: "Protocol Number",
          date: "Date",
          hour: "Hour",
          ticket_id: "Ticket Number",
          queue: "Sector",
          connection: "Connection",
        },
      },
      ticketOptionsMenu: {
        schedule: "Schedule",
        delete: "Delete",
        transfer: "Transfer",
        registerAppointment: "Contact Notes",
        resolveWithNoFarewell: "Resolve without Farewell",
        acceptAudioMessage: "Accept audio messages from contact?",
        appointmentsModal: {
          title: "Ticket Notes",
          textarea: "Note",
          placeholder: "Enter the information you want to register here",
        },
        confirmationModal: {
          title: "Delete the contact's ticket",
          titleFrom: "from contact",
          message:
            "Attention! All messages related to this ticket will be lost.",
        },
        buttons: {
          delete: "Delete",
          cancel: "Cancel",
        },
        aiSummarize: "AI Conversation Summary",
        aiSummarizeTitle: "AI Conversation Summary",
        aiSummaryCopied: "Summary copied to clipboard!",
        aiSummaryCopy: "Copy",
        aiSummaryClose: "Close",
        aiSummarySaveNote: "Save as Note",
        aiSummarySaved: "Summary saved as contact note!",
        autoAiSummary: "Auto AI summary on close",
      },
      messageInput: {
        tooltip: {
          signature: "Enable/Disable Signature",
          privateMessage: "Enable/Disable Private Message",
          meet: "Send video conference link",
        },
        type: {
          imageVideo: "Photos and Videos",
          cam: "Camera",
          contact: "Contact",
          meet: "Video Call",
          template: "Meta Template",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancel",
        },
      },
      messageOptionsMenu: {
        delete: "Delete",
        reply: "Reply",
        edit: "Edit",
        forward: "Forward",
        toForward: "Forward",
        talkTo: "Talk To",
        react: "React",
        reactionSent: "Reaction sent",
        confirmationModal: {
          title: "Delete message?",
          message: "This action cannot be undone.",
        },
      },
      invoices: {
        table: {
          invoices: "Invoices",
          details: "Details",
          users: "Users",
          connections: "Connections",
          queue: "Queues",
          value: "Value",
          expirationDate: "Expiration Date",
          action: "Action",
        },
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP:
          "There must be at lest one default WhatsApp connection.",
        ERR_NO_DEF_WAPP_FOUND:
          "No default WhatsApp found. Check connections page.",
        ERR_WAPP_NOT_INITIALIZED:
          "This WhatsApp session is not initialized. Check connections page.",
        ERR_WAPP_CHECK_CONTACT:
          "Could not check WhatsApp contact. Check connections page.",
        ERR_WAPP_INVALID_CONTACT: "This is not a valid whatsapp number.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "Could not download media from WhatsApp. Check connections page.",
        ERR_INVALID_CREDENTIALS: "Authentication error. Please try again.",
        ERR_SENDING_WAPP_MSG:
          "Error sending WhatsApp message. Check connections page.",
        ERR_DELETE_WAPP_MSG: "Couldn't delete message from WhatsApp.",
        ERR_OTHER_OPEN_TICKET:
          "There's already an open ticket for this contact.",
        ERR_SESSION_EXPIRED: "Session expired. Please login.",
        ERR_USER_CREATION_DISABLED:
          "User creation was disabled by administrator.",
        ERR_NO_PERMISSION: "You don't have permission to access this resource.",
        ERR_DUPLICATED_CONTACT: "A contact with this number already exists.",
        ERR_NO_SETTING_FOUND: "No setting found with this ID.",
        ERR_NO_CONTACT_FOUND: "No contact found with this ID.",
        ERR_NO_TICKET_FOUND: "No ticket found with this ID.",
        ERR_NO_USER_FOUND: "No user found with this ID.",
        ERR_NO_WAPP_FOUND: "No WhatsApp found with this ID.",
        ERR_CREATING_MESSAGE: "Error while creating message on database.",
        ERR_CREATING_TICKET: "Error while creating ticket on database.",
        ERR_FETCH_WAPP_MSG:
          "Error fetching the message in WhtasApp, maybe it is too old.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "This color is already in use, pick another one.",
        ERR_WAPP_GREETING_REQUIRED:
          "Greeting message is required if there is more than one queue.",
        ERR_OUT_OF_HOURS: "Outside Business Hours!",
        ERR_TICKET_NO_LINKED_CONNECTION:
          "This ticket has no linked connection; the connection was probably deleted.",
        ERR_PLAN_FEATURE_DISABLED: "This feature is not available on your current plan. Contact your administrator to upgrade.",
      },
      messagesAPIInstructions: {
        endpoint: "Endpoint:",
        method: "Method:",
        post: "POST",
        headers: "Headers:",
        headerAuthorization:
          "Authorization Bearer (registered token) and Content-Type (application/json)",
        body: "Body:",
        fieldNumber: '"number": "558599999999"',
        fieldBody: '"body": "Message"',
        fieldUserId: '"userId": User ID or ""',
        fieldQueueId: '"queueId": Queue ID or ""',
        fieldSendSignature: '"sendSignature": Sign message - true/false',
        fieldCloseTicket: '"closeTicket": Close the ticket - true/false',
        singMessage: "Sign message - true/false",
        closeTicket: "Close the ticket - true/false",
        testSend: "The Test Send",
      },
      recurrenceSection: {
        title: "Recurrence",
        description:
          "You can choose to send the message recurrently and select the interval. If it is a one-time message, do not change anything in this section.",
        labelInterval: "Interval",
        intervalFilterValue: "Interval filter value",
        sendAsManyTimes: " Send as many times",
        shipNormallyOnNonbusinessDays: "Ship normally on non-business days",
        sendOneBusinessDayBefore: "Send one business day before",
        sendOneBusinessDayLater: "Send one business day later",
        options: {
          days: "Days",
          weeks: "Weeks",
          months: "Months",
          minutes: "Minutes",
        },
        servicePanel: {
          allowRealTime: "Service Panel",
        },
      },
      servicePanel: {
        allowRealTime: "Service Panel  ",
      },
      financial: {
        invoices: "Invoices",
        details: "Details",
        users: "Users",
        connections: "Connections",
        queues: "Queues",
        value: "Value",
        expirationDate: "Due Date",
        status: "Status",
        action: "Action",
      },
      statusFilter: {
        statusFilter: "Filter by Status",
      },
      momentsUser: {
        services: "Services:",
        pending: "Pending",
        noqueue: "NO QUEUE",
      },
      campaignsPhrase: {
        campaignsFlow: "Campaigns Flow",
        campaigns: "Campaign",
        name: "Name",
        status: "Status",
        newCampaignWithFlowByPhrase: "New campaign with flow by phrase",
        editCampaignWithFlowByPhrase: "Edit campaign with flow by phrase",
        phraseTriggerName: "Phrase trigger name",
        chooseAStream: "Choose a stream",
        whichPhraseTriggersTheFlow: " Which phrase triggers the flow?",
        selectAConnection: " Select a Connection",
        chooseAStream: "Choose a stream",
        status: " Status",
        cancel: "CANCEL",
        createCampaign: "CREATE CAMPAIGN ",
        saveCampaign: "Sale Campaign",
      },
      chatList: {
        noMessages: "No messages",
        admin: "Admin",
        member: "Member",
        searchChat: "Search chat...",
        createNewChat: "Create new chat",
        searchUser: "Search user...",
        noUserFound: "No user found",
        noUserAvailable: "No user available",
        cancel: "Cancel",
        details: "Details",
        deleteChat: "Delete Chat",
        deleteChatConfirm: "This action cannot be undone, confirm?",
        detailsTitle: "Details",
        edit: "Edit",
        delete: "Delete",
        now: "now",
        minutesAgo: "{{count}}m ago",
        hoursAgo: "{{count}}h ago",
      },
      chatMessages: {
        deleted: "This message was deleted",
        deletedAdmin: "Deleted message - visible only to administrators",
        reply: "Reply",
        edit: "Edit",
        delete: "Delete",
        forward: "Forward",
        editMessage: "Edit Message",
        save: "Save",
        cancel: "Cancel",
        deleteMessage: "Delete Message",
        deleteMessageConfirm: "Are you sure you want to delete this message?",
        forwardMessage: "Forward Message",
        selectChat: "Select chat",
        doubleClickToReply: "Double click to reply",
        edited: "(edited)",
        forwarded: "(forwarded)",
        typeMessage: "Type a message...",
        send: "Send",
        noMessages: "No messages",
        loading: "Loading...",
        replyingTo: "Replying to",
        clickToGoToOriginal: "Click to go to original message",
      },
      chatPopover: {
        reply: "Reply",
        edit: "Edit",
        delete: "Delete",
        forward: "Forward",
        cancel: "Cancel",
        confirmDelete: "Confirm Delete",
        confirm: "Confirm",
        deleteMessage: "Are you sure you want to delete this message?",
        editMessage: "Edit Message",
        save: "Save",
        forwardMessage: "Forward Message",
        selectChat: "Select chat",
        forward: "Forward",
        noChats: "No chat available",
      },
      chatIndex: {
        chats: "Chats",
        groups: "Groups",
        new: "New",
        messages: "Messages",
        search: "Search...",
        noChats: "No chat found",
        noGroups: "No group found",
        noMessages: "No messages",
        loading: "Loading...",
        error: "Error loading data",
        addGroupPhoto: "Add Group Photo",
        changeGroupPhoto: "Change Group Photo",
        groupName: "Group Name",
        groupDescription: "Group Description",
        save: "Save",
        cancel: "Cancel",
        createGroup: "Create Group",
        editGroup: "Edit Group",
        deleteGroup: "Delete Group",
        deleteGroupConfirm: "Are you sure you want to delete this group?",
        edit: "Edit",
        delete: "Delete",
        details: "Details",
        groupDetails: "Group Details",
        title: "Title",
        description: "Description",
        editMessage: "Edit Message",
        messageLabel: "Message",
        modal: {
          title: "Create Group",
          editTitle: "Edit Group",
          save: "Save",
          cancel: "Cancel",
          name: "Group Name",
          description: "Group Description",
          create: "Create",
          edit: "Edit",
        },
      },
      whitelabel: {
        primaryColorLight: "Primary Color (Light Theme)",
        primaryColorDark: "Primary Color (Dark Theme)",
        appName: "Application Name",
        logoLight: "Logo (Light Theme)",
        logoDark: "Logo (Dark Theme)",
        favicon: "Favicon",
        logoMobile: "Mobile Logo (PWA)",
        backgroundLight: "Background Image (Light Theme)",
        backgroundDark: "Background Image (Dark Theme)",
        preview: "Preview",
        delete: "Delete",
        upload: "Upload",
        availableLanguages: "Available Languages",
        atLeastOneLanguage: "At least one language must be enabled",

        sections: {
          general: "General Settings",
          generalDescription: "Configure the application name and basic information",
          colors: "Colors and Themes",
          colorsDescription: "Customize primary colors for light and dark themes",
          logos: "Logos and Images",
          logosDescription: "Upload application logos and background images",
          languages: "Available Languages",
          languagesDescription: "Select which languages will be available in the system"
        }
      },
    flowBuilder: {
      conversationFlows: "Conversation Flows",
      addImage: {
        title: "Add image to flow",
        editTitle: "Edit image",
        add: "Add",
        save: "Save",
        caption: "Caption (optional)",
        uploadImage: "Upload image",
        successAdd: "Image added successfully!",
        fileTooLarge: "File is too large! 2MB maximum",
        error: "error",
      },
      addText: {
        title: "Add message to flow",
        editTitle: "Edit flow message",
        add: "Add",
        save: "Save",
        message: "Message",
      },
      addAttendant: {
        title: "Add attendant to flow",
        editTitle: "Edit attendant",
        add: "Add",
        edit: "Edit",
        chooseAttendant: "Choose an attendant",
        selectUser: "Select a user",
        addAttendant: "Add an attendant",
      },
      condition: {
        title: "New Condition",
        editTitle: "Edit Condition",
        variableField: "Variable / Field",
        variablePlaceholder: "Type $ to see available variables",
        variableHelper: "Type $ to autocomplete flow variables",
        conditionType: "Condition type",
        comparisonValue: "Comparison value",
        commaSeparated: "Comma-separated values",
        regexExample: "E.g.: ^[0-9]{11}$ — JavaScript regex",
        anyTokenTrigger: "Any token in the list triggers True",
        fixedOrVariable: "Fixed value or variable with $",
        insertVariable: "Insert variable from selector",
        addCondition: "Add condition",
        logicTrue: "Logic: True if",
        allConditions: "ALL conditions",
        anyCondition: "ANY condition",
        satisfied: "are satisfied",
        quickTips: "💡 Quick tips",
        tipContainsAny: "Contains any (,): separate tokens by comma →",
        tipRegex: "Regex: use JS expression →",
        tipVariable: "Use ${variable} in any field to reference dynamic values",
        cancel: "Cancel",
        saving: "Saving...",
        saveChanges: "Save changes",
        errorRequired: "the \"Variable / Field\" field is required",
        errorComparisonRequired: "the \"Comparison value\" field is required",
        errorSave: "An error occurred while saving. Try again.",
        selectVariable: "Select variable",
        dynamicVarsFound: "variable(s) found in the flow",
        addVarNodes: "Add Global Variable or Input nodes for dynamic variables",
        searchVariable: "Search variable...",
        noVariableFound: "No variable found",
        flowVariables: "Flow variables",
        equals: "Equal to",
        notEquals: "Not equal to",
        contains: "Contains text",
        notContains: "Does not contain",
        containsAny: "Contains any (,)",
        startsWith: "Starts with",
        endsWith: "Ends with",
        greaterThan: "Greater than",
        lessThan: "Less than",
        greaterOrEqual: "Greater or equal to",
        lessOrEqual: "Less or equal to",
        isEmpty: "Is empty",
        isNotEmpty: "Is not empty",
        regex: "Regular expression",
        equality: "Equality",
        text: "Text",
        numeric: "Numeric",
        state: "State",
        advanced: "Advanced",
        contactName: "Contact name",
        contactEmail: "Contact email",
        contactPhone: "Contact phone / number",
        lastMessage: "Last message received",
        ticketIdDesc: "Current ticket ID",
        ticketStatusDesc: "Ticket status (open/pending/closed)",
        ticketQueueDesc: "Current ticket queue",
        apiResponseDesc: "Last HTTP request response",
        contact: "Contact",
        ticket: "Ticket",
        globalVariable: "Global Variable",
        capturedInput: "Captured Input",
        menu: "Menu",
        httpApi: "HTTP / API",
        api: "API",
        globalVarDesc: "Flow global variable",
        userResponseDesc: "Captured user response",
        responseFrom: "Response from:",
        menuResponse: "Menu response:",
        menuOption: "Menu option:",
        mappedFrom: "Mapped from:",
        httpVarDesc: "HTTP response variable",
        valuePrefix: "Value:",
      },
    },
    flowBuilderTicketModal: {
      addTitle: "Add Ticket",
      editTitle: "Edit Ticket",
      chooseQueue: "Choose sector",
      selectConnection: "Select a connection",
      addQueueError: "Select a sector",
    },
    campaignModal: {
      validation: {
        tooShort: "Too Short!",
        tooLong: "Too Long!",
        required: "Required",
        recurrenceTypeRequired: "Recurrence type is required",
        intervalMin: "Interval must be greater than 0",
        intervalRequired: "Interval is required",
        selectDay: "Select at least one day of the week",
        dayRange: "Day must be between 1 and 31",
        dayRequired: "Day of month is required",
        endDateFuture: "End date must be in the future",
        maxExecMin: "Maximum number must be greater than 0",
        noneValue: "None",
      },
      tabs: {
        campaign: "Campaign",
        contactLists: "📋 Contact Lists",
        settings: "⚙️ Settings",
      },
      recurrence: {
        title: "Recurrence Settings",
        enable: "Enable recurrence",
        type: "Recurrence Type",
        interval: "Interval",
        dayOfMonth: "Day of Month",
        dayOfMonthHelper: "Specific day of month (1-31)",
        endDate: "End Date (optional)",
        endDateHelper: "Leave empty for infinite recurrence",
        maxExecutions: "Max Executions (optional)",
        maxExecutionsHelper: "Leave empty for infinite recurrence",
        showExecutions: "Show",
        hideExecutions: "Hide",
        nextExecutions: "Next Executions",
        next5: "Next 5 Executions:",
        nthExecution: "th Execution",
        minutely: "Every X minutes",
        hourly: "Every X hours",
        daily: "Daily",
        weekly: "Weekly",
        biweekly: "Biweekly",
        monthly: "Monthly",
        yearly: "Yearly",
      },
      days: {
        sunday: "Sunday",
        monday: "Monday",
        tuesday: "Tuesday",
        wednesday: "Wednesday",
        thursday: "Thursday",
        friday: "Friday",
        saturday: "Saturday",
      },
      message: {
        title: "Campaign Message",
        variables: {
          name: "Name",
          number: "Number",
          email: "Email",
          greeting: "Greeting",
          protocol: "Protocol",
          firstName: "First Name",
          attendant: "Attendant",
        },
        helperText: "Use variables like {name}, {number}, {email} or define custom variables.",
        oficialNotAvailable: "For Official API, use the selected template on the side. Message field and media attachment are not available.",
        attachMedia: "Attach Media",
        preview: "Preview",
      },
      template: {
        label: "Template *",
        noTemplates: "No approved template found. Create a template before sending.",
        helperText: "Required for Official API. Messages without template fail outside the 24h window.",
        selectTemplate: "Select an approved template for Official API campaigns.",
      },
      contactList: {
        title: "📋 Campaign Contact List",
        description: "Select a list created in the \"📋 Contact Lists\" tab. The list defines who will receive the campaign messages.",
        label: "Contact List",
        noList: "No list selected",
        contacts: "contacts",
        filterByTag: "Filter by Tag (optional)",
        noTagFilter: "No tag filter",
        switchList: "Switch list → Go to Contact Lists",
        createOrSelect: "+ Create or select list in Contact Lists tab",
      },
      triggerSettings: {
        title: "Trigger Intervals",
        description: "Configure the time intervals between campaign triggers to avoid blocks.",
        antiBan: "Anti-Ban",
        antiBanDesc: "Humanizes the trigger to reduce blocking risk",
        jitterLabel: "Random variation (jitter)",
        jitterFixed: "fixed",
        jitterMax: "maximum",
        jitterBase: "Base",
        jitterBetween: "between",
        jitterAnd: "and",
        selectBaseInterval: "⚠️ Select a base interval above",
        extraPause: "Extra pause every N msgs",
        extraPauseDuration: "Extra pause duration",
        disabled: "Disabled",
        every10: "Every 10 messages",
        every20: "Every 20 messages",
        every30: "Every 30 messages",
        every50: "Every 50 messages",
        every100: "Every 100 messages",
        seconds: "seconds",
        minute1: "1 minute",
        minutes2: "2 minutes",
        minutes5: "5 minutes",
        savedSuccess: "Settings saved successfully!",
        saveSettings: "Save Settings",
      },
      followUp: {
        toggle: "Send message after template",
        delayLabel: "Delay between messages",
        description: "Messages sent in sequence after the template (within the 24h window).",
        multipleHelp: "Fill in only the messages you want to send. They will be sent in sequence. Media is sent with the 1st message.",
        windowWarningTitle: "Meta's 24-hour window",
        windowWarningBody: "Messages 2 to 5 will only be sent AFTER the customer replies to the template. The WhatsApp Official API requires a customer reply to open a 24-hour messaging window. If the customer doesn't reply, only the template will be delivered.",
        delay3s: "3 seconds",
        delay5s: "5 seconds",
        delay10s: "10 seconds",
        delay30s: "30 seconds",
        delay60s: "1 minute",
        useApprovedTemplate: "Use approved template",
        noSimpleTemplate: "No simple template available",
        selectApprovedTemplate: "Select an approved template",
        simpleTemplateHelper: "Only approved templates without variables appear here. Header media (if any) is part of the template.",
        metaRestrictionTitle: "Meta restriction — 24h window",
        metaRestrictionBody: "You filled in additional messages (2-5) in an Official API campaign. Meta only allows sending these messages after the customer replies to the initial template, within a 24-hour window.",
        metaRestrictionEnableHint: "Enable the \"Send message after template\" switch below, otherwise messages 2-5 will not be sent.",
      },
    },
    chatMessages: {
      user: "User",
      today: "TODAY",
      loadingOldMessages: "Loading old messages...",
      viewDocument: "View Document",
      doubleClickReply: "Double click to reply",
      messageLabel: "Message",
      messageNotFound: "[message not found]",
    },
    finalizacaoAtendimento: {
      title: "Service Finalization",
      generalSettings: "General Settings",
      informSaleValue: "Inform sale value when finalizing service",
      informSaleValueHelper: "When enabled, the sale value field will appear in the finalization modal",
      finalizationReasons: "Finalization Reasons",
      addReason: "Add Reason",
      name: "Name",
      description: "Description",
      actions: "Actions",
      noDescription: "No description",
      noReasons: "No reasons registered. Click \"Add Reason\" to start.",
      editReason: "Edit Reason",
      reasonName: "Reason Name",
      descriptionOptional: "Description (optional)",
      cancel: "Cancel",
      saving: "Saving...",
      update: "Update",
      add: "Add",
      nameRequired: "Reason name is required",
      reasonUpdated: "Reason updated successfully!",
      reasonCreated: "Reason created successfully!",
      reasonSaveError: "Error saving reason",
      confirmDelete: "Are you sure you want to delete this reason?",
      reasonDeleted: "Reason deleted successfully!",
      reasonDeleteError: "Error deleting reason",
      settingUpdated: "Setting updated successfully!",
      settingUpdateError: "Error updating setting",
      currencyUpdated: "Currency updated successfully!",
      currencyUpdateError: "Error updating currency",
    },
    interactiveMessage: {
      tabs: {
        buttons: "Buttons",
        list: "List",
        billing: "Billing",
        offers: "Offers",
        pix: "PIX",
        url: "URL",
        call: "Call",
        location: "Location",
        carousel: "Carousel",
        catalog: "Catalog",
        poll: "Poll",
      },
      select: "Select",
      options: "Options",
      reviewAndPay: "Review and pay",
      templateLoaded: "Template \"{{name}}\" loaded",
      templateNameRequired: "Enter a name for the template",
      templateSaved: "Template saved!",
      templateSaveError: "Error saving template",
      templateRemoved: "Template removed",
      templateRemoveError: "Error removing",
      fillMessageText: "Fill in the message text",
      addAtLeastOneButton: "Add at least one button",
      addAtLeastOneListOption: "Add at least one option to the list",
      fillLatLong: "Fill in latitude and longitude",
      fillUrl: "Fill in the URL",
      fillPhone: "Fill in the phone number",
      fillPixKey: "Fill in the PIX key",
      addAtLeast2Options: "Add at least 2 options",
      addAtLeastOneCard: "Add at least one card",
      fillBillingDescription: "Fill in the billing description",
      pdfUploadError: "Error uploading PDF",
      messageSent: "Interactive message sent!",
      sendError: "Error sending",
      buttonsInfo: "Send up to 3 clickable buttons. The customer can tap a button to respond quickly.",
      messageText: "Message text *",
      footerOptional: "Footer (optional)",
      buttonsMax3: "Buttons (max. 3)",
      addButton: "Add",
      optionPlaceholder: "Option {{number}}",
      listInfo: "Send a list with up to 10 options. The customer opens a menu to select.",
      buttonText: "Button text",
      sectionTitle: "Section title",
      titleLabel: "Title",
      descriptionLabel: "Description",
      addOption: "Add option",
      offerInfo: "Send an offer with title, price, and description.",
      offerTitle: "Offer title",
      bodyDescription: "Description / Message body *",
      price: "Price (e.g. $99.90)",
      additionalDetails: "Additional details",
      pixInfo: "Send formatted PIX data to the customer.",
      pixKey: "PIX Key *",
      pixKeyPlaceholder: "CPF, CNPJ, email, phone or random key",
      beneficiaryName: "Beneficiary name",
      city: "City",
      amount: "Amount ($)",
      urlInfo: "Send a clickable link with custom text.",
      linkText: "Link text",
      linkTextPlaceholder: "Click here",
      urlLabel: "URL *",
      urlPlaceholder: "https://...",
      callInfo: "Send a message with a phone number for calling.",
      callButtonText: "Button text",
      callButtonPlaceholder: "Call now",
      phoneNumber: "Phone number *",
      locationInfo: "Send a location to the customer.",
      locationName: "Location name",
      address: "Address",
      latitude: "Latitude *",
      longitude: "Longitude *",
      carouselInfo: "Send multiple cards as a carousel.",
      cardLabel: "Card {{number}}",
      addCard: "Add card",
      catalogInfo: "Send catalog products as cards.",
      productLabel: "Product {{number}}",
      productName: "Product name",
      priceDescription: "Description / Price",
      addProduct: "Add product",
      pollInfo: "Create a poll for the customer to vote.",
      pollQuestion: "Poll question *",
      pollOptionsLabel: "Options (min. 2, max. 12)",
      billingInfo: "Send a billing with payment details and \"Review and pay\" button.",
      billingNumber: "Billing No.",
      billingDescription: "Billing description *",
      quantity: "Quantity",
      totalAmount: "Total amount ($)",
      billingMessage: "Additional message",
      paymentUrl: "Payment URL (optional)",
      paymentButtonText: "Payment button text",
      attachPdf: "Attach PDF (invoice)",
      save: "Save",
      cancel: "Cancel",
      send: "Send",
      sending: "Sending...",
      saveTemplate: "Save as template",
      templateNameLabel: "Template name",
      saveTemplateBtn: "Save Template",
      noTemplates: "No saved templates",
      templates: "Templates",
      deleteTemplate: "Delete template",
    },
    flowBuilderInteractive: {
      title: "Interactive Message (Baileys)",
      editTitle: "Edit Interactive Message",
      add: "Add",
      save: "Save",
      cancel: "Cancel",
      messageType: "Interactive message type",
      buttonsMax3: "Buttons (max. 3)",
      infoText: "Interactive buttons via Baileys (nativeFlowMessage). Works on non-official connections. Limit of 3 buttons.",
      messageContent: "MESSAGE CONTENT",
      buttonsTab: "BUTTONS",
      messageBody: "Message body",
      footerOptional: "Footer (optional)",
      headerImageOptional: "Header image (optional)",
      changeImage: "Change image",
      uploadImage: "Upload image",
      listButtonText: "List button text",
      listButtonHelper: "Text displayed on the button that opens the list",
      preview: "Preview",
      messageBodyPlaceholder: "Message body...",
      buttonsLabel: "Buttons",
      listOptions: "List options",
      buttonTextPlaceholder: "Button text {{number}}",
      optionPlaceholder: "Option {{number}}",
      addAtLeastOneOption: "Add at least one option.",
      bodyRequired: "Message body is required!",
      addOption: "Add at least one option!",
      fileTooLarge: "File too large! Maximum 2MB",
      imageUploadError: "Error uploading image",
      maxOptionsReached: "Maximum limit of {{max}} options for buttons!",
    },
    flowBuilderVideo: {
      title: "Add video to flow",
      editTitle: "Edit video",
      add: "Add",
      save: "Save",
      captionOptional: "Caption (optional)",
      uploadVideo: "Upload video",
      mp4Only: "ATTENTION! Only MP4 videos!",
      videoAdded: "Video added successfully!",
      fileTooLarge: "File too large! 20MB maximum",
      browserNotSupported: "your browser does not support HTML5",
    },
    flowBuilderInput: {
      addTitle: "Add input to flow",
      title: "Add input to flow",
      editTitle: "Edit flow input",
      add: "Add",
      saveChanges: "Save changes",
      question: "Question",
      questionTooltip: "The question that will be sent to the user. You can include variables using $\\{variableName}",
      questionLabel: "Type the question",
      typeQuestion: "Type the question",
      questionPlaceholder: "E.g.: Hello {{firstName}}, how old are you?",
      flowVariables: "Flow variables (click to insert):",
      variableName: "Variable name",
      variableNameTooltip: "Name of the variable where the answer will be stored. Do not use spaces or special characters.",
      variableTooltip: "Name of the variable where the answer will be stored. Do not use spaces or special characters.",
      variableNameLabel: "Variable name",
      variableNamePlaceholder: "E.g.: customer_age",
      variablePlaceholder: "E.g.: customer_age",
      variableNameHelper: "The user's answer will be stored in this variable",
      variableHelper: "The user's answer will be stored in this variable",
      howItWorks: "How it works",
      howItWorksDescription: "This node will send the question to the user and wait for a response. When the user responds, the value will be stored in the specified variable and the flow will continue to the next node.",
      howItWorksDesc: "This node will send the question to the user and wait for a response. When the user responds, the value will be stored in the specified variable and the flow will continue to the next node.",
      examples: {
        name: "Customer name",
        email: "Customer email",
        phone: "Customer phone",
        city: "Customer city",
      },
      exampleVars: {
        nome: "Customer name",
        email: "Customer email",
        telefone: "Customer phone",
        cidade: "Customer city",
      },
    },
    flowBuilderTag: {
      addTitle: "Add a tag to flow",
      editTitle: "Edit tag",
      chooseTag: "Choose a tag",
      selectTag: "Select a tag",
      noTagSelected: "No tag selected",
      addTag: "Add a tag",
      add: "Add",
      edit: "Edit",
    },
    flowBuilderSingleBlock: {
      addTitle: "Add content to flow",
      editTitle: "Edit content",
      addMenu: "Add menu to flow",
      add: "Add",
      save: "Save",
      image: "Image",
      uploadImage: "Upload image",
      captionOptional: "Caption (optional)",
      audio: "Audio",
      uploadAudio: "Upload audio",
      sendAsRecorded: "Send as live recorded audio",
      video: "Video",
      uploadVideo: "Upload video",
      text: "Text",
      message: "Message",
      interval: "Interval",
      timeInSeconds: "Time in seconds",
      document: "Document",
      uploadDocument: "Upload Document",
      viewDocument: "View Document",
      contentAdded: "Content added successfully!",
      deleteEmptyCards: "Delete empty cards (Image, Audio and Video)",
      emptyMessageFields: "Empty message fields!",
      intervalInvalid: "Interval cannot be 0 or greater than 120!",
      fileTooLargeImg: "File too large! 2MB maximum",
      fileTooLargeAudio: "File too large! 5MB maximum",
      fileTooLargeVideo: "File too large! 20MB maximum",
      fileTooLargeDoc: "File too large! 10MB maximum",
      browserNotSupported: "your browser does not support HTML5",
      variableLabels: {
        firstName: "First Name",
        name: "Name",
        userName: "Attendant",
        ms: "Greeting",
        protocol: "Protocol",
        date: "Date",
        hour: "Hour",
        ticket_id: "Ticket No.",
        queue: "Queue",
        connection: "Connection",
        phoneNumber: "Phone",
        email: "Email",
        kanban: "Kanban",
      },
    },
    flowBuilderGemini: {
      title: "Add Gemini to flow",
      editTitle: "Edit flow Gemini",
      add: "Add",
      save: "Save",
      cancel: "Cancel",
      basicSettings: "Basic Settings - Google Gemini",
      assistantName: "Assistant Name",
      apiKey: "Google AI API Key",
      model: "Gemini Model",
      systemPrompt: "System Prompt",
      systemPromptPlaceholder: "Describe how the AI should behave, what information to collect, how to respond...",
      temperature: "Temperature",
      temperatureHelper: "0 = conservative, 2 = creative",
      maxTokens: "Max Tokens",
      maxTokensHelper: "Maximum response size",
      maxMessages: "Max Messages",
      maxMessagesHelper: "Context history",
      flowBehavior: "Flow Behavior",
      flowBehaviorTooltip: "Configure how Gemini should behave in the flow",
      operationMode: "Operation Mode",
      permanent: "Permanent",
      permanentDesc: "End flow here",
      permanentHelper: "The user keeps chatting with the AI until requesting transfer or closing",
      temporary: "Temporary",
      temporaryDesc: "Returns to flow after",
      temporaryHelper: "The AI performs a specific task and then returns to the normal flow",
      temporarySettings: "Temporary Mode Settings",
      temporarySettingsDesc: "Configure when the AI should stop and return to the flow",
      maxInteractions: "Maximum Interactions",
      maxInteractionsHelper: "Maximum number of messages before returning to flow (0 = unlimited)",
      timeout: "Timeout (minutes)",
      timeoutHelper: "Time limit before returning to flow (0 = no limit)",
      continueKeywords: "Keywords to Continue Flow",
      keywordPlaceholder: "Type a keyword",
      addKeyword: "Add",
      keywordsHelper: "When the user sends one of these words, the flow will continue automatically",
      objective: "AI Objective",
      objectiveHelper: "Describe what the AI should complete (e.g. 'Collect name, email and phone')",
      objectivePlaceholder: "E.g.: Collect customer data, Qualify interest, Diagnose problem...",
      autoComplete: "Auto complete when objective is reached",
      autoCompleteHelper: "The AI will automatically analyze if it completed the objective and return to the flow",
      validation: {
        tooShort: "Too short!",
        tooLong: "Too long!",
        required: "Required",
        describeTraining: "Describe the training for Artificial Intelligence",
        invalidModel: "Invalid model",
        informModel: "Inform the model",
        minTokens: "Minimum 10 tokens",
        maxTokens: "Maximum 8000 tokens",
        informMaxTokens: "Inform the maximum number of tokens",
        minTemp: "Minimum 0",
        maxTemp: "Maximum 2",
        informTemp: "Inform the temperature",
        informApiKey: "Inform the API Key",
        minMessages: "Minimum 1 message",
        maxMessages: "Maximum 100 messages",
        informMaxMessages: "Inform the maximum number of messages",
        invalidFlowMode: "Invalid flow mode",
        selectFlowMode: "Select the flow mode",
        minInteraction: "Minimum 1 interaction",
        maxInteraction: "Maximum 50 interactions",
        minTimeout: "Minimum 1 minute",
        maxTimeout: "Maximum 60 minutes",
        keywordRequired: "Keyword cannot be empty",
        atLeastOneKeyword: "At least one keyword is required in temporary mode",
        objectiveRequired: "Objective is required when auto complete is active",
      },
    },
    flowBuilderOpenAI: {
      title: "Add OpenAI to flow",
      editTitle: "Edit flow OpenAI",
      add: "Add",
      save: "Save",
      cancel: "Cancel",
      basicSettings: "Basic Settings - OpenAI",
      assistantName: "Assistant Name",
      apiKey: "OpenAI API Key",
      model: "OpenAI Model",
      systemPrompt: "System Prompt",
      systemPromptPlaceholder: "Describe how the AI should behave, what information to collect, how to respond...",
      temperature: "Temperature",
      temperatureHelper: "0 = conservative, 2 = creative",
      maxTokens: "Max Tokens",
      maxTokensHelper: "Maximum response size",
      maxMessages: "Max Messages",
      maxMessagesHelper: "Context history",
      voiceSettings: "Voice Settings (Optional)",
      responseType: "Response Type",
      textOnly: "Text Only",
      voiceKeyLabel: "Voice Key (Azure)",
      voiceKeyPlaceholder: "Azure Speech Service Key",
      voiceRegionLabel: "Voice Region (Azure)",
      voiceRegionPlaceholder: "e.g. brazilsouth",
      flowBehavior: "Flow Behavior",
      flowBehaviorTooltip: "Configure how OpenAI should behave in the flow",
      operationMode: "Operation Mode",
      permanent: "Permanent",
      permanentDesc: "End flow here",
      permanentHelper: "The user keeps chatting with the AI until requesting transfer or closing",
      temporary: "Temporary",
      temporaryDesc: "Returns to flow after",
      temporaryHelper: "The AI performs a specific task and then returns to the normal flow",
      temporarySettings: "Temporary Mode Settings",
      temporarySettingsDesc: "Configure when the AI should stop and return to the flow",
      maxInteractions: "Maximum Interactions",
      maxInteractionsHelper: "Maximum number of messages before returning to flow (0 = unlimited)",
      timeout: "Timeout (minutes)",
      timeoutHelper: "Time limit before returning to flow (0 = no limit)",
      continueKeywords: "Keywords to Continue Flow",
      keywordPlaceholder: "Type a keyword",
      addKeyword: "Add",
      keywordsHelper: "When the user sends one of these words, the flow will continue automatically",
      objective: "AI Objective",
      objectiveHelper: "Describe what the AI should complete (e.g. 'Collect name, email and phone')",
      objectivePlaceholder: "E.g.: Collect customer data, Qualify interest, Diagnose problem...",
      autoComplete: "Auto complete when objective is reached",
      autoCompleteHelper: "The AI will automatically analyze if it completed the objective and return to the flow",
      validation: {
        tooShort: "Too short!",
        tooLong: "Too long!",
        required: "Required",
        describeTraining: "Describe the training for Artificial Intelligence",
        invalidModel: "Invalid model",
        informModel: "Inform the model",
        minTokens: "Minimum 10 tokens",
        maxTokens: "Maximum 4000 tokens",
        informMaxTokens: "Inform the maximum number of tokens",
        minTemp: "Minimum 0",
        maxTemp: "Maximum 2",
        informTemp: "Inform the temperature",
        informApiKey: "Inform the API Key",
        minMessages: "Minimum 1 message",
        maxMessages: "Maximum 100 messages",
        informMaxMessages: "Inform the maximum number of messages",
        informVoice: "Inform the voice mode",
        voiceKeyRequired: "Voice Key is required for voice synthesis",
        voiceRegionRequired: "Voice Region is required for voice synthesis",
        invalidFlowMode: "Invalid flow mode",
        selectFlowMode: "Select the flow mode",
        minInteraction: "Minimum 1 interaction",
        maxInteraction: "Maximum 50 interactions",
        minTimeout: "Minimum 1 minute",
        maxTimeout: "Maximum 60 minutes",
        keywordRequired: "Keyword cannot be empty",
        atLeastOneKeyword: "At least one keyword is required in temporary mode",
        objectiveRequired: "Objective is required when auto complete is active",
      },
    },
    validation: {
      tooShort: "Too short!",
      tooLong: "Too long!",
      required: "Required",
      messageTooShort: "Message too short",
      nameTooShort: "name too short",
    },
    flowBuilderConditionModal: {
      addTitle: "Add condition to flow",
      editTitle: "Edit condition",
      add: "Add",
      save: "Save",
      conditionField: "Condition field (Enter only 1 key)",
      validationRule: "Validation rule",
      conditionValue: "Condition value to be analyzed",
    },
    flowBuilderTypebot: {
      addTitle: "Add Typebot to flow",
      editTitle: "Edit Typebot in flow",
      add: "Add",
      edit: "Edit",
      save: "Save",
    },
    flowBuilderSwitchFlow: {
      addTitle: "Add Flow Switch",
      editTitle: "Edit Flow Switch",
      add: "Add",
      edit: "Edit",
      save: "Save",
      chooseFlow: "Choose a flow",
    },
    flowBuilderRandomizer: {
      add: "Add",
      edit: "Edit",
    },
    flowBuilderRandomizerModal: {
      addTitle: "Add randomizer to flow",
      editTitle: "Edit randomizer",
      addIntervalError: "Percentage must be greater than 0",
      maxTimeError: "Percentage cannot be greater than 120",
    },
    flowBuilderMenu: {
      addTitle: "Add menu to flow",
      editTitle: "Edit flow menu",
      add: "Add",
      save: "Save",
      menuMessage: "Menu message",
      addOption: "Add option",
      digit: "Digit",
      typeOption: "Type the option",
    },
    flowBuilderInterval: {
      addTitle: "Add interval to flow",
      editTitle: "Edit interval",
      add: "Add",
      edit: "Edit",
      timeInSeconds: "Time in seconds",
      addIntervalError: "Interval must be greater than 0",
      maxTimeError: "Interval cannot be greater than 120",
    },
    flowBuilderRemoveTag: {
      addTitle: "Remove a tag from flow",
      editTitle: "Edit tag removal",
      addRemoval: "Add Removal",
      edit: "Edit",
      selectTagToRemove: "Select a tag to remove",
      noTagSelected: "No tag selected",
      chooseTag: "Choose a tag to remove from the contact",
      actionDescription: "This action will remove the selected tag from the contact when the flow is executed",
      selectTagError: "Select a tag to remove",
      title: "Remove Tag",
      tagNotSelected: "Tag not selected",
      removesTagFromContact: "Removes the tag from contact",
    },
    flowBuilderTicket: {
      add: "Add",
      edit: "Edit",
    },
    flowBuilderVideo: {
      addTitle: "Add video to flow",
      editTitle: "Edit video",
      add: "Add",
      save: "Save",
    },
    flowBuilderAudio: {
      addTitle: "Add audio to flow",
      editTitle: "Edit audio",
      add: "Add",
      save: "Save",
    },
    flowBuilderGeminiModal: {
      addTitle: "Add Gemini to flow",
      editTitle: "Edit Gemini in flow",
      add: "Add",
      save: "Save",
      cancel: "Cancel",
      basicSettings: "Basic Settings - Google Gemini",
      assistantName: "Assistant Name",
      geminiModel: "Gemini Model",
      systemPrompt: "System Prompt",
      systemPromptPlaceholder: "Describe how the AI should behave, what information to collect, how to respond...",
      temperature: "Temperature",
      temperatureHelper: "0 = conservative, 2 = creative",
      maxTokensLabel: "Max Tokens",
      maxTokensHelper: "Maximum response size",
      maxMessagesLabel: "Max Messages",
      maxMessagesHelper: "Context history",
      flowBehavior: "Flow Behavior",
      flowBehaviorTooltip: "Configure how Gemini should behave in the flow",
      operationMode: "Operation Mode",
      permanent: "Permanent",
      permanentDesc: "End flow here",
      permanentHelper: "The user keeps chatting with the AI until requesting transfer or closing",
      temporary: "Temporary",
      temporaryDesc: "Returns to flow after",
      temporaryHelper: "The AI performs a specific task and then returns to the normal flow",
      temporarySettings: "Temporary Mode Settings",
      temporarySettingsDesc: "Configure when the AI should stop and return to the flow",
      maxInteractions: "Maximum Interactions",
      maxInteractionsHelper: "Maximum number of messages before returning to flow (0 = unlimited)",
      timeoutLabel: "Timeout (minutes)",
      timeoutHelper: "Time limit before returning to flow (0 = no limit)",
      continueKeywords: "Keywords to Continue Flow",
      keywordPlaceholder: "Type a keyword",
      addKeyword: "Add",
      keywordsHelper: "When the user sends one of these words, the flow will continue automatically",
      objectiveLabel: "AI Objective",
      objectiveHelper: "Describe what the AI should complete (e.g. 'Collect name, email and phone')",
      objectivePlaceholder: "E.g.: Collect customer data, Qualify interest, Diagnose problem...",
      autoComplete: "Auto complete when objective is reached",
      autoCompleteHelper: "The AI will automatically analyze if it completed the objective and return to the flow",
      queueId: "Queue ID (for transfer)",
      queueIdHelper: "Queue ID to transfer to if user asks for agent (0 = don't transfer)",
    },
    interactiveMessageModal: {
      title: "Send Interactive Message",
      subtitle: "Send messages with buttons, lists, offers, PIX or links",
      templateActive: "📋 Template: {{name}}",
      cancel: "Cancel",
      send: "Send",
      sending: "Sending...",
      save: "Save",
      saveTemplate: "Save Template",
      saveAsTemplate: "Save as template",
      loadTemplate: "Load saved template",
      models: "Models",
      templateNameLabel: "Template name",
      templateNamePlaceholder: "E.g.: Welcome with buttons",
      saveCurrentConfig: "Save the current configuration as a reusable model for the type",
      noTemplates: "No templates saved for this type",
      templateLoaded: "Template \"{{name}}\" loaded",
      templateSaved: "Template saved!",
      templateRemoved: "Template removed",
      templateSaveError: "Error saving template",
      templateRemoveError: "Error removing",
      templateNameRequired: "Enter a name for the template",
      messageSent: "Interactive message sent!",
      messageError: "Error sending",
      fillMessageText: "Fill in the message text",
      addAtLeastOneButton: "Add at least one button",
      addAtLeastOneOption: "Add at least one option in the list",
      fillLatLong: "Fill in latitude and longitude",
      fillUrl: "Fill in the URL",
      fillPhone: "Fill in the phone number",
      fillPixKey: "Fill in the PIX key",
      addAtLeast2Options: "Add at least 2 options",
      addAtLeastOneCard: "Add at least one card",
      fillBillingDesc: "Fill in the billing description",
      pdfUploadError: "Error uploading PDF",
      pdfTooBig: "PDF too large (max. 16MB)",
      previewTitle: "Message Preview",
      billingDesc: "Billing description...",
      messageBody: "Message body...",
      tabs: {
        buttons: "Buttons",
        list: "List",
        billing: "Billing",
        offers: "Offers",
        pix: "PIX",
        url: "URL",
        call: "Call",
        location: "Location",
        carousel: "Carousel",
        catalog: "Catalog",
        poll: "Poll",
      },
      buttonsTab: {
        info: "Send up to 3 clickable buttons. The customer can tap a button to quickly respond.",
        messageText: "Message text *",
        footer: "Footer (optional)",
        buttonsMax: "Buttons (max. 3)",
        add: "Add",
        option: "Option",
      },
      listTab: {
        info: "Send a list with up to 10 options. The customer opens a menu to select.",
        messageText: "Message text *",
        footer: "Footer (optional)",
        buttonText: "Button text",
        sectionTitle: "Section title",
        title: "Title",
        description: "Description",
        addOption: "Add option",
        select: "Select",
      },
      offerTab: {
        info: "🏷️ Send an offer with title, price and description.",
        offerTitle: "Offer title",
        bodyText: "Description / Message body *",
        price: "Price (e.g.: $99.90)",
        additionalDetails: "Additional details",
        footer: "Footer (optional)",
      },
      pixTab: {
        info: "💰 Send formatted PIX data to the customer.",
        messageText: "Message text *",
        pixKey: "PIX Key *",
        pixKeyPlaceholder: "CPF, CNPJ, email, phone or random key",
        beneficiaryName: "Beneficiary name",
        city: "City",
        amount: "Amount",
      },
      urlTab: {
        info: "🔗 Send a clickable link with custom text.",
        messageText: "Message text *",
        linkText: "Link text",
        linkPlaceholder: "Click here",
        url: "URL *",
        footer: "Footer (optional)",
      },
      callTab: {
        info: "📞 Send a message with a phone number for calling.",
        messageText: "Message text *",
        buttonText: "Button text",
        buttonPlaceholder: "Call now",
        phone: "Phone number *",
      },
      locationTab: {
        info: "📍 Send a location to the customer.",
        messageText: "Message text",
        locationName: "Location name",
        address: "Address",
        latitude: "Latitude *",
        longitude: "Longitude *",
      },
      carouselTab: {
        info: "🎠 Send multiple cards as a carousel.",
        messageText: "Message text *",
        card: "Card",
        title: "Title",
        description: "Description",
        addCard: "Add card",
      },
      catalogTab: {
        info: "🛍️ Send catalog products as cards.",
        messageText: "Message text *",
        product: "Product",
        productName: "Product name",
        descriptionPrice: "Description / Price",
        addProduct: "Add product",
      },
      pollTab: {
        info: "📊 Create a poll for the customer to vote.",
        officialNote: "(Will be sent as formatted text in the Official API)",
        question: "Poll question *",
        optionsMinMax: "Options (min. 2, max. 12)",
        add: "Add",
        option: "Option",
      },
      billingTab: {
        info: "🧾 Send a bill with payment details and \"Review and pay\" button.",
        billingNumber: "Billing number",
        billingDesc: "Billing description *",
        billingDescPlaceholder: "Child support billing",
        quantity: "Quantity",
        totalAmount: "Total amount *",
        customMessage: "Custom message",
        footer: "Footer (optional)",
        attachPdf: "📄 Attach PDF / Invoice (optional)",
        selectPdf: "Select PDF",
        paymentButton: "Payment button",
        buttonText: "Button text",
        paymentUrl: "Payment URL (optional)",
        paymentUrlHelper: "If filled, the button will be a clickable link (CTA URL)",
        reviewAndPay: "Review and pay",
        total: "Total",
        billingNumberLabel: "BILLING NUMBER",
      },
    },
    pairingCodeModal: {
      title: "📱 Connect via Pairing Code",
      instructions: "Enter the WhatsApp number with",
      countryCode: "country code + area code",
      example: "Example:",
      phoneLabel: "WhatsApp Number",
      phonePlaceholder: "+1 (555) 999-8888",
      digitsCount: "{{count}}/13 digits — country code + area code + number",
      generateCode: "Generate Code",
      tryAgain: "Try Again",
      close: "Close",
      cancel: "Cancel",
      connected: "Connected!",
      connectedDesc: "WhatsApp paired successfully. The modal will close automatically.",
      alreadyConnected: "✅ WhatsApp is already connected!",
      codeNotReturned: "Pairing code not returned by the server.",
      codeGenerated: "🔑 Code generated! Enter it in your WhatsApp within 60 seconds.",
      whatsappInstructions: "In your WhatsApp, go to:",
      whatsappSteps: "Settings → Linked Devices → Link a device",
      tapLinkPhone: "Tap on",
      linkWithPhone: "Link with phone number",
      enterCodeExact: "and enter the code exactly as displayed (no spaces):",
      waitingCode: "Waiting for code...",
      enterCodeInWhatsapp: "Enter the code in WhatsApp",
      codeExpiring: "Code expiring!",
      waitingPairing: "Waiting for you to enter the code in WhatsApp...",
      syncingSession: "Syncing session... Almost there!",
      steps: {
        generateCode: "Generate code",
        enterCode: "Enter in WhatsApp",
        syncing: "Syncing",
        connected: "Connected",
      },
    },
    campaignContactSelector: {
      newListTitle: "New Contact List",
      stepName: "Name list",
      stepImport: "Import contacts",
      nameDescription: "Give a name to identify this contact list.",
      listName: "List name",
      namePlaceholder: "E.g.: VIP Clients, November Prospects...",
      charsCount: "{{count}}/50 characters",
      listCreated: "List \"{{name}}\" created! Now import contacts (optional).",
      dragExcel: "Drag Excel here or click to select",
      acceptedFormats: "Accepted formats: .xls, .xlsx",
      downloadTemplate: "📥 Download template spreadsheet (.xlsx)",
      close: "Close",
      cancel: "Cancel",
      skipImport: "Skip import",
      creating: "Creating...",
      createList: "Create List →",
      sending: "Sending...",
      importContacts: "Import Contacts",
      selectedForCampaign: "✓ List selected for this campaign",
      selectForCampaign: "Select this list for the campaign",
      backToCampaign: "Back to Campaign →",
      searchSystemContacts: "Search System Contacts",
      selected: "{{count}} selected",
      addingToList: "Adding to list: {{name}}",
      searchPlaceholder: "Search by name or number...",
      filterByTag: "Filter by tag:",
      clearFilters: "Clear ({{count}})",
      loadingTags: "Loading tags...",
      noTagsAvailable: "No tags available.",
      selectAll: "Select all ({{count}} displayed)",
      noContactsFound: "No contacts found.",
      tryAnotherSearch: "Try searching for another name or number.",
      name: "Name",
      number: "Number",
      loadMore: "Load more",
      cancelSearch: "Cancel",
      adding: "Adding...",
      addToList: "Add {{count}} to list",
      contactLists: "Contact Lists",
      createListsDesc: "Create lists, import contacts and select the list to be used in this campaign.",
      simpleList: "Simple List",
      newListExcel: "New List + Excel",
      selectedList: "Selected list: {{name}}",
      contactsCount: "{{count}} contacts — this list will be used in the campaign",
      remove: "Remove",
      searchList: "Search list...",
      noListsYet: "No lists created yet.",
      clickNewList: "Click \"New List\" to get started.",
      selectedBadge: "Selected",
      contacts: "contacts",
      alreadySelected: "List already selected",
      selectForCampaignTooltip: "Select for campaign",
      searchSystemContactsTooltip: "Search system contacts for this list",
      editList: "Edit list",
      deleteList: "Delete list",
      deleteListConfirm: "Delete list \"{{name}}\"?",
      listSelected: "List \"{{name}}\" selected for the campaign!",
      listRemoved: 'List removed successfully',
      importStarted: 'Import started! Contacts will be loaded shortly.',
      invalidFormat: 'Invalid format. Use only .xls or .xlsx files',
      fileUploaded: 'File uploaded! Contacts will be loaded shortly.',
      searchContact: 'Search contact...',
      selectThisList: 'Select this list for the campaign',
      listSelectedToast: 'List "{{name}}" selected for the campaign!',
      nameList: 'Name list',
      giveNameToList: 'Give a name to identify this contact list.',
      listNamePlaceholder: 'E.g.: VIP Clients, November Prospects...',
      characters: 'characters',
      searchByNameOrNumber: 'Search by name or number...',
      listAlreadySelected: 'List already selected',
      selectWhatsapp: 'Select a WhatsApp connection in the campaign before importing.',
    },
    contactsPage: {
      importFromPhone: "Import contacts from phone",
      selectConnection: "Select the WhatsApp connection from which you want to import contacts:",
      noConnectionFound: "No connected WhatsApp connection found.",
      selectAConnection: "Select a connection",
      noNumber: "no number",
      cancel: "Cancel",
      import: "Import",
      profilePhoto: "Profile Photo",
      imageNotAvailable: "Image not available",
      blockContact: "Block Contact {{name}}?",
      unblockContact: "Unblock Contact {{name}}?",
      contactBlocked: "Contact blocked",
      contactUnblocked: "Contact unblocked",
      deleteAll: "Delete All ({{count}})",
      deleteSelected: "Delete Selected ({{count}})",
      delete: "Delete",
      selectAtLeastOne: "Select at least one contact to delete",
      allDeleted: "All {{count}} contacts were deleted",
      selectedDeleted: "{{count}} contacts successfully deleted",
      importStarting: "Starting import...",
      importSuccess: "Contacts imported successfully!",
      notSynced: "Contacts not yet synced. Connect your phone and wait.",
      importError: "Error importing contacts",
    },
    kanbanCard: {
      assignValue: "Assign Value",
      value: "Value: {{value}}",
      remove: "Remove",
      viewTicket: "View Ticket",
      editValue: "Edit",
      assignValueTitle: "Assign Opportunity Value",
      editValueTitle: "Edit Opportunity Value",
      valueLabel: "Value",
      cancel: "Cancel",
      save: "Save",
      noName: "No name",
      noMessages: "No messages",
      pending: "Pending",
      addValue: "Add value",
      viewChat: "View conversation",
      slaOnTime: "On time",
      slaWarning: "Warning",
      slaOverdue: "Overdue",
    },
    kanbanColumn: {
      searchPlaceholder: "Search by name, number...",
      noResults: "No results",
      noTickets: "No tickets",
      slaOnTime: "On time",
      slaWarning: "Warning",
      slaOverdue: "Overdue",
      totalValue: "Total value",
    },
    kanbanChat: {
      statusOpen: "Open",
      statusPending: "Pending",
      statusClosed: "Closed",
      contact: "Contact",
      noQueue: "No queue",
      noMessages: "No messages yet",
      inputPlaceholder: "Type a message...",
    },
    tooltips: {
      edit: "Edit",
      delete: "Delete",
      report: "Report",
      syncTemplates: "Sync templates",
      copyWebhook: "Copy webhook",
    },
    telegram: {
      botTokenTitle: "🤖 Telegram Bot Token",
      botTokenHelp: "Create a bot on Telegram's @BotFather and paste the token here. The webhook will be configured automatically upon saving.",
      botTokenLabel: "Bot Token",
      webhookUrl: "Webhook URL",
      connectBot: "Connect Bot",
      chip: "TELEGRAM",
    },
    locationPreview: {
      openInMaps: "Open in Google Maps",
    },
    flowBuilderConditionCompare: {
      saving: "Saving...",
      saveChanges: "Save changes",
      add: "Add",
    },
    flowBuilderStart: {
      title: "Flow start",
      description: "This block marks the start of your flow!",
    },
    flowBuilderConditionCompareNode: {
      title: "If / Else",
      contains: "contains",
      notContains: "not contains",
      containsAny: "contains any",
      startsWith: "starts with",
      endsWith: "ends with",
      isEmpty: "empty",
      isNotEmpty: "not empty",
      regex: "regex",
      field: "field",
      value: "value",
      and: "AND",
      or: "OR",
      true: "True",
      false: "False",
    },
    flowBuilderHttpRequest: {
      title: "HTTP Request",
      preconfiguredWebhooks: "Pre-configured Webhooks",
      selectPreset: "Select preset",
      choosePreset: "Choose a ready-made configuration...",
      system: "SYSTEM",
      remove: "Remove",
      usingPreset: "Using preset:",
      urlFromPreset: "URL (from preset)",
      urlPlaceholder: "https://api.example.com/webhook",
      editPresetUrl: "You can edit the preset base URL if needed",
      method: "Method",
      testRequest: "Test Request",
      apiResponse: "API Response:",
      viewFullResponse: "View full response",
      hideAdvanced: "Hide advanced",
      showAdvanced: "Show advanced",
      advancedWarning: "Advanced settings may override preset settings",
      timeoutMs: "Timeout (ms)",
      queryParams: "Query Parameters",
      key: "Key",
      addParam: "Add Parameter",
      headersJson: "Headers (JSON)",
      requestBody: "Request body (JSON)",
      editRequestBody: "Edit request body",
      close: "Close",
      hideMapVars: "Hide Response Variables",
      showMapVars: "Map Response Variables",
      mapResponseData: "Map response data to variables",
      path: "Path",
      pathPlaceholder: "e.g.: data.user.id",
      variableName: "Variable name",
      variablePlaceholder: "e.g.: userId",
      addVariable: "Add variable",
      tips: "Useful tips:",
      tipAutoSave: "The complete API response is automatically saved in the global variable",
      tipVarUsage: "You can use ${variableName} in the URL and request body to include variable values.",
      requestError: "Request error",
      configSaved: "Configuration saved!",
      fullApiResponse: "Full API response",
      presetError: "Error applying preset configuration",
      value: "Value",
    },
    flowBuilderInteractiveNode: {
      title: "Interactive API Msg",
      buttons: "Buttons",
      maxButtons: "max. 3",
      messageBody: "Message body...",
      select: "Select",
      button: "Button",
      item: "Item",
    },
    flowBuilderVariable: {
      title: "Global Variable",
      variableName: "Variable name",
      value: "Value",
      helperText: "You can use static values or references like ${anotherVariable}",
      saved: "Saved!",
      saveVariable: "Save variable",
      variableSavedSuccess: "Variable saved successfully!",
    },
    flowBuilderAiAgent: {
      title: "AI Agent",
      selectAgent: "Select an agent",
    },
    flowBuilderAttendant: {
      title: "Attendant",
    },
    flowBuilderAudioNode: {
      title: "Audio",
      recordedLive: "Recorded live",
      audioSent: "Audio sent",
    },
    flowBuilderVideoNode: {
      title: "Video",
    },
    flowBuilderMessageNode: {
      title: "Message",
    },
    flowBuilderConditionNode: {
      title: "Condition",
    },
    flowBuilderImageNode: {
      title: "Image",
    },
    flowBuilderInputNode: {
      title: "Input",
      question: "Question:",
      questionNotDefined: "Question not defined",
      variableToStore: "Variable to store response:",
      variableNotDefined: "Variable not defined",
      usingVariables: "Using variables:",
      alwaysAsk: "Always ask (even if variable already exists)",
    },
    flowBuilderMenuNode: {
      title: "Numeric Menu",
    },
    flowBuilderIntervalNode: {
      title: "Interval",
    },
    flowBuilderRandomizerNode: {
      title: "Randomizer",
    },
    flowBuilderSingleBlockNode: {
      title: "Content",
    },
    flowBuilderSwitchFlowNode: {
      title: "Switch Flow",
    },
    flowBuilderTypebotNode: {
      title: "TypeBot",
    },
    flowBuilderQuestionNode: {
      title: "Question",
    },
    flowBuilderTagNode: {
      title: "Tag",
    },
    flowBuilderTicketNode: {
      title: "Queue",
    },
    flowBuilderAiAgentModal: {
      addTitle: "Add AI Agent",
      editTitle: "Edit AI Agent",
      add: "Add",
      save: "Save",
      cancel: "Cancel",
      selectAgent: "Select an AI Agent",
      agentLabel: "AI Agent",
      selectPlaceholder: "Select...",
      subtitle: "Select an active agent to use in this flow",
      noAgentsFound: "No active agents found. Create an agent on the \"AI Agents\" page.",
      defaultAgentName: "AI Agent",
    },
    flowBuilderValidation: {
      tooShort: "Too short!",
      tooLong: "Too long!",
      enterName: "Enter a name!",
      enterMessage: "Enter a message!",
      required: "Required",
    },
    audioTranscription: {
      transcription: "Transcription:",
      transcribing: "Transcribing...",
      transcribe: "Transcribe",
      failed: "Text conversion failed",
    },
    birthdayModal: {
      congratulations: "🎉 Congratulations!",
      specialDay: "Today is a special day!",
      loading: "Loading birthdays...",
      youLabel: "(You!)",
      systemUser: "System User",
      contact: "Contact",
      sending: "Sending...",
      messageSent: "Message already sent",
      sendCongrats: "Send Congrats",
      remindLater: "Remind me later",
      understood: "Got it, thanks!",
      year: "year",
      years: "years",
      notAvailable: "N/A",
      toasts: {
        sent: "Birthday message sent to {{name}}! 🎉",
        alreadySent: "Birthday message has already been sent today for this contact",
        loadError: "Error loading birthdays",
        sendError: "Error sending birthday message",
      },
    },
    birthdaySettings: {
      title: "🎂 Birthday Settings",
      loading: "Loading settings...",
      userSection: "User Birthdays",
      contactSection: "Contact Birthdays",
      generalSection: "General Settings",
      enableUserNotifications: "Enable user birthday notifications",
      enableUserNotificationsHelp: "When enabled, a congratulations modal will be displayed and an automatic announcement will be created",
      createAnnouncementUsers: "Create automatic announcement for user birthdays",
      createAnnouncementUsersHelp: "Creates an automatic announcement displayed to all company users",
      userBirthdayMessage: "Birthday message for users",
      userMessageHelper: "Use {nome} to include the user's name",
      enableContactMessages: "Enable automatic birthday messages for contacts",
      enableContactMessagesHelp: "Automatically sends birthday messages via WhatsApp to contacts",
      contactBirthdayMessage: "Birthday message for contacts",
      contactMessageHelper: "Use {nome} for the contact's name and {idade} for age",
      testMessage: "Test Message",
      sendTime: "Message sending time",
      sendTimeHelper: "Time when automatic messages will be sent",
      whatsappConnection: "WhatsApp Connection for Sending",
      selectConnection: "Select a connection",
      whatsappConnectionHelp: "WhatsApp connection used to send birthday messages",
      createInternalAnnouncement: "Create internal announcement for user birthdays",
      createInternalAnnouncementHelp: "Creates an internal announcement when a user has a birthday",
      availableVariables: "Available variables in messages:",
      varName: "Person's name",
      varAge: "Person's age (contacts only)",
      preview: "Preview:",
      saving: "Saving...",
      saveSettings: "Save Settings",
      toasts: {
        saved: "Birthday settings saved successfully! 🎉",
        loadError: "Error loading birthday settings",
        saveError: "Error saving settings",
        testSent: "Test message sent! 📱",
        testError: "Error sending test message",
      },
    },
    campaignModal: {
      tabCampaign: "Campaign",
      tabContactLists: "📋 Contact Lists",
      tabSettings: "⚙️ Settings",
      selectTemplateRequired: "Select an approved template for Official API campaigns.",
      noTemplateFound: "No approved templates found. Create a template before sending.",
      templateRequired: "Required for Official API. Messages without template fail outside the 24h window.",
      apiOfficialLabel: "Official API",
      recurrenceTitle: "Recurrence Configuration",
      enableRecurrence: "Enable recurrence",
      recurrenceType: "Recurrence Type",
      minutely: "Per Minute",
      hourly: "Per Hour",
      daily: "Daily",
      weekly: "Weekly",
      biweekly: "Biweekly",
      monthly: "Monthly",
      yearly: "Yearly",
      interval: "Interval",
      everyInterval: "Every {{count}} {{unit}}",
      minuteUnit: "minute(s)",
      hourUnit: "hour(s)",
      dayUnit: "day(s)",
      weekUnit: "week(s)",
      biweekUnit: "fortnight(s)",
      monthUnit: "month(s)",
      yearUnit: "year(s)",
      daysOfWeek: "Days of Week",
      dayOfMonth: "Day of Month",
      dayOfMonthHelper: "Specific day of the month (1-31)",
      endDate: "End Date (optional)",
      emptyRecurrence: "Leave empty for infinite recurrence",
      maxExecutions: "Max Executions (optional)",
      hideExecutions: "Hide",
      showExecutions: "Show",
      nextExecutions: "Next Executions",
      next5Executions: "Next 5 Executions:",
      nthExecution: "{{n}}th Execution",
      campaignMessage: "Campaign Message",
      apiOfficialNote: "For Official API, use the template selected on the side. Message field and media attachment are not available.",
      apiOfficialNoFollowUp: "⚠️ Follow-up is available only for Baileys channels. On Official API campaigns, only the template is sent.",
      attachMedia: "Attach Media",
      messageVariableHelper: "Use variables like {nome}, {numero}, {email} or define custom variables.",
      varName: "Name",
      varNumber: "Number",
      varEmail: "Email",
      varGreeting: "Greeting",
      varProtocol: "Protocol",
      varFirstName: "First Name",
      varAgent: "Agent",
      contactListTitle: "📋 Campaign Contact List",
      contactListDesc: "Select a list created in the \"📋 Contact Lists\" tab. The list defines who will receive this campaign's messages.",
      contactList: "Contact List",
      noListSelected: "No list selected",
      contacts: "contacts",
      filterByTag: "Filter by Tag (optional)",
      noTagFilter: "No tag filter",
      switchList: "Switch list → Go to Contact Lists",
      createOrSelectList: "+ Create or select list in Contact Lists tab",
      dispatchIntervals: "Dispatch Intervals",
      dispatchIntervalsDesc: "Configure time intervals between dispatches to avoid blocks.",
      antiBan: "Anti-Ban",
      antiBanDesc: "Humanizes dispatching to reduce block risk",
      jitterLabel: "Random variation (jitter)",
      jitterFixed: "fixed",
      jitterMax: "maximum",
      jitterBase: "Base {{base}}s → between {{min}}s and {{max}}s",
      jitterSelectBase: "⚠️ Select a base interval above",
      extraPauseEvery: "Extra pause every N msgs",
      disabled: "Disabled",
      everyNMessages: "Every {{n}} messages",
      extraPauseDuration: "Extra pause duration",
      seconds: "seconds",
      minute1: "1 minute",
      minutes2: "2 minutes",
      minutes5: "5 minutes",
      settingsSaved: "Settings saved successfully!",
      daysOfWeekOptions: {
        sunday: "Sunday",
        monday: "Monday",
        tuesday: "Tuesday",
        wednesday: "Wednesday",
        thursday: "Thursday",
        friday: "Friday",
        saturday: "Saturday",
      },
      autoListName: "Campaign - {{name}} - {{date}}",
      noName: "No name",
      followUp: {
        toggle: "Send message after template",
        delayLabel: "Delay between messages",
        description: "Messages sent in sequence after the template (within the 24h window).",
        multipleHelp: "Fill in only the messages you want to send. They will be sent in sequence. Media is sent with the 1st message.",
        windowWarningTitle: "Meta's 24-hour window",
        windowWarningBody: "Messages 2 to 5 will only be sent AFTER the customer replies to the template. The WhatsApp Official API requires a customer reply to open a 24-hour messaging window. If the customer doesn't reply, only the template will be delivered.",
        delay3s: "3 seconds",
        delay5s: "5 seconds",
        delay10s: "10 seconds",
        delay30s: "30 seconds",
        delay60s: "1 minute",
        useApprovedTemplate: "Use approved template",
        noSimpleTemplate: "No simple template available",
        selectApprovedTemplate: "Select an approved template",
        simpleTemplateHelper: "Only approved templates without variables appear here. Header media (if any) is part of the template.",
        metaRestrictionTitle: "Meta restriction — 24h window",
        metaRestrictionBody: "You filled in additional messages (2-5) in an Official API campaign. Meta only allows sending these messages after the customer replies to the initial template, within a 24-hour window.",
        metaRestrictionEnableHint: "Enable the \"Send message after template\" switch below, otherwise messages 2-5 will not be sent.",
      },
    },
    campaignModalPhrase: {
      campaignName: "Campaign name",
      nameRequired: "Name is required",
      selectFlow: "Select a flow",
      flowRequired: "Flow is required",
      connections: "WhatsApp Connections",
      connectionsMultiple: "(Multiple)",
      atLeastOneConnection: "You must select at least one connection",
      connectionsSelected: "{{count}} connection(s) selected:",
      connectionsInfo: "The campaign will run whenever any connection receives messages matching the configured phrases.",
      filterByTag: "Filter by Contact Tag",
      optional: "(optional)",
      filterByTagDesc: "If selected, the flow will only trigger for contacts that have at least one of these tags.",
      tagsLabel: "Tags (optional)",
      filterActive: "🏷️ Filter active: flow will only trigger for contacts with at least one of the {{count}} selected tag(s).",
      triggerKeywords: "Keywords that trigger the flow",
      logicOr: "🔀 OR logic: the flow triggers if the contact sends any of the words/phrases below.",
      exactLabel: "Exact: identical message.",
      partialLabel: "Partial: word contained anywhere in the message.",
      orChip: "OR",
      phraseLabel: "Word/phrase {{index}}",
      phrasePlaceholder: "E.g.: hi, I want a quote...",
      fieldRequired: "Required field",
      typeLabel: "Type",
      exact: "Exact",
      partial: "Partial",
      addPhrase: "+ Add another word/phrase (OR)",
      active: "Active",
      inactive: "Inactive",
      saving: "Saving...",
      update: "Update",
      create: "Create",
      fillAllFields: "Please fill in all required fields",
      flowNotFound: "Selected flow not found",
      toasts: {
        updated: "Campaign updated!",
        created: "Campaign created!",
        saveError: "Error saving campaign",
        loadFlowsError: "Error loading flows",
        loadConnectionsError: "Error loading connections",
        loadDataError: "Error loading campaign data",
      },
    },
    contactNotes: {
      deleteTitle: "Delete Record",
      deleteConfirm: "Are you sure you want to delete this record?",
      noteAdded: "Note added successfully!",
      noteDeleted: "Note deleted successfully!",
      cancel: "Cancel",
      save: "Save",
      close: "Close",
    },
    contactDeleteConfirm: {
      titleAll: "Delete ALL {{count}} contacts?",
      titleSelected: "Delete {{count}} selected contacts?",
      warningAll: "⚠️ WARNING: This action will permanently delete ALL {{count}} contacts from the company!",
      warningAllBody: "This operation cannot be undone. All contacts, their message histories, tags and relationships will be permanently lost.",
      warningSelected: "This action will permanently delete {{count}} selected contacts.",
      warningSelectedBody: "Selected contacts and their related data will be permanently deleted.",
      confirmPrompt: "To confirm, type exactly:",
      confirmLabel: "Confirmation",
      cancel: "Cancel",
      deleteAll: "Delete All",
      deleteSelected: "Delete Selected",
      expectedAll: "DELETE ALL",
      expectedSelected: "DELETE SELECTED",
      typeExact: "Type exactly: {{text}}",
    },
    colorBoxModal: {
      title: "Choose a color",
      cancel: "Cancel",
      ok: "OK",
    },
    contactGroupModal: {
      title: "Create Contact Group",
      groupName: "Group Name",
      groupNamePlaceholder: "E.g.: VIP Clients, January Leads...",
      searchPlaceholder: "Search contacts...",
      selectedCount: "{{count}} contact(s) selected",
      clearSelection: "Clear selection",
      name: "Name",
      number: "Number",
      email: "Email",
      tags: "Tags",
      noContacts: "No contacts found",
      perPage: "Per page:",
      displayedRows: "{{from}}-{{to}} of {{count}}",
      cancel: "Cancel",
      creating: "Creating...",
      createGroup: "Create Group ({{count}} contacts)",
      groupNameRequired: "Please enter a group name",
      selectAtLeastOne: "Select at least one contact",
      groupCreated: "Group \"{{name}}\" created with {{count}} contacts",
    },
    contactListTable: {
      name: "Name",
      contacts: "Contacts",
      actions: "Actions",
    },
    contactTagListModal: {
      contacts: "Contacts",
      id: "ID",
      name: "Name",
      number: "Number",
      actions: "Actions",
    },
    contactsFilter: {
      placeholder: "Contacts",
    },
    contactImport: {
      fields: {
        name: "Name",
        number: "Number",
        email: "Email",
        birthDate: "Birth Date",
        tags: "Tags",
        wallet: "Wallet",
      },
      errors: {
        noNumber: "Contact number field was not selected",
        noName: "Contact name field was not selected",
        noSelection: "No contacts selected",
        fieldAlreadySelected: "The field {{field}} has already been selected.",
      },
      results: {
        title: "Import Result",
        created: "✅ {{count}} contacts created successfully",
        ignored: "⚠️ {{count}} contacts ignored (invalid number or not marked for update)",
        successAll: "Import completed successfully! {{count}} contacts imported.",
        successPartial: "Import completed: {{created}} contacts imported and {{ignored}} ignored.",
        failed: "Import failed. No contacts were imported.",
        importMore: "Import more contacts",
      },
      validateSwitch: "Validate contacts on WhatsApp",
      uploading: "Importing... Please wait",
      importButton: "Import contacts",
      cancel: "Cancel",
      processing: "Processing file...",
      invalidFile: "Invalid file!",
      invalidFileDesc: "The file you tried to import is not valid. Please try again with a file in the correct format.",
      tryAgain: "Try again",
      dropzoneTitle: "Click or drag an Excel file",
      dropzoneFormats: "* Accepted formats: xls, xlsx, csv, txt",
      dropzoneHelp: "To import contacts, you must have at least the name and phone number columns.",
      back: "Back",
    },
    contactImportWpModal: {
      importingPhone: "Importing phone contacts...",
      importPhoneButton: "📱 Import phone contacts (WhatsApp)",
      phoneImported: "Phone contacts imported successfully!",
      statusInProgress: "import in progress {{current}} of {{total}} do not leave this screen until import is complete",
      statusComplete: "import completed successfully",
    },
    contactDrawer: {
      noParticipants: "No participants found",
      chat: "Chat",
      superAdmin: "Super Admin",
      admin: "Admin",
      participant: "Participant",
      searching: "Searching...",
      noMessages: "No messages found",
      searchPlaceholder: "Search messages...",
      infoTab: "Information",
      imagesTab: "Images",
      videosTab: "Videos",
      audiosTab: "Audios",
      documentsTab: "Documents",
      linksTab: "Links",
      participantsTab: "Participants",
      noImages: "No images found",
      noVideos: "No videos found",
      noAudios: "No audios found",
      noDocs: "No documents found",
      noLinks: "No links found",
      contactUpdated: "Contact updated successfully!",
      contactBlocked: "Contact blocked",
      contactUnblocked: "Contact unblocked",
      blockTooltip: "Block contact",
      unblockTooltip: "Unblock contact",
      lidWarning: "⚠️ Possible error: Number appears to be LID",
      you: "(You)",
      exportParticipants: "Export Participants",
      noParticipantsExport: "No participants to export",
      exportSuccess: "File \"{{name}}\" exported successfully!",
      noName: "No name",
    },
    companiesManager: {
      generateInvoice: "Generate Invoice",
      yes: "Yes",
      no: "No",
      loadError: "Unable to load records list",
      operationSuccess: "Operation completed successfully!",
      operationError: "Unable to perform the operation. Check if a company with the same name already exists or if all fields are filled correctly",
      deleteError: "Unable to perform the operation",
    },
    birthdaySettingsPage: {
      title: "🎂 Birthday Settings",
    },
    groupManager: {
      title: "Group Manager",
      groups: "Groups",
      refresh: "Refresh",
      sync: "Sync Groups",
      syncing: "Syncing...",
      clearAll: "Clear all groups",
      selectConnection: "Select a connection",
      selectConnectionFirst: "Select a connection to start",
      clickSyncToLoad: "Click Sync to load groups",
      connection: "Connection",
      allConnections: "All connections",
      searchGroup: "Search group...",
      noGroupsFound: "No groups found",
      noName: "No name",
      connectionLabel: "Connection {{id}}",
      selectGroup: "Select a group",
      selectGroupDesc: "Choose a group from the list to manage",
      participants: "participants",
      groupActions: "Group Actions",
      changeName: "Change name",
      changeNameDesc: "Change the group name",
      changeDescription: "Change description",
      changeDescriptionDesc: "Edit the group description",
      inviteLink: "Invite link",
      inviteLinkDesc: "Generate or copy sharing link",
      addParticipants: "Add participants",
      addParticipantsDesc: "Add by phone number",
      sendMessage: "Send message",
      sendMessageDesc: "Send message to group with ghost mention",
      settings: "Settings",
      onlyAdminsSend: "Only admins send",
      onlyAdminsSendDesc: "Only administrators can send messages",
      restrictEdit: "Restrict editing",
      restrictEditDesc: "Only admins can edit group info",
      participantsCount: "Participants ({{count}})",
      creator: "Creator",
      admin: "Admin",
      demoteAdmin: "Demote from admin",
      promoteAdmin: "Promote to admin",
      removeFromGroup: "Remove from group",
      dialogChangeName: "Change group name",
      groupName: "Group name",
      cancel: "Cancel",
      save: "Save",
      dialogChangeDesc: "Change group description",
      description: "Description",
      dialogInviteLink: "Invite link",
      close: "Close",
      dialogAddParticipants: "Add participants",
      phoneNumbers: "Phone number(s)",
      phoneNumbersPlaceholder: "5521999999999 (separate by comma for multiple)",
      phoneNumbersHelper: "Enter the number with country+area code, no spaces. E.g.: 5521999999999",
      add: "Add",
      dialogSendMessage: "Send message to group",
      message: "Message",
      mentionAll: "Mention all participants (ghost mention)",
      send: "Send",
      confirmRemoveParticipant: "Are you sure you want to remove this participant?",
      toasts: {
        loadError: "Error loading groups",
        selectConnectionFirst: "Select a connection first",
        syncSuccess: "{{count}} groups synced!",
        metadataError: "Error loading group data",
        nameUpdated: "Group name updated!",
        nameError: "Error updating group name",
        descUpdated: "Description updated!",
        descError: "Error updating description",
        inviteLinkError: "Error generating invite link",
        linkCopied: "Link copied!",
        participantAdded: "Participant(s) added!",
        participantAddError: "Error adding participant",
        messageSent: "Message sent!",
        messageError: "Error sending message",
        settingUpdated: "Setting updated!",
        settingError: "Error updating setting",
        participantRemoved: "Participant removed!",
        removeError: "Error removing participant",
        promoted: "Participant promoted to admin!",
        promoteError: "Error promoting participant",
        demoted: "Admin demoted!",
        demoteError: "Error demoting participant",
      },
    },
    contactImportPage: {
      title: "Import contacts from file",
    },
    forwardMessageModal: {
      title: "Forward message",
      noContactFound: "No contact found with the name {{name}}",
      sending: "Sending {{id}}...",
      forward: "Forward",
    },
    newTicketModal: {
      selectQueue: "Select a queue",
      selectConnection: "Select a Connection",
      createAndSendTemplate: "Create and Send Template",
    },
    finalizacaoVendaModal: {
      title: "Service Finalization - Sale Value",
      loading: "Loading settings...",
      saleCompleted: "Was the sale completed?",
      yes: "Yes, sale completed",
      no: "No, sale not completed",
      saleValue: "Sale Value",
      noSaleReason: "Reason for No Sale *",
      finalizationReason: "Finalization Reason *",
      selectReason: "Select a reason",
      cancel: "Cancel",
      finalizing: "Finalizing...",
      finalize: "Finalize Service",
      errorSaleValue: "Please enter the sale value.",
      errorNoSaleReason: "Please select the reason for no sale.",
      errorFinalizationReason: "Please select the finalization reason.",
    },
    forbiddenPage: {
      title: "403",
      message: "Oops! Access Denied!",
      back: "Go Back",
    },
    showTicketLogModal: {
      close: "Close",
    },
    showTicketOpenModal: {
      close: "Close",
    },
        backupRestore: {
          backupTitle: "Database Backup",
          backupDescription: "Download a full copy of the database. Choose the desired format:",
          backupSQL: "SQL Backup (.sql)",
          backupJSON: "JSON Backup (.json)",
          generating: "Generating...",
          tip: "SQL backup is ideal for full restoration. JSON backup is useful for data analysis and migration.",
          restoreTitle: "Restore Database",
          dangerZone: "Danger zone",
          dangerDescription: "Restoration will overwrite all current database data. Make sure you have an updated backup before proceeding.",
          restoring: "Restoring...",
          uploadRestore: "Upload .sql file to restore",
          confirmRestore: "⚠️ WARNING: Restoration will overwrite current database data. Are you sure you want to continue? We recommend making a backup first.",
          important: "Important",
          importantText: "After restoring the backup, restart the server so that Redis/Bull connections are properly recreated.",
          toasts: {
            sqlSuccess: "SQL Backup downloaded successfully!",
            sqlError: "Error generating SQL backup.",
            jsonSuccess: "JSON Backup downloaded successfully!",
            jsonError: "Error generating JSON backup.",
            sqlOnly: "Only .sql files are accepted for restoration.",
            restoreSuccess: "Database restored successfully! Reload the page.",
            restoreError: "Error restoring the database.",
          },
        },
        smtpSettings: {
          title: "SMTP Settings",
          description: "Configure the email server for sending password recovery codes and notifications.",
          server: "SMTP Server",
          port: "Port",
          secure: "Secure connection (SSL/TLS on port 465)",
          secureHelp: "Enable to use direct SSL/TLS (port 465). Disabled uses STARTTLS (port 587).",
          senderEmail: "Sender Email",
          senderName: "Sender Name",
          senderNameHelp: "Ex.: Equipechat. The sender email will be the field above.",
          authentication: "Authentication",
          authMethod: "Authentication Method",
          password: "Password (Default)",
          passwordLabel: "Password",
          gmailHelp: "For Gmail, use an \"App Password\" generated at myaccount.google.com/apppasswords",
          save: "Save",
          testConfig: "Test Configuration",
          testEmail: "Test email",
          sendTest: "Send Test",
          toasts: {
            saveSuccess: "SMTP settings saved successfully!",
            saveError: "Error saving SMTP settings.",
            emailRequired: "Enter an email for testing.",
            testSuccess: "Test email sent successfully!",
            testError: "Failed to send test email. Check the settings.",
          },
        },
        uploaderCert: {
          noPermission: "No permission to access!",
          p12Only: "Only use p12 format files!",
          chooseFile: "Choose a file!",
          chooseDestination: "Choose a destination!",
          uploadSuccess: "File uploaded successfully!",
          tabLabel: "Efí Certificate - PIX API (p12)",
          chooseOption: "Choose an option:",
          certOption: "Efí Certificate p12 PIX API",
          chooseCert: "Choose Efí Certificate p12 PIX API",
          submit: "UPLOAD CERTIFICATE",
        },
        triggerFlowModal: {
          selectRequired: "Select a flow to trigger",
          success: "Flow triggered successfully!",
          processingMessage: "Triggering flow... Message field temporarily disabled.",
        },
        queueOptions: {
          titlePlaceholder: "Option title",
          untitled: "Title not defined",
          messagePlaceholder: "Enter option text",
          add: "Add",
          options: "Options",
        },
        flowBuilderAudio: {
          toasts: {
            success: "Audio added successfully!",
            fileTooLarge: "File is too large! 5MB maximum",
          },
          captionLabel: "Caption (optional)",
          sendAudio: "Upload audio",
          sendAsRecorded: "Send as recorded audio",
        },
        common: {
          browserNoSupport: "Your browser does not support HTML5",
        },
        flowBuilderVideo: {
          toasts: {
            success: "Video added successfully!",
            fileTooLarge: "File is too large! 20MB maximum",
          },
          sendVideo: "Upload video",
          mp4Only: "ATTENTION! Only MP4 videos!",
        },
        flowBuilder: {
          condition: {
            commaSeparated: "Comma-separated values",
            comparisonValue: "Comparison value",
            typeDollar: "Type $ to see available variables",
            regexHelper: "Ex: ^[0-9]{11}$ — JavaScript regular expression",
            anyTokenHelper: "Any token from the list triggers True",
            fixedOrVariable: "Fixed value or variable with $",
            insertVarSelector: "Insert variable from selector",
            errors: {
              variableRequired: "Condition {{num}}: the \"Variable / Field\" is required",
              valueRequired: "Condition {{num}}: the \"Comparison value\" is required",
              saveError: "An error occurred while saving. Try again.",
            },
            editCondition: "Edit Condition",
            newCondition: "New Condition",
            and: "AND",
            or: "OR",
            addCondition: "Add condition",
            logic: "Logic: True if",
            allConditions: "ALL conditions",
            anyCondition: "ANY condition",
            areSatisfied: "are satisfied",
            quickTips: "Quick tips",
            containsAnyTip: "Contains any (,): separate tokens by comma",
            regexTip: "Regex: use JS expression",
            dynamicVarTip: "Use ${variable} in any field to reference dynamic values",
            selectVariable: "Select variable",
            varsFound: "{{count}} variable(s) found in the flow",
            addVarNodes: "Add Global Variable or Input nodes for dynamic variables",
            searchVar: "Search variable...",
            noVarsFound: "No variables found",
            flowVariables: "Flow variables",
          },
        },
        flowBuilderInteractive: {
          title: "Interactive Message (Baileys)",
          editTitle: "Edit Interactive Message",
          add: "Add",
          save: "Save",
          selectDefault: "Select",
          toasts: {
            messageRequired: "Message body is required!",
            addOption: "Add at least one option!",
            imageError: "Error uploading image",
            fileTooLarge: "File too large! Maximum 2MB",
          },
          preview: "Preview",
          messagePlaceholder: "Message body...",
          messageType: "Interactive message type",
          buttonsMax3: "Buttons (max. 3)",
          infoText: "Interactive buttons via Baileys (nativeFlowMessage). Works on non-official connections. Limit of 3 buttons.",
          tabContent: "MESSAGE CONTENT",
          messageBody: "Message body",
          footer: "Footer (optional)",
          headerImage: "Header image (optional)",
          changeImage: "Change image",
          uploadImage: "Upload image",
          listButtonLabel: "List button text",
          listButtonHelper: "Text shown on the button that opens the list",
          buttons: "Buttons",
          listOptions: "List options",
          addAtLeastOne: "Add at least one option.",
          button: "Button",
        },
        flowBuilderSingleBlock: {
          addTitle: "Add content to flow",
          editTitle: "Edit content",
          addMenuTitle: "Add menu to flow",
          add: "Add",
          save: "Save",
          message: "Message",
          timeInSeconds: "Time in seconds",
          image: "Image",
          audio: "Audio",
          video: "Video",
          document: "Document",
          text: "Text",
          interval: "Interval",
          uploadImage: "Upload image",
          uploadDocument: "Upload Document",
          uploading: "Uploading files and creating content...",
          availableVars: "Available variables",
          toasts: {
            emptyMessage: "Message fields are empty!",
            invalidInterval: "Interval cannot be 0 or greater than 120!",
            fileTooLarge2MB: "File is too large! 2MB maximum",
            fileTooLarge5MB: "File is too large! 5MB maximum",
            fileTooLarge20MB: "File is too large! 20MB maximum",
            fileTooLarge10MB: "File is too large! 10MB maximum",
            success: "Content added successfully!",
            deleteEmpty: "Delete empty cards (Image, Audio and Video)",
          },
          vars: {
            firstName: "First Name",
            name: "Name",
            userName: "Agent",
            greeting: "Greeting",
            protocol: "Protocol",
            date: "Date",
            hour: "Hour",
            ticketId: "Ticket #",
            queue: "Queue",
            connection: "Connection",
            phone: "Phone",
            email: "Email",
            kanban: "Kanban",
          },
        },
    settingsOptions: {
      generalSettings: 'General Settings',
      schedulingBot: 'Scheduling & Bot',
      pushNotifications: 'Push Notifications',
      pushProcessing: 'Processing...',
      pushEnabled: '🔔 Push Enabled',
      pushDisabled: '🔕 Push Disabled',
      pushDescription: 'Enable to receive push notifications in this browser when new messages arrive.',
      pushDeactivated: 'Push notifications deactivated',
      pushActivated: 'Push notifications activated successfully!',
      pushActivateError: 'Could not activate push notifications. Check browser permissions.',
      pushVapidError: 'Push notifications not configured on the server. Configure VAPID keys on the backend.',
      pushChangeError: 'Error changing push notifications',
      systemCurrency: 'Company Currency',
      currency: 'Currency',
      currencyDescription: 'Defines the currency symbol displayed in sale values, reports, finance, and checkout for this company.',
      currencyUpdated: 'Currency updated successfully!',
      currencyPersistError: 'Failed to persist currency',
      currencySaveError: 'Error saving currency',
      currencyUpdateError: 'Error updating currency',
      operationUpdated: 'Operation updated successfully.',
      supportNumber: '📞 Support Number',
      supportNumberPlaceholder: 'E.g.: 5511999998888',
      supportNumberHelper: 'Number with country code (used in Call Support button)',
      supportNumberUpdated: 'Support number updated!',
      pixEfiConfig: 'PIX Efí Configuration (GerenciaNet)',
      pixKey: 'PIX Key',
      tokenAsaas: 'Asaas Token',
      text: 'Text',
      enabled: '✓ ENABLED',
      disabledLabel: '✕ DISABLED',
      copyContactPrefix: 'Prefix for copying contacts',
      aiSection: '🤖 Artificial Intelligence',
      autoAiSummary: 'Auto AI summary on ticket close',
      aiSuggestReply: 'AI Suggest Reply in Chat',
    },
    whitelabelSettings: {
      operationUpdated: 'Operation updated successfully.',
      appName: 'Application Name',
      appNameHelper: 'Name displayed in the browser and emails',
      mobileAppName: 'Mobile Name (PWA)',
      mobileAppNameHelper: 'Name displayed when installing on mobile',
      languages: {
        ptBR: 'Português',
        en: 'English',
        es: 'Español',
      },
    },
    campaignsPhrase: {
      deleted: 'Campaign deleted successfully',
      newCampaign: 'New Campaign',
      active: 'Active',
      inactive: 'Disabled',
      editCampaign: 'Edit campaign',
      deleteCampaign: 'Delete campaign',
      noCampaigns: 'No campaigns found',
      clickNewCampaign: 'Click "New Campaign" to create your first flow campaign',
      name: 'Name',
      connectionsCol: 'Connections',
      statusCol: 'Status',
      nameNotDefined: 'Name not defined',
      phrasesConfigured: 'phrase(s) configured',
    },
    contactsPage: {
      notSynced: 'Contacts not synced yet. Connect your phone and wait.',
      deleteAllContacts: 'Delete all contacts',
      deleteSelectedContacts: 'Delete selected contacts',
      cancelSelection: 'Cancel selection',
      deleteSelected: 'Delete selected',
      status: 'Status',
      userNotFound: 'User not found',
      notAssigned: 'Not assigned',
      openConversation: 'Open conversation',
    },
    financeiroPage: {
      paid: 'Paid',
      overdue: 'Overdue',
      open: 'Open',
      refunded: 'Refunded',
      yes: 'Yes',
      no: 'No',
    },
    adminFinanceiro: {
      title: 'Financial Management',
      totalRevenue: 'Total Revenue',
      openInvoices: 'Open Invoices',
      overdueInvoices: 'Overdue Invoices',
      totalInvoices: 'Total Invoices',
      paidInvoices: 'paid invoices',
      allCompanies: 'All companies',
      statusDistribution: 'Status Distribution',
      revenueByMonth: 'Revenue by Month',
      defaultByMonth: 'Default by Month',
      revenue: 'Revenue',
      defaulting: 'Default',
      search: 'Search invoice...',
      filterStatus: 'Filter Status',
      all: 'All',
      paid: 'Paid',
      open: 'Open',
      overdue: 'Overdue',
      company: 'Company',
      detail: 'Details',
      users: 'Users',
      connections: 'Connections',
      value: 'Value',
      dueDate: 'Due Date',
      daysLeft: 'Days',
      status: 'Status',
      daysRemaining: 'days remaining',
      daysOverdue: 'days overdue',
      action: 'Action',
      refund: 'Refund',
      refunded: 'Refunded',
      refundTitle: 'Refund invoice',
      refundMessage: 'Are you sure you want to refund this invoice?',
      refundSuccess: 'Invoice refunded successfully.',
    },
    companyFinanceiro: {
      title: 'My Plan & Financial',
      myPlan: 'My Plan',
      company: 'Company',
      users: 'Users',
      connections: 'Connections',
      queues: 'Queues',
      value: 'Value',
      daysLeft: 'days remaining',
      daysOverdue: 'days overdue',
      expiresOn: 'Expires on',
      expiredTitle: 'Subscription Expired!',
      expiredMessage: 'Your subscription has expired. Please renew to continue using the system.',
      availablePlans: 'Available Plans',
      currentPlan: 'Current Plan',
      changePlan: 'Change Plan',
      earlyPayment: 'Early Payment',
      month: 'month',
      invoiceHistory: 'Invoice History',
      detail: 'Details',
      dueDate: 'Due Date',
      status: 'Status',
      action: 'Action',
      pay: 'Pay',
      refund: 'Refund',
      refundTitle: 'Refund invoice',
      refundMessage: 'Are you sure you want to refund this invoice?',
      refundSuccess: 'Invoice refunded successfully.',
      features: {
        campaigns: 'Campaigns',
        schedules: 'Schedules',
        internalChat: 'Internal Chat',
        integrations: 'Integrations',
        flows: 'Flows',
        contacts: 'Contacts',
        realTime: 'Real Time',
      },
    },
    checkout: {
      almostDone: 'Almost done!',
      steps: { data: 'Data', customize: 'Customize', review: 'Review' },
      back: 'BACK',
      pay: 'PAY',
      next: 'NEXT',
      select: 'SELECT',
      users: 'Users',
      connection: 'Connection',
      queues: 'Queues',
      perMonth: '/month',
      subscriptionSuccess: 'Subscription completed successfully! Awaiting payment.',
      total: 'TOTAL',
      copied: 'Copied',
      copyQrPix: 'Copy QR PIX code',
      pixInstructions: 'To complete, simply make the payment by scanning or pasting the Pix code above, or choose Pay with Credit Card below.',
      payWithCard: 'Pay with Credit Card',
      payWithMercadoPago: 'Pay with MercadoPago',
      payWithAsaas: 'Pay with Asaas',
      licenseRenewed: 'Your license has been renewed until',
      subscriptionSummary: 'Subscription Summary',
      planDetails: 'Plan Details',
      billing: 'Billing',
      monthly: 'Monthly',
      paymentInfo: 'Payment Information',
      email: 'Email',
      name: 'Name',
      cpfCnpj: 'Tax ID',
      fullName: 'Full name*',
      fullNameRequired: 'Full name is required',
      address: 'Address*',
      addressRequired: 'Address is required',
      city: 'City*',
      cityRequired: 'City is required',
      state: 'State*',
      stateRequired: 'State is required',
      cpfCnpjLabel: 'Tax ID*',
      cpfCnpjRequired: 'Tax ID is required',
      country: 'Country*',
      countryRequired: 'Country is required',
    },
    chatPage: {
      loadUsersError: 'Error loading users',
      chatExists: 'Chat with this user already exists!',
      chatCreated: 'Chat created successfully!',
      chatCreateError: 'Error creating chat',
      group: 'Group',
      user: 'User',
      internalChat: 'Internal chat # ',
      chat: 'Chat',
      noMessages: 'No messages',
      editGroup: 'Edit Group',
      createGroup: 'Create Group',
      changeGroupPhoto: 'Change Group Photo',
      addGroupPhoto: 'Add Group Photo',
      titleLabel: 'Title',
      titlePlaceholder: 'Title',
      descriptionLabel: 'Description',
      descriptionPlaceholder: 'Group description',
      editTimeLimit: 'Can only edit messages sent less than 10 minutes ago.',
      messageDeleted: 'This message was deleted',
      chatEditError: 'Error creating/editing chat',
    },
    flowBuilderPage: {
      activeStatus: 'Active',
      inactiveStatus: 'Inactive',
      flowDeleted: 'Flow deleted successfully',
      flowDuplicated: 'Flow duplicated successfully',
      searchFlows: 'Search flows...',
      createFlow: 'Create flow',
    },
    flowBuilderConfigPage: {
      basics: 'Basics',
      start: 'Start',
      startDesc: 'Flow starting point',
      content: 'Content',
      contentDesc: 'Send text, image, audio or video',
      textNode: 'Text',
      textDesc: 'Simple text message',
      interaction: 'Interaction',
      menu: 'Menu',
      menuDesc: 'Numeric option menu',
      interactiveApi: 'Interactive Msg API',
      interactiveApiDesc: 'Buttons and lists (Baileys)',
      input: 'Input',
      inputDesc: 'Collect user input',
      interval: 'Interval',
      intervalDesc: 'Pause execution for a time',
      logic: 'Logic',
      randomizer: 'Randomizer',
      randomizerDesc: 'Random path selection',
      ifElse: 'If/Else',
      ifElseDesc: 'Branch flow based on condition',
      system: 'System',
      queues: 'Queues',
      queuesDesc: 'Manage service queues',
      tags: 'Tags',
      tagsDesc: 'Add tags to contact',
      removeTag: 'Remove Tag',
      removeTagDesc: 'Remove tags from contact',
      switchFlow: 'Switch Flow',
      switchFlowDesc: 'Redirect to another flow',
      attendant: 'Agent',
      attendantDesc: 'Transfer to agent',
      variable: 'Variable',
      variableDesc: 'Set global variables',
      aiAgent: 'AI Agent',
      aiAgentDesc: 'Use configured AI agent',
      httpRequest: 'HTTP Request',
      httpRequestDesc: 'External HTTP request',
      flowEditor: 'Flow Editor',
    },
    templateMetaModal: {
      title: 'WhatsApp Templates',
      searchPlaceholder: 'Search Templates',
      templateContent: 'Template Content:',
      category: 'Category:',
      language: 'Language:',
      selectedDetails: 'Selected Template Details',
      name: 'Name:',
      content: 'Content:',
      fillValue: 'Fill in the value for',
      requiredField: 'Required field',
      sendTemplate: 'Send Template',
      back: 'Back',
    },
    messagesAPIPage: {
      sendTextMedia: 'Send Text / Media',
      yourMessageHere: 'Your message here',
      sendImageUrl: 'Send Image by URL',
      imageCaption: 'Image caption',
      sendNoTicket: 'Quick Send (No Ticket)',
      messageNoTicket: 'Message without ticket',
      batchSend: 'Batch Send',
      interactiveMessages: 'Interactive Messages',
      chooseOption: 'Choose an option:',
      optionalFooter: 'Optional footer',
      sales: 'Sales',
      support: 'Support',
      financial: 'Financial',
      sidebar: {
        playground: 'PLAYGROUND',
        history: 'HISTORY',
        intro: 'INTRODUCTION',
        messages: 'MESSAGES API',
        contacts: 'CONTACTS',
        tickets: 'TICKETS / CONVERSATIONS',
        testEndpoint: 'Test Endpoint',
        searchEndpoint: 'Search endpoint...',
        requestCount: 'request(s)',
        clearHistory: 'Clear history',
        noRequests: 'No requests yet',
        remove: 'Remove',
        supportsGroups: 'Supports groups',
        docSubtitle: 'Full documentation — {{count}} endpoints',
      },
      introItems: {
        auth: 'Authentication',
        rateLimit: 'Rate Limiting',
        errorCodes: 'Error Codes',
      },
      endpoints: {
        checkNumber: 'Check Number',
        listConnections: 'List Connections',
        listContacts: 'List Contacts',
        showContact: 'Find Contact',
        createContact: 'Create Contact',
        updateContact: 'Update Contact',
        deleteContact: 'Delete Contact',
        listTickets: 'List Tickets',
        showTicket: 'Find Ticket',
        createTicket: 'Create Ticket',
        updateTicket: 'Update Ticket',
        deleteTicket: 'Delete Ticket',
        closeAllTickets: 'Close All Tickets',
        messagesRange: 'Messages by Period',
      },
      playground: {
        title: 'API Playground',
        desc: 'Test your API endpoints directly here. Enter the server base URL and your authentication token.',
        apiUrl: 'API URL',
        token: 'Token',
        copyCurl: 'Copy cURL',
        selectEndpoint: 'Select predefined endpoint',
        group: 'Group',
        send: 'Send',
        uploadMedia: 'Upload Media',
        formatJson: 'Format JSON',
        mediaHint: 'Image, video, audio, or document. Also works for groups!',
        error: 'Error',
        response: 'Response',
        yourToken: '<your_token>',
      },
      badges: {
        new: 'NEW',
        required: 'required',
        optional: 'optional',
      },
      docs: {
        authTitle: 'Authentication',
        authDesc: 'All endpoints require Bearer token authentication. The token must be registered in the WhatsApp connection via <b>Connections → Edit → Token</b>.',
        rateLimitTitle: 'Rate Limiting',
        rateLimitDesc: 'To avoid WhatsApp blocks, a minimum interval of <b>2 seconds</b> between sends is recommended. For batch sending, use the <code>delay</code> parameter to control the interval.',
        errorCodesTitle: 'Error Codes',
        messagesSection: 'Messages API',
        contactsSection: 'Contacts',
        ticketsSection: 'Tickets / Conversations',
        parameter: 'Parameter',
        type: 'Type',
        description: 'Description',
        code: 'Code',
        meaning: 'Meaning',
        success: 'Success',
        invalidParams: 'Invalid or missing parameters',
        invalidToken: 'Invalid or missing token',
        notFound: 'Resource not found',
        serverError: 'Internal server error',
        sendTextTitle: 'Send Text / Media',
        sendTextDesc: 'Sends a text or media message (image, video, audio, document) to individual contacts or <b>groups</b>. To send to a group, set <code>"isGroup": true</code> and the group JID in the <code>number</code> field.',
        paramNumber: 'Contact number or group JID',
        paramBody: 'Message text or media caption',
        paramIsGroup: 'If <code>true</code>, sends to group using <code>@g.us</code>',
        paramMedias: 'Media file (multipart/form-data)',
        paramUserId: 'Agent ID to assign',
        paramQueueId: 'Queue ID to route to',
        paramSendSignature: 'Include agent name in message',
        paramCloseTicket: 'Close ticket after sending',
        paramNoRegister: 'Send without creating a ticket',
        sendImageTitle: 'Send Image by URL',
        sendImageDesc: 'Sends an image from a public URL to a contact or <b>group</b>.',
        paramUrl: 'Public image URL',
        paramCaption: 'Caption',
        paramIsGroupSend: 'If <code>true</code>, sends to group',
        sendNoTicketTitle: 'Quick Send (No Ticket)',
        sendNoTicketDesc: 'Sends a text message without creating a ticket. Works for contacts and <b>groups</b>.',
        bulkTitle: 'Batch Send (Bulk)',
        bulkDesc: 'Sends up to 100 messages per batch. Each message can have <code>isGroup: true</code> individually.',
        buttonsTitle: 'Interactive Messages',
        buttonsDesc: 'Sends interactive messages with buttons, lists, URLs, and PIX. Works for contacts and <b>groups</b>.',
        checkNumberTitle: 'Check Number',
        checkNumberDesc: 'Checks if a number has an active WhatsApp account.',
        listContactsTitle: 'List Contacts',
        listContactsDesc: 'Returns all company contacts. Supports pagination and search.',
        paramSearchParam: 'Search by name, number, or email',
        paramPageNumber: 'Page number (default: 1)',
        showContactTitle: 'Find Contact by ID',
        showContactDesc: 'Returns the data of a specific contact by ID.',
        createContactTitle: 'Create Contact',
        createContactDesc: 'Creates a new contact in the database.',
        paramName: 'Contact name',
        paramNumberWhatsApp: 'WhatsApp number with country+area code',
        paramEmail: 'Contact email',
        paramExtraInfo: 'Custom fields',
        updateContactTitle: 'Update Contact',
        updateContactDesc: 'Updates an existing contact\'s data.',
        deleteContactTitle: 'Delete Contact',
        deleteContactDesc: 'Permanently removes a contact. <b>Warning:</b> This action cannot be undone.',
        listTicketsTitle: 'List Tickets',
        listTicketsDesc: 'Returns tickets filtered by status, queue, and agent. Supports pagination.',
        paramStatus: '<code>open</code>, <code>pending</code>, <code>closed</code>',
        paramQueueIds: 'Queue IDs separated by comma',
        paramSearchTicket: 'Search by message, contact, or ticket',
        paramShowAll: '<code>"true"</code> to list all tickets',
        showTicketTitle: 'Find Ticket by ID',
        showTicketDesc: 'Returns the full details of a ticket, including contact, queue, agent, and messages.',
        createTicketTitle: 'Create Ticket',
        createTicketDesc: 'Creates a new ticket linked to a contact. Useful for starting conversations programmatically.',
        paramContactId: 'Linked contact ID',
        paramStatusDefault: '<code>open</code>, <code>pending</code> (default: open)',
        paramQueueIdTicket: 'Queue ID',
        paramUserIdTicket: 'Responsible agent ID',
        updateTicketTitle: 'Update Ticket',
        updateTicketDesc: 'Updates a ticket\'s status, queue, or agent. Useful for transferring or closing tickets via API.',
        paramNewQueueId: 'New queue ID',
        paramNewUserId: 'New agent ID',
        deleteTicketTitle: 'Delete Ticket',
        deleteTicketDesc: 'Permanently removes a ticket and its messages. <b>Warning:</b> This action is irreversible.',
        closeAllTitle: 'Close All Tickets',
        closeAllDesc: 'Closes all open tickets at once. Ideal for batch cleanup.',
        messagesRangeTitle: 'Messages by Period',
        messagesRangeDesc: 'Returns messages within a date range.',
        paramCompanyId: 'Company ID',
        paramStartDate: 'Start date (YYYY-MM-DD)',
        paramEndDate: 'End date (YYYY-MM-DD)',
        paramNumberOrJid: 'Number or group JID',
      },
    },
    templateManagerPage: {
      title: 'Template Management',
      connection: 'Connection',
      search: 'Search...',
      syncTooltip: 'Sync with Meta',
      sync: 'Sync',
      createTemplate: 'Create Template',
      submitApproval: 'Submit for Approval',
      noOfficialConnection: 'No Official API connection found. Add an official connection to manage templates.',
      noTemplatesFound: 'No templates found. Click "Sync" to synchronize or "Create Template" to create a new one.',
      tableName: 'Name',
      tableCategory: 'Category',
      tableLanguage: 'Language',
      tableStatus: 'Status',
      tableActions: 'Actions',
      viewDetails: 'View details',
      editTemplate: 'Edit (recreate template)',
      deleteTemplate: 'Delete template',
      marketing: 'Marketing',
      utility: 'Utility',
      authentication: 'Authentication',
    },
    userPerformance: {
      title: 'Agent Performance',
      subtitle: 'Detailed analysis of individual agent performance',
      fetchError: 'Error loading performance data',
      loading: 'Loading...',
      noData: 'No data found for the selected period',
      summary: {
        totalTickets: 'Total Tickets',
        activeUsers: 'Active Agents',
        avgSupportTime: 'Avg Support Time',
        avgWaitTime: 'Avg Wait Time',
        avgRating: 'Avg Rating',
      },
      charts: {
        ticketsByUser: 'Tickets by Agent',
        statusDistribution: 'Status Distribution',
      },
      table: {
        title: 'Detail by Agent',
        user: 'Agent',
        totalTickets: 'Total',
        open: 'Open',
        pending: 'Pending',
        closed: 'Closed',
        avgTime: 'Avg Time',
        avgWait: 'Avg Wait',
        minTime: 'Min Time',
        maxTime: 'Max Time',
        rating: 'Rating',
        distribution: 'Distribution',
      },
    },
    messagePreview: {
      title: "Preview",
      subtitle: "See how your message will be displayed",
      contact: "Contact",
      online: "online",
      emptyState: "No messages to preview",
      typePlaceholder: "Type a message...",
      availableVars: "Available variables:",
      greetingExample: "Good morning",
      attachedMedia: "Attached media",
    },
    reportsExtra: {
      statusDistribution: "Status Distribution",
      ticketsByQueue: "Tickets by Queue",
      ticketsByUser: "Tickets by User",
      noQueue: "No queue",
      noUser: "No user",
      noDataForChart: "No data to display",
    },
    flowDefaultPage: {
      title: "Default Flow",
      welcomeFlow: "Welcome Flow",
      welcomeFlowDesc: "This flow is triggered only for new contacts, people who are not in your contact list and who sent a message",
      defaultResponseFlow: "Default Response Flow",
      defaultResponseFlowDesc: "The Default Response is sent with any character different from a keyword. WARNING! It will trigger if the ticket is already closed.",
      defaultResponseFlowDescLong: "The Default Response is sent with any character different from a keyword. WARNING! It will trigger if the ticket is already closed and 6 hours have passed since closing.",
      disabled: "Disabled",
      chooseFlow: "Choose a flow",
      disconnect: "Disconnect",
      save: "Save",
      deleteConfirm: "Are you sure you want to delete this flow? All related integrations will be lost.",
    },
    flowBuilderPageExtra: {
      title: "Conversation Flows",
      newFlow: "New Flow",
      importZip: "Import (.zip)",
      noFlowFound: "No flow found",
      noFlowCreated: "No flow created yet",
      tryOtherSearch: "Try using other search terms",
      createFirstFlowDesc: "Create your first conversation flow to automate support",
      createFirstFlow: "Create First Flow",
    },
    floupPage: {
      title: "Follow UP - Flow Templates",
      filterActive: "Active",
      filterError: "With errors",
      filterPaused: "Paused",
      filterAll: "All",
      newTemplate: "New Template",
      editTemplate: "Edit Template",
      basicInfo: "Basic Information",
      templateName: "Template Name",
      templateType: "Template Type",
      description: "Description",
      triggerCondition: "Trigger Condition",
      triggerConditionDesc: "Define when this Follow UP should be triggered. Once triggered, all steps will run sequentially until the stop conditions are met.",
      condition: "Condition",
      systemQueue: "System queue",
      systemTag: "System tag",
      firstClientInteraction: "First client interaction",
      firstAttendantInteraction: "First agent interaction",
      queue: "Queue",
      selectQueue: "Select queue",
      tag: "Tag",
      selectTag: "Select tag",
      conditionDescription: "Condition description",
      conditionPlaceholder: "E.g.: The client sent the first message",
      flowStopControls: "Flow Stop Controls",
      stopAnyMessage: "1. If the Contact replies any message",
      stopKeyword: "2. If the Contact replies a Keyword",
      keyword: "Keyword",
      keywordPlaceholder: "E.g.: STOP, CANCEL, EXIT",
      stopTicketClosed: "3. If the Ticket is Closed",
      flowSteps: "Flow Steps",
      addStep: "Add Step",
      cancel: "Cancel",
      saveTemplate: "Save Template",
      confirmDeleteTitle: "Confirm Deletion",
      confirmDeleteMessage: "Are you sure you want to delete the Follow UP",
      confirmDeleteWarning: "This action cannot be undone and all associated media will be permanently deleted.",
      delete: "Delete",
      duplicate: "Duplicate",
      edit: "Edit",
      steps: "steps",
      active: "Active",
      inactive: "Inactive",
      customized: "Customized",
      client: "Client",
      lead: "Lead",
      basicInfoDesc: "Set the name and type of your Follow Up. The type defines the initial message template.",
      stepsDesc: "Configure the Follow Up flow steps. Use arrows to reorder.",
      stopControlsDesc: "Set when the Follow Up should stop automatically.",
      subtitle: "Manage your Follow Up templates",
      noFlowsYet: "No Follow UP created yet",
      step: "Step",
      emptyMessage: "Empty message",
      message: "Message",
      variablesHint: "Variables: {" + "{name}}, {" + "{protocol}}, {" + "{queue}}",
      interval: "Interval",
      unit: "Unit",
      minutesLabel: "Minutes",
      hoursLabel: "Hours",
      daysLabel: "Days",
      weeksLabel: "Weeks",
      monthsLabel: "Months",
      attachment: "Attachment/Media",
      pasteUrl: "Paste the URL...",
      choose: "Choose",
      uploadError: "Upload error.",
      removeStep: "Remove Step",
      conversationPreview: "Conversation Preview",
      addStepsForPreview: "Add steps to see the preview",
      afterLabel: "After",
      fileLabel: "File",
      previous: "Previous",
      next: "Next",
      queueLabel: "Queue",
      tagLabel: "Tag",
      interactionLabel: "Interaction",
      stepsCount: "steps",
    },
    templateManagerPageExtra: {
      createNewTemplate: "Create New Template",
      templateNameLabel: "Template Name",
    },
    templateManagerForm: {
      rejected: "was REJECTED by Meta",
      syncComplete: "Sync complete",
      statusChanged: "with status changes",
      syncNoChanges: "Templates synced - no status changes",
      tokenExpired: "⚠️ Official API token expired or invalid! Update the Meta access token in the connection settings.",
      nameBodyRequired: "Name and message body are required",
      nameValidation: "Template name must contain only lowercase letters, numbers and underscores (_)",
      sentForApproval: "Template sent for Meta approval!",
      deleteSuccess: "Template deleted successfully!",
      confirmDeleteMessage: "This action will delete the template on Meta and locally. Do you want to continue?",
      templateDetails: "Template Details",
      name: "Name",
      language: "Language",
      status: "Status",
      category: "Category",
      components: "Components",
      close: "Close",
      nameHelper: "Only lowercase letters, numbers and _",
      headerOptional: "Header (optional)",
      headerHelper: "Text displayed at the top of the template",
      messageBody: "Message Body",
      messageBodyHelper: "Use {{1}}, {{2}}, etc. for variables. E.g.: Hello {{1}}, your order {{2}} is ready!",
      footerOptional: "Footer (optional)",
      footerHelper: "Small text at the end of the template",
      buttonsOptional: "Buttons (optional - max 3)",
      quickReply: "Quick Reply",
      phone: "Phone",
      text: "Text",
      preview: "Preview",
      button: "Button",
      cancel: "Cancel",
    },
    whatsappModalRel: {
      form: {
        resolveAndTriggerIntegration: "Resolve and Trigger Integration",
        reportFilename: "Ticket_Report_",
        elementNotFoundForExport: "Element not found for export",
      },
    },
    announcementsPopover: {
      title: "Announcements",
      dontShowAgain: "Don't show again",
      dismiss: "Dismiss",
      dismissAll: "Dismiss all",
      close: "Close",
      backToList: "Back to list",
      dismissedToast: "This announcement will no longer be shown. It will reappear only when there are updates.",
      priority: {
        high: "High",
        medium: "Medium",
        low: "Low",
      },
      priorityLabel: "Priority",
    },
    ticketsManagerExtra: {
      viewAll: "All",
      ascending: "Ascending",
      descending: "Descending",
      searchOnMessages: "Check to also search within message content (slower)",
    },
    announcementsPage: {
      noPermission: "This company does not have permission to access this page! Redirecting you.",
      priorityHigh: "High",
      priorityMedium: "Medium",
      priorityLow: "Low",
    },
    pairingCodeModalExtra: {
      phoneRequired: "Enter the phone number.",
      phoneTooShort: "Number too short. Include country code + area code.",
      phoneTooLong: "Number too long.",
      phoneBrazil: "For Brazilian numbers, use 55 + area code + number.",
      connectedSuccess: "✅ WhatsApp connected successfully!",
      pairingFailed: "⚠️ Pairing failed. Try again.",
      instructionText: "Enter the WhatsApp number with",
      instructionHighlight: "country code + area code",
      exampleNumber: "5511999998888",
      digitsHelper: "digits — country code + area code + number",
      whatsappInstructions: "On your WhatsApp, go to:",
      whatsappSteps: "Settings → Linked Devices → Link a Device",
      tapLink: "Tap on",
      linkWithPhone: "Link with phone number",
      enterCodeExact: "and enter the code exactly as shown (no spaces):",
      stepCodeGenerated: "Code generated",
      stepWaitingPairing: "Waiting for pairing",
      stepSyncing: "Syncing",
      stepConnected: "Connected",
    },
    newTicketOficialModal: {
      title: "New Conversation - Official API",
      selectQueue: "Select a queue",
      selectOfficialConnection: "Select an Official Connection",
      selectQueuePlaceholder: "Select a queue",
      selectConnectionPlaceholder: "Select an Official Connection",
      officialApiLabel: "Official API",
      createAndSendTemplate: "Create and Send Template",
      templateSentSuccess: "Template sent successfully!",
      selectQueueError: "Select a queue",
      selectConnectionError: "Select an official connection",
    },
    interactiveMessageModalExtra: {
      sendInteractiveMessage: "Send Interactive Message",
      modelsCount: "Models ({{count}})",
      saveCurrentConfig: "Save the current configuration as a reusable template for the type",
      saveButton: "Save",
      templateLoaded: "Template \"{{name}}\" loaded",
      buttonsInfo: "ℹ️ Send up to 3 clickable buttons. The client can tap a button to respond quickly.",
      messageText: "Message text *",
      footer: "Footer (optional)",
      buttonsMax: "Buttons (max. 3)",
      add: "Add",
      optionPlaceholder: "Option {{n}}",
      listInfo: "ℹ️ Send a list with up to 10 options. The client opens a menu to select.",
      buttonText: "Button text",
      sectionTitle: "Section title",
      titleLabel: "Title",
      descriptionLabel: "Description",
      addOption: "Add option",
      offerInfo: "🏷️ Send an offer with title, price, and description.",
      offerTitle: "Offer title",
      offerBody: "Description / Message body *",
      offerPrice: "Price (e.g. $99.90)",
      offerDetails: "Additional details",
      pixInfo: "💰 Send formatted PIX data to the client.",
      pixKey: "PIX Key *",
      pixKeyPlaceholder: "CPF, CNPJ, email, phone, or random key",
      pixBeneficiary: "Beneficiary name",
      pixCity: "City",
      pixAmount: "Amount ($)",
      urlInfo: "🔗 Send a clickable link with custom text.",
      linkText: "Link text",
      linkPlaceholder: "Click here",
      urlLabel: "URL *",
      callInfo: "📞 Send a message with a phone number for calling.",
      callButtonText: "Button text",
      callPlaceholder: "Call now",
      callPhoneLabel: "Phone number *",
      locationInfo: "📍 Send a location to the client.",
      locationMessageText: "Message text",
      locationName: "Location name",
      locationAddress: "Address",
      latitudeLabel: "Latitude *",
      longitudeLabel: "Longitude *",
      carouselInfo: "🎠 Send multiple cards as a carousel.",
      cardLabel: "Card {{n}}",
      cardTitle: "Title",
      cardDescription: "Description",
      addCard: "Add card",
      catalogInfo: "🛍️ Send products from the catalog as cards.",
      productLabel: "Product {{n}}",
      productName: "Product name",
      productDescription: "Description / Price",
      addProduct: "Add product",
      pollInfo: "📊 Create a poll for the client to vote.",
      pollOfficialNote: "(Will be sent as formatted text on the Official API)",
      pollQuestion: "Poll question *",
      pollOptionsLabel: "Options (min. 2, max. 12)",
      billingInfo: "🧾 Send a billing with payment details and \"Review and pay\" button.",
      billingNumber: "Billing number",
      billingDescription: "Billing description *",
      billingQuantity: "Quantity",
      billingTotalAmount: "Total amount ($) *",
      billingCustomMessage: "Custom message",
      billingAttachPdf: "📄 Attach PDF / Invoice (optional)",
      billingSelectPdf: "Select PDF",
      billingPaymentButton: "Payment button",
      billingButtonText: "Button text",
      billingPaymentUrl: "Payment URL (optional)",
      billingPaymentUrlHelper: "If filled, the button will be a clickable link (CTA URL)",
      billingNumberPreview: "BILLING NUMBER",
      billingQuantityPreview: "Quantity",
      billingTotal: "Total",
      billingDefaultBody: "Message body...",
      billingDefaultDescription: "Billing description...",
      billingDefaultButton: "Review and pay",
    },
    whatsAppModalExtra: {
      saturday: "Saturday",
      sunday: "Sunday",
      saveSchedulesHint: "Click save to register the changes",
    },
    tagsKanbanContainer: {
      label: "Kanban Stage",
      selectStep: "Select a stage",
      selectKanbanStep: "Select a Kanban Stage",
      none: "None",
      loadingSteps: "Loading stages...",
    },
    pendingTicketOverlay: {
      blockedTitle: "Conversation Blocked",
      blockedSubtitle: "This ticket is awaiting acceptance. Accept the conversation to view and respond to the client's messages.",
      statusWaiting: "Status: Waiting",
      contact: "Contact",
      ticketId: "Ticket #{{id}}",
      accepting: "Accepting...",
      acceptConversation: "Accept Conversation",
      warningText: "🚫 You cannot view messages before accepting the ticket",
    },
    documentModalExtra: {
      viewDocument: "View Document",
      open: "Open",
      download: "Download",
      emailOutlook: "Outlook Email",
      keynotePresentation: "Keynote Presentation",
      numbersSpreadsheet: "Numbers Spreadsheet",
      pagesDocument: "Pages Document",
      executable: "Executable",
      retFile: "RET File",
      document: "Document",
    },
    statusFilterExtra: {
      groups: "Groups",
    },
    callReport: {
      title: "Call Report",
      subtitle: "Complete history of calls made and received",
      exportCsv: "Export CSV",
      totalCalls: "Total Calls",
      answered: "Answered",
      received: "Received",
      errorsRejected: "Errors / Rejected",
      callsByHour: "Calls by Hour",
      callsByDay: "Calls by Day",
      callStatus: "Call Status",
      average: "Average",
      dateStart: "Start Date",
      dateEnd: "End Date",
      provider: "Connection",
      attendant: "Attendant",
      status: "Status",
      all: "All",
      dateTime: "Date/Time",
      phone: "Phone",
      contact: "Contact",
      connection: "Connection",
      duration: "Duration",
      recording: "Recording",
      downloadRecording: "Download recording",
      noRecords: "No records found",
      showing: "Showing",
      of: "of",
      completed: "Completed",
      rejected: "Rejected",
      notAnswered: "Not Answered",
      pending: "Pending",
      system: "System",
      sun: "Sun",
      mon: "Mon",
      tue: "Tue",
      wed: "Wed",
      thu: "Thu",
      fri: "Fri",
      sat: "Sat",
    },
    n8nNodes: {
      webhook: "n8n Webhook",
      wait: "n8n Wait",
      query: "n8n Query",
      sendMessage: "n8n Message",
      configureUrl: "Configure Webhook URL",
      configureQuery: "Configure Query",
      configureWebhook: "Configure Webhook",
      waitingReturn: "Waiting n8n return",
      receiveAndSend: "Receive and send message",
      sendsTicketData: "Sends ticket data",
      sendsContactData: "Sends contact data",
      queryN8n: "n8n Query",
      resultIn: "Result in",
      sendsResponseToClient: "Sends response to client",
      waitsN8nResponse: "Waits n8n response",
      field: "Field",
      variable: "Var",
      saveIn: "Save in",
      error: "error",
    },
    n8nModal: {
      editWebhook: "Edit n8n Webhook",
      editWait: "Edit n8n Wait for Return",
      editQuery: "Edit n8n Query",
      editSendMessage: "Edit n8n Send Message",
      addWebhook: "n8n - Webhook",
      addWait: "n8n - Wait for Return",
      addQuery: "n8n - Query",
      addSendMessage: "n8n - Send Message",
      nodeType: "n8n Node Type",
      webhookOption: "Webhook - Send data",
      waitOption: "Wait for Return - Pause until callback",
      queryOption: "Query - Fetch and return data",
      sendMessageOption: "Send Message - Receive text from n8n and send",
      webhookInfo: "Sends data to an n8n webhook. The flow continues immediately after sending.",
      waitInfo: "Sends data to n8n and PAUSES the flow until receiving a callback via POST /n8n-callback with processed data.",
      queryInfo: "Makes a synchronous query to n8n (e.g., fetch CRM/ERP data) and saves the response in a variable for use in the flow.",
      sendMessageInfo: "Sends ticket/contact data to n8n, waits for the processed text in the response and automatically sends it as a message to the client.",
      webhookUrlLabel: "n8n Webhook URL",
      webhookUrlPlaceholder: "https://your-n8n.com/webhook/...",
      authTokenLabel: "Authentication Token (optional)",
      authTokenPlaceholder: "Token to authenticate with n8n",
      dataToSend: "Data to send",
      ticketData: "Ticket Data (ID, queue, status, etc.)",
      contactData: "Contact Data (name, phone, email)",
      lastMessage: "Last received message",
      customPayload: "Custom payload (optional JSON)",
      waitConfig: "Wait Configuration",
      timeoutMinutes: "Timeout (minutes)",
      timeoutHelper: "Maximum wait time. After that, follows the 'timeout' handle.",
      saveResponseVar: "Variable to save response",
      saveResponseHelper: "The n8n response will be saved in this variable. Use {{n8n_result}} in the next nodes.",
      waitingMessage: "Message while waiting (optional)",
      queryConfig: "Query Configuration",
      queryNameLabel: "Query Name",
      queryPayloadLabel: "Query payload (JSON)",
      queryPayloadHelper: "Use {{variable}} to insert flow variables",
      queryResultVar: "Variable to save result",
      queryResultHelper: "The query result will be saved in this variable",
      sendResultAsMessage: "Send result as message to client",
      messageTemplate: "Message template",
      messageTemplateHelper: "Use {{variable}} to interpolate the result",
      sendConfig: "Send Configuration",
      responseFieldLabel: "Response field with the message",
      responseFieldHelper: "The JSON response field from n8n that contains the text.",
      timeoutSeconds: "Timeout (seconds)",
      timeoutSecondsHelper: "Maximum wait time for n8n response",
      saveResponseVarOptional: "Variable to save response (optional)",
      saveResponseVarHelper: "Saves the returned text in a variable for later use",
      fallbackMessage: "Fallback message (if n8n fails)",
      fallbackHelper: "Sent to the client if n8n does not respond or an error occurs",
      flowWarning: "Ticket and contact data are sent to n8n → n8n processes and returns the text → the text is automatically sent to the client via WhatsApp.",
      webhookRequired: "Webhook URL is required",
      cancel: "Cancel",
      save: "Save",
      add: "Add",
    },
    n8nMonitor: {
      title: "n8n Monitoring",
      total: "Total",
      success: "Success",
      errors: "Errors",
      pending: "Pending",
      avgDuration: "Avg Duration",
      successRate: "Success Rate",
      startDate: "Start Date",
      endDate: "End Date",
      status: "Status",
      nodeType: "Node Type",
      all: "All",
      webhook: "Webhook",
      waitReturn: "Wait for Return",
      query: "Query",
      sendMessage: "Send Message",
      id: "ID",
      dateTime: "Date/Time",
      type: "Type",
      ticket: "Ticket",
      contact: "Contact",
      duration: "Duration",
      details: "Details",
      noLogs: "No logs found",
      executionDetail: "Execution Details",
      nodeTypeLabel: "Node Type",
      webhookUrl: "Webhook URL",
      errorMessage: "Error Message",
      payloadSent: "Payload Sent",
      responseReceived: "Response Received",
      noData: "No data",
      close: "Close",
      loadError: "Error loading n8n logs",
      detailError: "Error loading details",
      of: "of",
    },
    flowBuilderN8N: {
      integrations: "Integrations",
      webhookName: "n8n Webhook",
      webhookDesc: "Send data to n8n webhook",
      waitName: "n8n Wait",
      waitDesc: "Pause until n8n return",
      queryName: "n8n Query",
      queryDesc: "Fetch data via n8n",
      sendMessageName: "n8n Message",
      sendMessageDesc: "Receive text from n8n and send",
    },
    n8nMenuLabel: "n8n Monitor",
    n8nPanel: {
      title: "n8n Automations",
      refresh: "Refresh",
      openInNewTab: "Open in new tab",
      iframeBlocked: "Could not load n8n here",
      iframeBlockedHint: "n8n may be blocking iframe loading. Set N8N_SECURE_COOKIE=false on your n8n server or open in a new tab.",
    },
    hardcoded: {
      flowSavedSuccess: "Flow saved successfully",
      flowSaveError: "Error saving flow",
      flowDeletedSuccess: "Flow deleted successfully",
      flowDefaultsUpdated: "Default flows updated",
      mediaError: "Error processing media",
      noDataFound: "No data found",
      selectFollowUp: "Select a Follow Up",
      chooseTemplate: "Choose template...",
      noPermission: "Your company does not have permission to access this page! Redirecting you.",
      noPermissionShort: "Your company does not have permission to access this page!",
      loadError: "Error loading shipping data",
      generatingExcel: "Generating Excel report, please wait...",
      loadingData: "Loading data... {{count}} records found",
      noDataToExport: "No data found to export",
      excelReportHeader: "Campaign Report",
      excelCampaignLabel: "Campaign: {{name}}",
      excelGeneratedAt: "Generated at: {{date}}",
      excelColId: "ID",
      excelColRecipient: "Recipient",
      excelColMessage: "Message",
      excelColSentAt: "Sent at",
      excelColDeliveredAt: "Delivered at",
      excelColStatus: "Status",
      excelDelivered: "Delivered",
      excelPending: "Pending",
      excelSheetName: "Campaign Report",
      excelSuccess: "Excel report generated successfully! {{count}} records exported.",
      excelError: "Error generating Excel report",
      settingsSaved: "Settings saved",
      campaignDeleted: "Campaign deleted successfully",
      enterToken: "Enter the authentication token",
      requestSuccess: "✅ Request sent successfully",
      requestLoaded: "Request loaded — click Send to repeat",
      historyCleared: "History cleared",
      copied: "Copied!",
      invalidJson: "Invalid JSON",
      chatCreated: "Chat created successfully!",
      chatsGenerated: "Chats generated successfully!",
      confirmBackfill: "Are you sure you want to generate chats for all existing users? This may take a while and create many chats.",
      walletNotFound: "Wallet not found",
      maxButtonsReached: "Maximum of 3 buttons allowed",
      queueAcceptance: {
        kept: "Queue kept",
        inherited: "Queue inherited from connection"
      },
      schedulesUpdated: "Schedules updated successfully.",
      pushDeactivateError: "Error deactivating push notifications",
      metaUpdated: "{{field}} updated!",
      clickSaveToRegister: "Click save to register changes",
      contactsImported: "WhatsApp contacts imported successfully!",
      couldNotLoadRecords: "Could not load the records list",
      selectPeriod: "Please select the period",
      fillAllFields: "Fill all fields with valid numeric values.",
      slaLimitsOrder: "Limits must be in ascending order: Green < Yellow < Red.",
      slaUpdated: "SLA settings updated successfully!",
      slaError: "Error saving SLA settings.",
      cancelRequested: "Cancellation requested. Wait for the current chat to finish...",
      parameterizeFilter: "Set filter parameters",
      intervalValue: "Interval Value",
      sendHowManyTimes: "Send how many times",
      sendNormallyNonBusiness: "Send normally on non-business days",
      sendBusinessDayBefore: "Send one business day before",
      sendBusinessDayAfter: "Send one business day after",
      showUser: "Show User",
      users: "Users",
      createTicket: "Create Ticket",
      filterByTags: "Filter by Tags",
      unknown: "Unknown",
      accessTicket: "Access Ticket",
      downloadFile: "Download file",
      clickToDownload: "📎 Click to download",
      select: "Select",
      options: "Options",
      reviewAndPay: "Review and pay",
      followUpInfo: "Follow UP information",
      followUpPanel: "Follow UP Panel",
      aboutFollowUpTitle: "About the Follow UP System",
      aboutFollowUpDesc: "Follow UP allows you to create message flows and assign them to a contact or ticket for automatic execution.",
      aboutFollowUpSelect: "Select an active template to start. You can stop it at any time.",
      understood: "Got it",
      noAgent: "No agent",
      salesReport: "Sales Report",
      startDate: "Start Date",
      endDate: "End Date",
      agent: "Agent",
      all: "All",
      generating: "Generating...",
      generateReport: "Generate Report",
      totalSales: "Total Sales",
      totalSalesValue: "Total Sales Value",
      nonSales: "Non-Sales",
      avgTicketsPerAgent: "Avg Tickets per Agent",
      nonSaleReasons: "Non-Sale Reasons",
      closedTickets: "Closed Tickets",
      saleValue: "Sale Value",
      nonSaleReason: "Non-Sale Reason",
      closingReason: "Closing Reason",
      closingReasonFilter: "Closing Reason",
      nonSaleReasonFilter: "Non-Sale Reason",
      agentPerformance: "Agent Performance",
      totalTickets: "Total Tickets",
      avgTickets: "Avg Tickets",
      date: "Date",
      allowCrossQueueTicket: "Allow opening ticket in any queue/connection",
      refresh: "Refresh",
      openNewTab: "Open in new tab",
      whatsappConnection: "WhatsApp Connection",
      tagUsed: "Tag Used",
      notSpecified: "Not specified",
      downloadSampleSheet: "Download Sample Sheet",
      saveFlow: "Save Flow",
      intervals: "Intervals",
      connected: "Connected",
      connecting: "Connecting...",
      unknownNumber: "Unknown number",
      incomingCall: "Incoming call",
      readyForCalls: "Ready for calls",
      connectingToServer: "Connecting to server...",
      minimize: "Minimize",
      backspace: "Delete",
      unmute: "Unmute",
      mute: "Mute",
      endCall: "End call",
      answerCall: "Answer",
      rejectCall: "Reject",
      makeCall: "Call",
      typeNumberToCall: "Type a number to call",
      calling: "Calling...",
      inCall: "In call",
      numberTooShort: "Number too short",
      numberTooLong: "Number too long",
      callError: "Error making call",
      recordAudio: "Record Audio",
      recording: "Recording...",
      audioRecorded: "Audio recorded",
      confirmOrDelete: "Click ✓ to confirm or 🗑️ to delete",
      dashboardSubtitle: "Track the progress of your follow-up flows",
      totalContacts: "Total Contacts",
      active: "Active",
      paused: "Paused",
      withErrors: "With Errors",
      steps: "Steps",
      completionRate: "Completion Rate",
      responseRate: "Response Rate",
      contactDistribution: "Contact distribution by step",
      searchContact: "Search contact...",
      allChannels: "All channels",
      allFilter: "All",
      withErrorsFilter: "With Errors",
      pausedFilter: "Paused",
      noContact: "No contacts",
      noStepFound: "No steps found",
      noHistoryFound: "No history found",
      lastSendError: "Error on last send",
      step: "Step",
      resume: "Resume",
      pause: "Pause",
      history: "History",
      timelineFollowUp: "Follow Up Timeline",
      created: "Created",
      sent: "Sent",
      next: "Next",
      inactive: "Inactive",
      awaitingExecution: "Awaiting execution",
      awaitingExecutionShort: "Awaiting",
      deliveryStatus: "Delivery Status",
      delivered: "Delivered",
      waiting: "Waiting",
      failures: "Failures",
      messagesSent: "Messages Sent",
      uniqueRecipients: "Unique Recipients",
      messagesDelivered: "Messages Delivered",
      messageDetails: "Message Details",
      exportExcel: "Export Excel",
      rowsPerPage: "Rows per page:",
      chipDelivered: "Delivered",
      chipPending: "Pending",
      chipFailed: "Failed",
      chipUnknown: "Unknown",
      loading: "Loading...",
      noMessagesFound: "No messages found",
      notScheduled: "Not scheduled",
      notCompleted: "Not completed",
      approved: "Approved",
      pending: "Pending",
      rejected: "Rejected",
      noContactInList: "No contacts in this list yet.",
      importViaExcelOrWhatsapp: "Import via Excel or WhatsApp using the buttons above.",
      loadingTags: "Loading tags...",
      noTagAvailable: "No tags available.",
      selectAllShown: "Select all ({{count}} shown)",
      noContactFound: "No contacts found.",
      trySearchOther: "Try searching by another name or number.",
      clickNewListToStart: "Click \"New List\" to get started.",
      filterByTag: "Filter by tag:",
      clearTags: "Clear ({{count}})",
      addingToList: "Adding to list:",
      addToList: "Add {{count}} to list",
      listCreatedImport: "List \"{{name}}\" created! Now import contacts (optional).",
      dragExcelHere: "Drag the Excel file here or click to select",
      acceptedFormats: "Accepted formats: .xls, .xlsx",
      downloadTemplate: "📥 Download template sheet (.xlsx)",
      skipImport: "Skip import",
      nameListHint: "Give a name to identify this contact list.",
      characters: "characters",
      listNameMinLength: "Name must be at least 2 characters.",
      listCreatedSuccess: "List \"{{name}}\" created successfully!",
      contactsAddedToList: "{{count}} contact(s) added to list \"{{name}}\"!",
      listSelectedForCampaign: "List \"{{name}}\" selected for the campaign!",
      backToCampaign: "Back to Campaign →",
      excelModel: "Excel Template",
      importExcel: "Import Excel",
      loadMore: "Load more",
      contactLists: "Contact Lists",
      contactListsSubtitle: "Create lists, import contacts and select the list to use in this campaign.",
      simpleList: "Simple List",
      newListExcel: "New List + Excel",
      selectedListLabel: "Selected list: {{name}}",
      selectedListDesc: "{{count}} contacts — this list will be used in the campaign",
      remove: "Remove",
      deleteListConfirm: "Delete list \"{{name}}\"?",
      addCaption: "Add a caption (optional)",
      previewNotAvailable: "Preview not available",
      departments: "Departments",
      name: "Name",
      noTagFound: "No tags found. Type to create a new one.",
      selectWhatsappConnection: "Select the WhatsApp connection from which to import contacts:",
      noWhatsappConnectionFound: "No connected WhatsApp connection found.",
      cancel: "Cancel",
      import: "Import",
      imageNotAvailable: "Image not available",
    },
    todoList: {
      title: "To-Do List",
      counter: "{{pending}} pending of {{total}} task(s)",
      newTask: "New task",
      editTask: "Edit task",
      add: "Add",
      save: "Save",
      cancel: "Cancel",
      priority: "Priority",
      category: "Category",
      status: "Status",
      dueDate: "Due date",
      assignTo: "Assign to",
      nobody: "Nobody",
      notes: "Notes",
      notesLabel: "Notes",
      search: "Search...",
      allTabs: "All",
      pendingTabs: "Pending",
      doneTabs: "Completed",
      allPriorities: "All",
      allUsers: "All",
      sortBy: "Sort by",
      sortCreatedAt: "Created date",
      sortPriority: "Priority",
      sortDueDate: "Due date",
      sortManual: "Manual (drag)",
      user: "User",
      priorities: { high: "High", medium: "Medium", low: "Low" },
      statuses: { pending: "Pending", in_progress: "In Progress", done: "Done" },
      categories: { general: "General", work: "Work", personal: "Personal", urgent: "Urgent", study: "Study" },
      emptyNoTasks: "No tasks created yet",
      emptyFiltered: "No tasks found",
      emptyAddFirst: "Add your first task above!",
      emptyAdjustFilters: "Try adjusting the filters",
      dueSoonAlert: "task(s) due soon:",
      overdue: "Overdue!",
      subtasks: "Subtasks",
      newSubtask: "New subtask...",
      createdBy: "Created by",
      assignedTo: "Assigned to",
      deleteTitle: "Confirm deletion",
      deleteMessage: "Are you sure you want to delete this task?",
      deleteConfirm: "Delete",
      toasts: {
        loadError: "Error loading tasks",
        saveError: "Error saving task",
        statusError: "Error updating status",
        deleteError: "Error deleting task",
        subtaskError: "Error updating subtasks",
      },
    },
    accountSwitch: {
      title: "Your Accounts",
      subtitle: "Select an account to switch automatically",
      addAccount: "Add account",
      savePassword: "Save Password",
      saveCurrentPassword: "Save Current Account Password",
      email: "Email",
      password: "Password",
      cancel: "Cancel",
      save: "Save",
      admin: "Admin",
      agent: "Agent",
      saved: "Saved",
      noPassword: "No password",
      active: "ACTIVE",
      passwordHelper: "Password is stored locally for quick account switching",
      saveWarning: "Save your password to enable quick switching",
      toasts: {
        accountAdded: "Account validated and added!",
        invalidCredentials: "Invalid credentials. Check email and password.",
        passwordSaved: "Password saved successfully!",
        cannotRemoveActive: "Cannot remove the active account.",
        accountRemoved: "Account removed.",
        noCredentials: "Credentials not saved. Save the password first.",
        connectedAs: "Connected as {{name}}",
      },
      floupSelector: {
        stopSuccess: "Follow UP stopped for the contact successfully",
        stopError: "Error stopping the Follow UP",
        active: "Active",
      },
    },
  },
};

export { messages };
